let intervalID = null;
var shouldUpdateDrawer = true;
let jscAccountDropdownObserver = null;
let jscAccountDropdownEventsBound = false;

// Defined early so document-ready can always call it
initTextLinkClick = () => {
  var $links = $('.shopify-section--multi-column .jsc_multi_column_item .metafield-rich_text_field a');

  $links.each(function() {
    var $link = $(this);

    // Skip if already wired
    if ($link.attr('data-page-handle')) {
      return;
    }

    var href = $link.attr('href') || '';
    var pageHandle = String(href).replace(/#/g, '').replace(/^\/pages\//, '').split('?')[0].split('/')[0];

    // Only wire hash page links like #cnb-paper
    if (!pageHandle || href.indexOf('#') !== 0) {
      return;
    }

    // Keep same <a>, append open function directly — href not needed after this
    $link
      .attr('data-page-handle', pageHandle)
      .attr('onclick', 'return getPageContent(this);')
      .removeAttr('href')
      .addClass('jsc-pdp-page-drawer-link');
  });
};

$(function () {
  // Run first — earlier inits can throw and block later lines
  try {
    initTextLinkClick();
  } catch (err) {}

  shippingBarUpdate();
  onloadgiftWrap();
  cartJSevent();
  onloadGetProductImgArray();
  initProductGalleryCounter();
  initUpsellSlider();
  initImageWithTextSlider();
  onloadUpdateSliderNav();
  onchangeUpdateSliderNav();
  initTagSlider();
  onloadProductGallerySticky();
  positionJscAccountDropdown();
  bindJscAccountDropdownEvents();
  $(window).on('resize', positionJscAccountDropdown);
  $('.cart_drawer_open').on('click', function() {
    OnloadCheckDeliveryNoteCheckbox();
  });
  if ($('.shopify-section--main-cart').length > 0) {
    OnloadCheckDeliveryNoteCheckbox();
  }

  // Inline URL check only — edit helpers are defined later in this file.
  var cnbEditPending = /[?&]edit_personalisation=1(?:&|$)/.test(String(window.location.search));

  if ($('#setPersonaliserun').length > 0 || $('#isPersonalisation').length > 0 ) {
    // Keep leather personalisation form available when restoring an edit session
    if (!cnbEditPending) {
      removePersonlise(this); 
      onclickPersonalisation();
    }
  }

  // Skip default first-option clicks so async cart restore can prefill.
  if (cnbEditPending) {
    // Early overlay shell (full helper may not exist yet at this point in the file)
    if ($('#cnb-edit-loading-overlay').length === 0) {
      $('body').append(
        '<div id="cnb-edit-loading-overlay" class="cnb-edit-loading-overlay is-visible" aria-live="polite" aria-busy="true">'
        + '<div class="cnb-edit-loading-card">'
        + '<div class="cnb-edit-loading-spinner" aria-hidden="true"></div>'
        + '<p class="cnb-edit-loading-text">Loading your personalisation…</p>'
        + '</div></div>'
      );
    }
  }
  if (!cnbEditPending) {
    $('.twin-wire-swatch-tab').find('.dropdownwrapcnb').each(function(){
      $(this).find('.dropdownlistcnb').first().click();
    });
    $('.paperswatchflickity').find('.paper-swatch').first().click();
    if ($('.add-ons-tab').length > 0) {
      $('.add-ons-tab').find('.dropdownwrapcnb').each(function(){
        $(this).find('.dropdownlistcnb').first().click();
      });
      $('#category-no-addons').next().click();
    }
    if ($('.customiseatag-addon').length > 0) {
      $('.customiseatag-addon').first().click();
    }
  }
  initfoil();
  var popup = localStorage.getItem("popupnewsletter");
  if (popup && popup == 'true') {
    $('.NewsletterPopup').attr('aria-hidden','true');
  }else{
    $('.NewsletterPopup').attr('aria-hidden','false');
  }
  var alcoholpopup = localStorage.getItem("popupalcohol");
  if (alcoholpopup && alcoholpopup == 'true') {
    $('#prompt-background').hide();
  }else{
    $('#prompt-background').show();
  }
  $('.cart-drawer__footer #defaultCheckbox1').change(function(event) {
    shouldUpdateDrawer = false;
    CartJS.setAttribute('Paperbag', this.checked ? 'Yes' : 'No');

    console.log("inside1", shouldUpdateDrawer);
  });

  $('.cart-drawer__footer #defaultCheckbox2').change(function(event) {

    shouldUpdateDrawer = false;
    CartJS.setAttribute('Order Summary', this.checked ? 'Yes' : 'No');
    console.log(this.checked);

    console.log("inside2", shouldUpdateDrawer);
  });
});

onloadProductGallerySticky = () => {
  const syncStickyTop = () => {
    const $sticky = $('.jsc-product-gallery-sticky');
    if (!$sticky.length) return;

    const stickyTop = getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height').trim();
    if (stickyTop) {
      $sticky.css('top', stickyTop);
    }
  };

  syncStickyTop();
  $(window).resize(syncStickyTop);
}

updateProductGalleryCounter = ($gallery, detail) => {
  const $root = $gallery && $gallery.length ? $gallery : $('product-gallery');
  $root.each(function() {
    const $thisGallery = $(this);
    const $counter = $thisGallery.find('.product-gallery__counter');
    if (!$counter.length) return;

    const carousel = $thisGallery.find('.product-gallery__carousel')[0];
    const $visibleMedia = $thisGallery.find('.product-gallery__carousel > .product-gallery__media').filter(function() {
      return $(this).is(':visible') && !this.hasAttribute('hidden');
    });
    const total = $visibleMedia.length;
    if (total <= 1) {
      $counter.addClass('is-hidden');
      return;
    }

    $counter.removeClass('is-hidden');

    let current = 1;
    let hasDetailIndex = false;
    if (detail && detail.cell) {
      const detailIndex = $visibleMedia.index(detail.cell);
      if (detailIndex >= 0) {
        current = detailIndex + 1;
        hasDetailIndex = true;
      }
    }

    if (!hasDetailIndex && carousel && $visibleMedia.length) {
      const carouselRect = carousel.getBoundingClientRect();
      const scrollCenter = carouselRect.left + (carouselRect.width / 2);
      let bestIndex = 0;
      let bestDistance = Infinity;

      $visibleMedia.each(function(index) {
        const mediaRect = this.getBoundingClientRect();
        const mediaCenter = mediaRect.left + (mediaRect.width / 2);
        const distance = Math.abs(mediaCenter - scrollCenter);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      current = bestIndex + 1;
    }

    $counter.find('.product-gallery__counter-current').text(current);
    $counter.find('.product-gallery__counter-total').text(total);
  });
}

initProductGalleryCounter = () => {
  if (window.__jscProductGalleryCounterBound) {
    updateProductGalleryCounter();
    return;
  }
  window.__jscProductGalleryCounterBound = true;

  const onCarouselEvent = (event) => {
    const carousel = event.target;
    if (!carousel || !carousel.classList || !carousel.classList.contains('product-gallery__carousel')) return;
    const gallery = carousel.closest('product-gallery');
    if (!gallery) return;
    updateProductGalleryCounter($(gallery), event.detail);
  };

  document.addEventListener('carousel:change', onCarouselEvent, true);
  document.addEventListener('carousel:settle', onCarouselEvent, true);

  const bindCarouselScroll = (carousel) => {
    if (!carousel || carousel.__jscCounterScrollBound) return;
    carousel.__jscCounterScrollBound = true;

    carousel.addEventListener('scroll', () => {
      const gallery = carousel.closest('product-gallery');
      if (!gallery) return;
      if (gallery.__jscCounterScrollFrame) return;
      gallery.__jscCounterScrollFrame = requestAnimationFrame(() => {
        gallery.__jscCounterScrollFrame = null;
        updateProductGalleryCounter($(gallery));
      });
    }, { passive: true });

    carousel.addEventListener('scrollend', () => {
      const gallery = carousel.closest('product-gallery');
      if (!gallery) return;
      updateProductGalleryCounter($(gallery));
    });
  };

  const bindAllCarousels = () => {
    document.querySelectorAll('product-gallery .product-gallery__carousel').forEach(bindCarouselScroll);
  };

  bindAllCarousels();

  $(document).on('click', '.jsc-gallery-arrow [is="carousel-prev-button"], .jsc-gallery-arrow [is="carousel-next-button"]', function() {
    const $gallery = $(this).closest('product-gallery');
    setTimeout(function() {
      updateProductGalleryCounter($gallery);
    }, 50);
    setTimeout(function() {
      updateProductGalleryCounter($gallery);
    }, 300);
  });

  updateProductGalleryCounter();
  setTimeout(function() {
    bindAllCarousels();
    updateProductGalleryCounter();
  }, 100);
}

positionJscAccountDropdown = () => {
  const header = document.querySelector('x-header.header');
  const trigger = document.querySelector('.jsc-hover-account');
  if (!header || !trigger) return;

  const dropdown = trigger.querySelector('.jsc-account-dropdown');
  if (!dropdown) return;

  const headerRect = header.getBoundingClientRect();
  const triggerRect = trigger.getBoundingClientRect();
  const topOffset = Math.round(headerRect.bottom - triggerRect.top - 2);

  trigger.style.setProperty('--jsc-account-dropdown-top', `${topOffset}px`);

  if (!jscAccountDropdownObserver && window.ResizeObserver) {
    jscAccountDropdownObserver = new ResizeObserver(positionJscAccountDropdown);
    jscAccountDropdownObserver.observe(header);
  }
};

bindJscAccountDropdownEvents = () => {
  const trigger = document.querySelector('.jsc-hover-account');
  if (!trigger || jscAccountDropdownEventsBound) return;

  jscAccountDropdownEventsBound = true;
  trigger.addEventListener('mouseenter', positionJscAccountDropdown);
  window.addEventListener('scroll', positionJscAccountDropdown, { passive: true });
};

scrollToTop = () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}


// Start CartJS Function
cartJSevent = () =>{
  $(document).on('cart.requestComplete', function(event, cart) {
    console.log("inside cartJSEVENT", shouldUpdateDrawer);
    if (shouldUpdateDrawer) { 
      if (location.href.includes('/cart')) {
        fetch(window.Shopify.routes.root + "?sections=" + $('.shopify-section--main-cart').attr('id').replace(/shopify-section-/g, ''))
        .then(res => res.json())
        .then((restext) => {
          $('.shopify-section--main-cart').children().remove();
          $('.shopify-section--main-cart').html(restext[$('.shopify-section--main-cart').attr('id').replace(/shopify-section-/g, '')]);
        });
        location.reload();
      } 

      fetch(window.Shopify.routes.root + "?sections=" + $('.shopify-section--cart-drawer').attr('id').replace(/shopify-section-/g, ''))
      .then(res => res.json())
      .then((restext) => {
        console.log(restext);
        $('.shopify-section--cart-drawer').children().remove();
        $('#cart-drawer').remove();
        $('.shopify-section--cart-drawer').html(restext[$('.shopify-section--cart-drawer').attr('id').replace(/shopify-section-/g, '')]);
        if (location.href.includes('/cart')) {
        }else{
        $('.cart_drawer_open')[0].click();
        }
      });

      fetch(window.Shopify.routes.root + "?sections=" + $('.shopify-section--header').attr('id').replace(/shopify-section-/g, ''))
      .then(res => res.json())
      .then((restext) => {
        $('.shopify-section--header').children().remove();
        $('.shopify-section--header').html(restext[$('.shopify-section--header').attr('id').replace(/shopify-section-/g, '')]);
      });
    }

    shouldUpdateDrawer = true;
  });
}
// End CartJS Function

//Start - Personalise Feature

// leatherAddToCart = (evt) => {
//   var $this = $(evt);
//   var $prod = {};
//   var $prodCost_add = {};
//   var $prodVid = parseInt($('.jsc-mainID-pdp').val());
//   var $prodCost_vid = parseInt($this.attr('data-prodCostVid'));
//   var $prodCost_price = parseInt($this.attr('data-prodCostPrice'));
//   var $prodTitle = $this.attr('data-prodTitle');
//   var $prodCost_title = $this.attr('data-prodCostTitle');
//   var jsonObj = [];

//   var $inputText = $('#leather-text').val();
//   var $fontType = $('#fontType').val();
//   var $fontSize = $('#fontSize').val();
//   var $fontSizeMm = $('#fontSize').find(':selected').text();
//   var $layout = $('.position-layout-label.layout-selected').attr('value');
//   var $foilColor = $('.foil-option.foil-selected').data('val');

//   // Gift Wrap options
//   var $giftWrap = $('.gift-radio:checked');
//   var $handleizeGiftOption = '';
//   // Handleize Gift Wrap and text input
//   if ($giftWrap.length > 0) {
//     $handleizeGiftOption = $giftWrap.val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
//   }
//   var $handleizeInputText = $inputText.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

//   if ($inputText == '') {
//     $('#input-text-error').show();
//   }
//   else if ($fontType == null) {
//     $('#font-type-error').show();
//   }
//   else if ($fontSize == null) {
//     $('#font-size-error').show();
//   }
//   else {
//     $prodCost_add['Personalise'] = $prodTitle;
//     $prodCost_add['Font Type'] = $fontType;
//     $prodCost_add['Font Size'] = $fontSizeMm;
//     $prodCost_add['Foil Colour'] = $foilColor;
//     $prodCost_add['Font Position'] = $layout;
//     //$prodCost_add['Personalisation'] = $inputText;

//     if ($fontType == 'Copperplate' || $fontType == 'Script' || $fontType == 'Univers' ) {
//     $prodCost_add['Personalisation'] = $inputText.toUpperCase();
//     }else {
//     $prodCost_add['Personalisation'] = $inputText;
//     }
//     $prodCost_add['BindID'] = $prodVid+'-'+$prodCost_vid+'-'+$handleizeInputText+'-'+$fontType+'-'+$fontSize+'-'+$layout+'-'+$foilColor+'-'+$handleizeGiftOption;
//     $prodCost_add['Packaging'] = $giftWrap.val();

//     $prod['Main Product'] = $prodCost_title;
//     $prod['Font Type'] = $fontType;
//     $prod['Font Size'] = $fontSizeMm;
//     $prod['Foil Colour'] = $foilColor;
//     $prod['Font Position'] = $layout;
//     //$prod['Personalisation'] = $inputText;

//     if ($fontType == 'Copperplate' || $fontType == 'Script' || $fontType == 'Univers' ) {
//     $prod['Personalisation'] = $inputText.toUpperCase();
//     }else {
//     $prod['Personalisation'] = $inputText;
//     }

//     if ($prodCost_price > 0){
//     $prod['BindID'] = $prodVid+'-'+$prodCost_vid+'-'+$handleizeInputText+'-'+$fontType+'-'+$fontSize+'-'+$layout+'-'+$foilColor+'-'+$handleizeGiftOption;
//     }else{
//       $prod['BindID'] = $prodVid+'-'+$handleizeInputText+'-'+$fontType+'-'+$fontSize+'-'+$layout+'-'+$foilColor+'-'+$handleizeGiftOption;
//     }
//     $prod['Packaging'] = $giftWrap.val();

//     if ($prodCost_price > 0){
//       var item = {};
//       item ["id"] = $prodCost_vid;
//       item ["quantity"] = 1;
//       item ["properties"] = $prodCost_add;
//       jsonObj.push(item);
//       var item = {};
//       item ["id"] = $prodVid;
//       item ["quantity"] = 1;
//       item ["properties"] = $prod;
//       jsonObj.push(item);

//     //cartJSDoubleAddQuery($prodVid, 1,$prod, $prodCost_vid, 1,$prodCost_add);
//       CartJS.addItems(jsonObj,
//         {
//             // Define a success callback to display a success message.
//             "success": function(data, textStatus, jqXHR) {
//                 console.log('success');
                    
//             },
//             // Define an error callback to display an error message.
//             "error": function(jqXHR, textStatus, errorThrown) {
//             console.log("Error occur !", errorThrown);
//             }
//         });
//     }else{
//       var item = {};
//       item ["id"] = $prodVid;
//       item ["quantity"] = 1;
//       item ["properties"] = $prod;
//       jsonObj.push(item);

//       //cartJSAddQuery($prodVid, 1,$prod);
//       CartJS.addItems(jsonObj,
//         {
//             // Define a success callback to display a success message.
//             "success": function(data, textStatus, jqXHR) {
//                 console.log('success');
                    
//             },
//             // Define an error callback to display an error message.
//             "error": function(jqXHR, textStatus, errorThrown) {
//             console.log("Error occur !", errorThrown);
//             }
//         });
//     }
//   }
// }

swapTabimg = (scr) => {
  $('.jsc-set-img').find('img').attr('src',scr);
}

onclickPersonalisation  = () =>{
  if ($('#setPersonalise').length > 0) {
    $('.Alt_Product__Slideshow').hide();
    $('.selectedNav').hide();
    $('.jsc-set-img').show();

    setTimeout(function(){
    var tabID = $('.tab-selected').attr('data-prodID');
    var tabIMG = $('.tab-selected').attr('data-img');
    swapTabimg(tabIMG);
    changeFontTypeSet($('#fontType-' + tabID));
    changeFontSizeSet($('#fontSize-' + tabID));
    $('.foil-option').each(function(){
      var $this = $(this);
      var _foilprodID = $this.attr('data-prodID');
      if ($this.hasClass('foil-selected') && _foilprodID == tabID ) {
        lFoilSet($this);
      }
    });
    $('.position-layout-label').each(function(){
      var $this = $(this);
      var _layoutprodID = $this.attr('data-prodID');
      if ($this.hasClass('layout-selected') && _layoutprodID == tabID) {
        lLayoutSet($this);
      }
    });
    }, 100);
  }
}

removePersonlise = (evt) => {
  // var $this = $(evt);
  $(".motifpersonalizebtn").show();
  $("#isPersonalisation").hide();
  $(".personalisation-text").hide();
  $(".before-price").show();
  $(".personalise-price").hide();
  $(".ProductForm__AddToCart").show();
  $(".jsProductForm").removeClass('isPersonalized');
  $(".Product__Info").removeClass('isPersonalized');

  // move gift box container before Add Personalisation btn
  $(".gift-container").insertBefore(".jsc-pdp-gift-message-wrapper");
  $("#personaliseBtn").removeClass('hideimportant').css('display','inline-block');
  var _priceAddpersonalize = $(".jsc-ori-price").text();
  $("#atome-price").children().text(_priceAddpersonalize);

  //extra function for set personlaise
  if ($('#setPersonalise').length > 0) {
    var oriImg = $('#ori-img').val();
    //swapTabimg(oriImg);
    $('.Alt_Product__Slideshow').show();
    $('.selectedNav').show();
    $('.jsc-set-img').hide();

  }

}

jscClampLeatherTextToMaxlength = (text, inputEl) => {
  if (text == null || text === '') return text;
  var el = inputEl && inputEl.getAttribute ? inputEl : document.getElementById('leather-text');
  if (!el || !el.getAttribute) return text;
  var max = parseInt(el.getAttribute('maxlength'), 10);
  if (isNaN(max) || max < 1) return text;
  return text.length > max ? text.slice(0, max) : text;
};

removePunctuation = (evt) => {
  var $this = $(evt);
  var $textVal = $this.val();
  var $textOverlay = $('#personalisation-text');
  var $fontFamily = $('#fontType').val();
  var $fontSize = $('#fontSize').find(':selected').text();
  
  // Disable special character
  if ($fontFamily == 'Copperplate' && $fontSize == '10mm') {
    var temp = $textVal.replace(/[^-'.&a-zA-Z@#\s]/g, '').replaceAll('*', '').replaceAll('+', '').replaceAll("'", "");
  } else if ($fontFamily == 'Script Sentence' && $fontSize == '6mm'){
    var temp = $textVal.replace(/[^'.&a-zA-Z0-9\s]/g, '').replaceAll('*', '').replaceAll('+', '').replaceAll("'", "").replaceAll('.', '');
  } else {
    var temp = $textVal.replace(/[^'.&a-zA-Z0-9\s]/g, '').replaceAll('*', '').replaceAll('+', '');
  }
  if ($this.attr('id') === 'leather-text') {
    temp = jscClampLeatherTextToMaxlength(temp, $this[0]);
  }
  $this.val(temp);
  $textOverlay.text(temp);
}

tooltipClick = (evt) => {
  var $this = $(evt);
  var $tooltipPop =  $(".tooltipFont");
  $tooltipPop.toggle();
}

lLayout = (evt) => {
  var $this = $(evt);
  var _ltop = $this.attr('data-ltop');
  var _lleft = $this.attr('data-lleft');
  var _isShow = $this.attr('value');
  var _fontType = $('#fontType').val(); console.log(_fontType,'hy');
  var _topTransform = $this.attr('data-topTransform');
  var _leftTransform = $this.attr('data-leftTransform');

  $(".personalisation-text-overlay").attr('style', 'transform: translate('+_leftTransform+','+_topTransform+')');
  $(".personalisation-text-overlay").css( "top", _ltop);
  $(".personalisation-text-overlay").css( "left", _lleft);
  $('.position-layout-label').removeClass('layout-selected');
  $this.addClass('layout-selected');

  $(".showLayout").html(_isShow);
}

lFoil = (evt) => {
  var $this = $(evt);
  var _lfoil = $this.data('foil');
  var _isShow = $this.data('val');
  var $textPersonalise = $('.personalisation-text');
  var $texture_url = $this.attr('data-texture');
  var $backgroundTexture = "-webkit-linear-gradient(top, transparent, transparent), url('"+ $texture_url +"') center center no-repeat";

  $textPersonalise.css( "color", _lfoil);
  $('.foil-list').children('.foil-option').removeClass('foil-selected');
  $this.addClass('foil-selected');
  $(".showFoil").html(_isShow);
  $textPersonalise.css('text-shadow', ' ');
  $textPersonalise.css('opacity', ' ');

  $textPersonalise.css('background',$backgroundTexture);
  if (_isShow == 'Black') {
    $textPersonalise.css('background', '#000000');
  }
  if (_isShow == 'White') {
    $textPersonalise.css('background', '#FFFFFF');
  }
  if (_isShow == 'Blind Deboss') {
    var colorvar = $('.jsc-col-var input:checked').val();
    var hasdebosscol = false;

    $('.deboss-color-data').each(function(){
      var varcol = $(this).val();
      var coldeboss = $(this).attr('data-coldeboss');
      if (colorvar == varcol) {
        $textPersonalise.css('background', coldeboss);
        hasdebosscol = true;
      }
    });

    if (hasdebosscol == false) {
      $textPersonalise.css('background', '#666666');
    }
    $textPersonalise.css('color', 'transparent');
    $textPersonalise.css('opacity', '1');
  }
}

$("#leather-text").bind('paste', function (evt) {
  setTimeout(function () {
    var $fontFamily = $('#fontType').val();
    var $fontSize = $('#fontSize').find(':selected').text();
    var _ltext = $("#leather-text").val();
  // hide input text error message
  $("#input-text-error").hide();

  // Disable special character
  var regex = new RegExp("['-.&a-zA-Z0-9]+$");
  if ($fontFamily == 'Copperplate' && $fontSize == '10mm') {
    var temp = _ltext.replace(/[^-'.&a-zA-Z@#\s]/g, "").replaceAll("*", "").replaceAll("+", "").replaceAll("'", "");
  } else if ($fontFamily == 'Script Sentence' && $fontSize == '6mm'){
    var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, "").replaceAll("*", "").replaceAll("+", "").replaceAll("'", "").replaceAll('.', '');
  } else {
    var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, "").replaceAll("*", "").replaceAll("+", "");
  }

  var leatherEl = document.getElementById('leather-text');
  temp = jscClampLeatherTextToMaxlength(temp, leatherEl);
  $("#leather-text").val(temp);
  $(".personalisation-text").text(temp);
  // To show how many character (s)left
  var $charNum = $(".charNum");
  var $max = $("#leather-text").attr("maxlength");
  var $len = temp.length;
  var $overlayText = $(".personalisation-text");
  var $char = 0;
  $char = $max - $len;
  $charNum.text($len + '/' + $max);
    }, 500 );
});

$('#leather-text').on('input change compositionend', function (evt) {
  var _ltext = $('#leather-text').val();
  var $fontFamily = $('#fontType').val();
  var $fontSize = $('#fontSize').find(':selected').text();
  // hide input text error message
  $('#input-text-error').hide();

  // Disable special character
  var regex = new RegExp("['-.&a-zA-Z0-9]+$");
  if ($fontFamily == 'Copperplate' && $fontSize == '10mm') {
    var temp = _ltext.replace(/[^-'.&a-zA-Z@#\s]/g, '').replaceAll('*', '').replaceAll('+', '').replaceAll("'", "");
  } else if ($fontFamily == 'Script Sentence' && $fontSize == '6mm'){
    var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, '').replaceAll('*', '').replaceAll('+', '').replaceAll("'", "").replaceAll('.', '');
  } else {
    var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, '').replaceAll('*', '').replaceAll('+', '');
  }

  temp = jscClampLeatherTextToMaxlength(temp, this);
  $('#leather-text').val(temp);
  $(".personalisation-text").text(temp);
  // To show how many character (s)left
  var $charNum = $('.charNum');
  var $max = this.getAttribute("maxlength");
  var $len = temp.length;
  var $overlayText = $('.personalisation-text');
  var $char = 0;
  $char = $max - $len;
  $charNum.text($len + '/' + $max);
});

selectGiftBox = (evt,option) =>{
  $('.append-bindid-gift-wrap').children().remove();
  $('#AddToCart').removeClass('add-gift-wrap');
  var $this = $(evt);
  var $giftLabel = $('.gift_label');
  var $textSpan = $('#gift-type-text');
  var $price = $this.attr('data-price');
  var $priceNum = $this.attr('data-price-number');

  // border styling
  $giftLabel.css('border', 'none');
  $this.css('border', '1px solid #89714B');

  // text update
  if ($price){
  $textSpan.text(option+' (+'+$price+')');
  }else{
    $textSpan.text(option);
  }
  $('#selected-gift-wrap').val(option);
  if ($priceNum && $priceNum > 0) {
    var $bindId = $('.jsc-mainID-pdp').val() + option;
    var $handleizeBindId = $bindId.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    $('.append-bindid-gift-wrap').append('<input type="hidden" id="gift-wrap-id" name="properties[BindID]" class="gift-radio" value="'+ $handleizeBindId +'">')
    $('#AddToCart').addClass('add-gift-wrap');
  }
}
//End - Personalise Feature
//Start - Img swap variant
var jscVariantTextThumbnailTimer;
var jscVariantSliderTimer;

jscMediaMatchesColor = (altText, color, selectedlengthcolor, length) => {
  if (!altText) {
    return false;
  }
  return altText == color
    || altText == selectedlengthcolor
    || altText == length
    || altText == 'main_image'
    || (color && altText.includes(color + '-text'))
    || altText == 'main_image-text';
};

jscIsMainImageAlt = (altText) => {
  return altText == 'main_image' || altText == 'main_image-text';
};

jscIsColourOptionLabel = (label) => {
  var text = (label || '').toLowerCase();
  return text.indexOf('colour') !== -1 || text.indexOf('color') !== -1;
};

// Colour option fieldsets for gallery filtering.
// Supports .jsc-col-var and dropdown labels like "Book Jacket Nbr 2.1 (Colour)".
// Bundle PDPs render each child product in its own <variant-picker>, so search all pickers.
// custom.bundle_product_list PDPs use .jsc-bundle-list-colour-row instead of variant-picker.
jscGetGalleryColourOptionFields = () => {
  var $bundleRows = $('.jsc-bundle-list-colour-row');
  if ($bundleRows.length > 0) {
    return $bundleRows;
  }

  var $colorOptions = $('.variant-picker .jsc-col-var');
  if ($colorOptions.length > 0) {
    return $colorOptions;
  }

  return $('.variant-picker').find('.variant-picker__option').filter(function() {
    return jscIsColourOptionLabel($(this).find('legend').text());
  });
};

// 1-based colour-option index for the clicked swatch (so Black on jacket ≠ Black on notebook).
jscGetClickedGalleryColorOptionIndex = ($root) => {
  if (!$root || !$root.length) {
    return null;
  }

  var $bundleRow = $root.closest('.jsc-bundle-list-colour-row');
  if ($bundleRow.length) {
    var bundleIdx = parseInt($bundleRow.attr('data-bundle-list-index'), 10);
    if (!isNaN(bundleIdx)) {
      return bundleIdx + 1;
    }
    var $allBundleRows = $('.jsc-bundle-list-colour-row');
    var bundleDomIdx = $allBundleRows.index($bundleRow);
    return bundleDomIdx >= 0 ? bundleDomIdx + 1 : null;
  }

  var $clickedOption = $root.closest('.variant-picker__option');
  if (!$clickedOption.length) {
    return null;
  }

  var $allColorOptions = jscGetGalleryColourOptionFields();
  var idx = $allColorOptions.index($clickedOption);
  if (idx < 0) {
    return null;
  }

  return idx + 1;
};

jscGetColourOptionSelectedValue = ($option) => {
  if ($option.hasClass('jsc-bundle-list-colour-row')) {
    return $option.find('.jsc-bundle-list-colour-select').attr('data-option1')
      || $option.find('.jsc-bundle-list-colour-option[selected="selected"]').attr('data-option1')
      || $.trim($option.find('.jsc-selected-text').first().text())
      || '';
  }
  return $option.find('input:checked').val()
    || $option.find('input.jsc-var-no-color').val()
    || $option.find('input[type="hidden"][name^="option"]').val()
    || $option.find('[data-option-value][aria-selected="true"]').attr('value')
    || $option.find('.jsc-dropdown-selected-value, [id$="-selected-value"]').first().text().trim();
};

// Bundle / multi-colour products (e.g. A New Chapter): one entry per colour option,
// with a 1-based product/option index so Pink on jacket ≠ Pink on notebook.
jscGetSelectedGalleryColorSelections = (preferredColor) => {
  var selections = [];
  var $colorOptions = jscGetGalleryColourOptionFields();

  $colorOptions.each(function(index) {
    var val = jscGetColourOptionSelectedValue($(this));
    if (val) {
      selections.push({ color: val, index: index + 1 });
    }
  });

  if (!selections.length && preferredColor) {
    selections.push({ color: preferredColor, index: 1 });
  }

  return selections;
};

jscGetSelectedGalleryColors = (preferredColor) => {
  var colors = [];
  var selections = jscGetSelectedGalleryColorSelections(preferredColor);
  for (var i = 0; i < selections.length; i++) {
    if (colors.indexOf(selections[i].color) === -1) {
      colors.push(selections[i].color);
    }
  }
  if (preferredColor && colors.indexOf(preferredColor) === -1) {
    colors.push(preferredColor);
  }
  return colors;
};

// All colour values across colour options (selected + unselected) for group detection.
jscGetAllGalleryColorValues = () => {
  var colors = [];
  var pushColor = function(val) {
    if (val && colors.indexOf(val) === -1) {
      colors.push(val);
    }
  };

  jscGetGalleryColourOptionFields().each(function() {
    var $option = $(this);
    if ($option.hasClass('jsc-bundle-list-colour-row')) {
      $option.find('.jsc-bundle-list-colour-option').each(function() {
        pushColor($(this).attr('data-option1'));
      });
      return;
    }
    $option.find('input[type="radio"], input.jsc-var-no-color, input[type="hidden"][name^="option"]').each(function() {
      pushColor($(this).val());
    });
    $option.find('[data-option-value]').each(function() {
      pushColor($(this).attr('value') || $(this).attr('title'));
    });
  });

  return colors;
};

jscResolveAltColor = (altText, allColors, selectedlengthcolor, length) => {
  if (!altText || jscIsMainImageAlt(altText) || !allColors || !allColors.length) {
    return null;
  }

  // Prefer exact colour matches before partial "-text" matches.
  for (var i = 0; i < allColors.length; i++) {
    var color = allColors[i];
    if (!color) {
      continue;
    }
    if (altText == color) {
      return color;
    }
    if (selectedlengthcolor && altText == selectedlengthcolor && selectedlengthcolor.indexOf(color) === 0) {
      return color;
    }
  }
  // Longer colour names first so "Dark Brown-text" does not resolve as "Brown".
  var sortedColors = allColors.slice().sort(function(a, b) {
    return (b || '').length - (a || '').length;
  });
  for (var j = 0; j < sortedColors.length; j++) {
    if (sortedColors[j] && altText.includes(sortedColors[j] + '-text')) {
      return sortedColors[j];
    }
  }
  return null;
};

// Contiguous alt groups per colour in gallery order:
// group 1 = first product block, group 2 = second product block, etc.
jscBuildColorMediaGroups = ($items, allColors, selectedlengthcolor, length) => {
  var groupsByColor = {};
  var lastColor = null;

  $items.each(function() {
    var altText = $(this).attr('data-img-alt') || '';
    if (jscIsMainImageAlt(altText)) {
      lastColor = null;
      return;
    }

    var matchedColor = jscResolveAltColor(altText, allColors, selectedlengthcolor, length);
    if (!matchedColor) {
      lastColor = null;
      return;
    }

    if (!groupsByColor[matchedColor]) {
      groupsByColor[matchedColor] = [];
    }

    if (matchedColor !== lastColor) {
      groupsByColor[matchedColor].push([]);
      lastColor = matchedColor;
    }

    groupsByColor[matchedColor][groupsByColor[matchedColor].length - 1].push(this);
  });

  return groupsByColor;
};

jscCollectVisibleMediaFromSelections = ($items, selections, selectedlengthcolor, length) => {
  var visible = [];
  var seen = [];
  var markVisible = function(el) {
    if (!el || seen.indexOf(el) !== -1) {
      return;
    }
    seen.push(el);
    visible.push(el);
  };

  $items.each(function() {
    if (jscIsMainImageAlt($(this).attr('data-img-alt') || '')) {
      markVisible(this);
    }
  });

  if (!selections || selections.length <= 1) {
    var singleColor = selections && selections[0] ? selections[0].color : null;
    $items.each(function() {
      var altText = $(this).attr('data-img-alt') || '';
      if (jscMediaMatchesColor(altText, singleColor, selectedlengthcolor, length)) {
        markVisible(this);
      }
    });
    return visible;
  }

  var allColors = jscGetAllGalleryColorValues();
  for (var s = 0; s < selections.length; s++) {
    if (allColors.indexOf(selections[s].color) === -1) {
      allColors.push(selections[s].color);
    }
  }

  var groupsByColor = jscBuildColorMediaGroups($items, allColors, selectedlengthcolor, length);
  for (var i = 0; i < selections.length; i++) {
    var selection = selections[i];
    var groups = groupsByColor[selection.color];
    if (!groups || !groups.length) {
      continue;
    }

    var group = groups[selection.index - 1];
    if (!group) {
      // Only one image set for this colour across products — reuse it.
      group = groups.length === 1 ? groups[0] : null;
    }
    if (!group) {
      continue;
    }

    for (var g = 0; g < group.length; g++) {
      markVisible(group[g]);
    }
  }

  return visible;
};

jscSelectSingleVisibleThumbnail = (matchFn, preferredElements) => {
  clearTimeout(jscVariantTextThumbnailTimer);
  jscVariantTextThumbnailTimer = setTimeout(function() {
    var $target = null;

    // Prefer the colour group for the option that was just clicked (same colour, different product).
    if (preferredElements && preferredElements.length) {
      for (var i = 0; i < preferredElements.length; i++) {
        var $el = $(preferredElements[i]);
        if (!$el.hasClass('jsc-thumbnail') || !$el.is(':visible')) {
          continue;
        }
        var alt = $el.attr('data-img-alt') || '';
        if (!matchFn || matchFn(alt)) {
          $target = $el;
          break;
        }
      }
      if (!$target) {
        for (var j = 0; j < preferredElements.length; j++) {
          var $fallback = $(preferredElements[j]);
          if ($fallback.hasClass('jsc-thumbnail') && $fallback.is(':visible')) {
            $target = $fallback;
            break;
          }
        }
      }
    }

    if (!$target || !$target.length) {
      $('.jsc-thumbnail:visible').each(function() {
        if (matchFn($(this).attr('data-img-alt') || '')) {
          $target = $(this);
          return false;
        }
      });
    }

    if ($target && $target.length) {
      $target.trigger('click');
    }
  }, 10);
};

jscFilterProductGalleryByColor = ($root, color, selectedlengthcolor, length) => {
  var $galleryRoot = $root.closest('.jsc-pdp');
  if (!$galleryRoot.length) {
    $galleryRoot = $('.jsc-pdp').first();
  }

  var selections = jscGetSelectedGalleryColorSelections(color);
  var clickedOptionIndex = jscGetClickedGalleryColorOptionIndex($root);
  var $media = $galleryRoot.find('.product-gallery__media');
  var $thumbs = $('.jsc-thumbnail');
  var visibleMedia = jscCollectVisibleMediaFromSelections($media, selections, selectedlengthcolor, length);
  var visibleThumbs = jscCollectVisibleMediaFromSelections($thumbs, selections, selectedlengthcolor, length);

  $media.each(function() {
    if (visibleMedia.indexOf(this) !== -1) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });

  $thumbs.each(function() {
    if (visibleThumbs.indexOf(this) !== -1) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });

  var preferredThumbGroup = null;
  if (color && clickedOptionIndex) {
    var allColors = jscGetAllGalleryColorValues();
    if (allColors.indexOf(color) === -1) {
      allColors.push(color);
    }
    var thumbGroupsByColor = jscBuildColorMediaGroups($thumbs, allColors, selectedlengthcolor, length);
    var colorGroups = thumbGroupsByColor[color];
    if (colorGroups && colorGroups.length) {
      preferredThumbGroup = colorGroups[clickedOptionIndex - 1] || (colorGroups.length === 1 ? colorGroups[0] : null);
    }
  }

  jscSelectSingleVisibleThumbnail(function(altText) {
    return color && altText.includes(color + '-text');
  }, preferredThumbGroup);
};

variantImageSwap = (evt,color, containsSingleQuotesVal) =>{
  setTimeout(function () {

  if(containsSingleQuotesVal) {
    var uncleanedValue = $(evt).attr('uncleaned-value');
    if (uncleanedValue) {
      color = uncleanedValue;
    }
  }

  if ($('.jsc-cnb-gallery').length <= 0) {

  var length = 'xx';
  var selectedlengthcolor = 'xx';
  if ($('.customised-a-tag-prod').length > 0) {
    color = $('.jsc-col-var input:checked').val();
    length = $('.side-variant .variant-picker__option-values input:checked').val();
    setTimeout(function(){
      var selectcoladdonparent = $('.add-ons-customiseAtag-category input:checked').next().attr('data-container');
      $('.addons-containers').hide();
      $('.customisedatag-addons').hide();
      $('.'+selectcoladdonparent).show();
      $('.'+selectcoladdonparent).find('.dropdownlistcnb.dropdownactive').click();
      $('.positionstrap').each(function(){
        var positiontext = $(this).attr('data-tag-name');
        if (positiontext.includes('Position:' + length)) {
          var positiontextcss = positiontext.replace('Position:' + length + '-', '');
          $('.personalize-textoverlay-container').css('top',positiontextcss)
        }
      });
    },1);
    selectedlengthcolor = color + '-' + length;
  }

  jscFilterProductGalleryByColor($(evt), color, selectedlengthcolor, length);

  setTimeout(function() {
    updateProductGalleryCounter();
  }, 20);

  // Show personalise
  if ($('#leather-text').val() != null || $('#leather-text').val() != undefined ) {
  var $textVal = $('#leather-text').val();
  $(".personalisation-text").text($textVal);

  if ($textVal !== '' ){
    var swapvar = true;
    $('.position-layout-label').each(function(){
      var $this = $(this);
      if ($this.hasClass('layout-selected')) {
        lLayout($this);
      }
    });
    $('.foil-option').each(function(){
      var $this = $(this);
      if ($this.hasClass('foil-selected')) {
        lFoil($this);
      }
    });
  }
    if ($(evt).hasClass('is-disabled')) {
      $('#personaliseBtn').addClass('hideimportant');
      $('.jsc-atc').text('Sold out');
      $('.jsc-atc').addClass('sold_out_personalize');
      $('.jsc-atc').attr('onclick','');
      if ($(evt).attr('bundleprd') !== undefined) {
        // If the attribute exists, check if its value is 'true' or 'false'
        var bundlePrdValue = $(evt).attr('bundleprd');
        if (bundlePrdValue == 'true') {
          $('.ProductForm__AddToCart').attr('disabled', 'disabled');
          $('.ProductForm__AddToCart').text('Sold out');
        }
      }
    }else{
      console.log('show personalize');
      var leatherFormOpen = $('#isPersonalisation').is(':visible');
      var leatherEditMode = $('body').hasClass('cnb-edit-personalisation-mode')
        || window.__cnbEditPrefillActive
        || /[?&]edit_personalisation=1(?:&|$)/.test(String(window.location.search));
      if (leatherFormOpen || leatherEditMode) {
        $('#personaliseBtn').addClass('hideimportant');
        $('.jsc-atc').text(leatherEditMode ? 'Update' : 'add to cart');
      } else {
        $('#personaliseBtn').removeClass('hideimportant').css('display', 'inline-block');
        $('.jsc-atc').text('add to cart');
      }
      $('.jsc-atc').removeClass('sold_out_personalize');
      $('.jsc-atc').attr('onclick','leatherAddToCart(this)');
      if ($(evt).attr('bundleprd') !== undefined) {
        // If the attribute exists, check if its value is 'true' or 'false'
        var bundlePrdValue = $(evt).attr('bundleprd');
        if (bundlePrdValue == 'true') {
          $('.jsc-atc').attr('onclick','leatherBundleProductAddToCart(this)');
          $('.ProductForm__AddToCart').removeAttr('disabled');
          $('.ProductForm__AddToCart').text(leatherEditMode ? 'Update' : 'add to cart');
        }
      }
    }
  }
  }
  }, 10 );

  if($('.jsc-selector-dropdown').length > 0){
    //Normal Product Description
    var variantDesc = $(evt).find('.jsc-custom-variant-desc').html();
    var targetElement = $('[data-block-type="description"]');
    var childElement = targetElement.find('.accordion__content');
    if (variantDesc != '') {
      if (childElement.length) {
        childElement.html(variantDesc);
      }
    }
    //About The Artist Description
    var variantArtistDesc = $(evt).find('.jsc-custom-variant-about-artist-desc').html();
    var targetElement = $('.jsc-about-artist-field');
    var childElement = targetElement.find('.accordion__content');
    
    if (variantArtistDesc != '') {
      targetElement.show();
      if (childElement.length) {
        childElement.html(variantArtistDesc);
      }
    }else{
      targetElement.hide();
    }

  }else{
    //Normal Product Description
    var variantDesc = $(evt).find('.jsc-custom-variant-desc').html();
    var targetElement = $('[data-block-type="description"]');
    var childElement = targetElement.find('.accordion__content');
    if (variantDesc != '') {
      if (childElement.length) {
        childElement.html(variantDesc);
      }
    }
    //About The Artist Description
    var variantArtistDesc = $(evt).find('.jsc-custom-variant-about-artist-desc').html();
    var targetElement = $('.jsc-about-artist-field');
    var childElement = targetElement.find('.accordion__content');
    if (variantArtistDesc != '') {
      if (childElement.length) {
        targetElement.show();
        childElement.html(variantArtistDesc);
      }
    }else{
      targetElement.hide();
    }
  }
}
onloadGetProductImgArray = () =>{
  if ($('.jsc-cnb-gallery').length <= 0) {
  var color = $('.jsc-col-var input:checked').val();
  if (!color) {
    color = $('.jsc-var-no-color').first().val();
  }
  var selectedColors = jscGetSelectedGalleryColors(color);
  if (selectedColors.length) {
    color = selectedColors[0];
  }

  var length = $('.side-variant .variant-picker__option-values input:checked').val();
  if ($('.customised-a-tag-prod').length > 0) {
    $('.positionstrap').each(function(){
      var positiontext = $(this).attr('data-tag-name');
      if (positiontext.includes('Position:' + length)) {
        var positiontextcss = positiontext.replace('Position:' + length + '-', '');
        $('.personalize-textoverlay-container').css('top',positiontextcss)
      }
    });
  }
  var selectedlengthcolor = color + '-' + length;

  jscFilterProductGalleryByColor($('.jsc-pdp').first(), color, selectedlengthcolor, length);
  setTimeout(function() {
    updateProductGalleryCounter();
  }, 20);
  }
}
//End - Img swap variant


// Global variable
var $imgContainer = $('.Alt_Product__Slideshow');
var $childArrayElement = $imgContainer.find('.Carousel__Cell');
var $navContainer = $('.selectedNav');
var $navCell = $('.navCell');
var $templateName = $('#js_template').attr('data-template');
$(function () {
  
  if (window.location.href.indexOf('/account?data-segment=profile?register=true') > -1) {
    $('#jsc-customer-greeting').text('Hi');
  }
  initCustomRecommendation();

  if (location.pathname == '/account') {
    var formId = '0ktYKL';
    var $form = document.querySelector('form[data-cf-form="' + formId + '"]');

    setTimeout(function () {
        appendProfileCTA();
    }, 1000);

    $form.addEventListener('cf:form_submitted', function(event) {
      // submitbirthday();
      submitprofile();
      window.location.href = "/account?data-segment=profile";
    });
  }

  // start customise ll sections
  $(window).scroll(function(){
    if (location.href.includes('/account?data-segment=loyaltylion')) {
      var nowScrollTop = $(this).scrollTop();
      if (nowScrollTop > 1890) {
        $('#_jsc-sidebar').removeClass('jsc-sidebar-sticky');
        $('#_accountPageLayout').removeClass('jsc-segment-sticky');
      }else {
        $('#_jsc-sidebar').addClass('jsc-sidebar-sticky');
        $('#_accountPageLayout').addClass('jsc-segment-sticky');
      }
    }
  });

  if (location.href.includes('/account?data-segment=loyaltylion')) {
    $('#_jsc-sidebar').addClass('jsc-sidebar-sticky');
    $('#_accountPageLayout').addClass('jsc-segment-sticky');

    showllEachSection();
    setTimeout(function () {
      loadLLSectionID();
    }, 1000);
  }
  // end customise ll sections

  setTimeout(function () {

  $(".lion-tiers-overview")
    .clone()
      .insertAfter(".lion-header.lion-integrated-page-section");
  }, 2000);

  if (location.href.includes('/account')) {
    var timer = setInterval(function() {
      if ($('.cf-form-actions')) {
        var dateOB = $(".DayPickerInput input").val();
        if (dateOB != '') {
          $('.cf-date-picker-container').append('<div class="jsc-disabled-dob"></div>');
        }
        clearInterval(timer);
      }
  	}, 1000);
  }



    // setTimeout(function () {
    //   if ($('.cf-form-actions')) {
    //     $('.cf-form-actions').append('<button type="button" class="cf-button btn button" onclick="submitbirthday()"><span>Save</span></button>')
    //     $('.cf-submit-form').hide();
    //     }
    //   }, 1000);

  setTimeout(function () {
    if ($(".lion-header__your-points")) {
      var point = $("div.lion-header__your-points > span > strong").text();
    }
    
    var enrolled_meta = $(".jsc-LL").attr("data_synced");
    var tier = $(".jsc-LL").attr("data-tier");
    
    if (enrolled_meta != null && enrolled_meta !='') {
     
      //remove all unwanted element
      var path = $(".lion-header");
      path.find(".lion-header__your-points").remove();
      path.find(".lion-header__pending-points").remove();
      path.find(".lion-header__nav").remove();
     
      //append new design element
      path.append('<div class="ll-detail"><div class="left-ll-detail"></div><div class="right-ll-detail"><div id="points" style="font-size:20px;font-weight:700;color:#8C734C;margin-bottom: 35px;"></div>' +
        '<div style="margin-top:10px;">' +
        '<span id="enrolled"></span >' +
        '<p id="__tier-reachtext" style="margin-top:10px;"></p></div></div></div>')
     
      //get enrolled date from metafield
      var enrolled_meta = $(".jsc-LL").attr("data_synced");
      var enroll = enrolled_meta.split("T");
      var shopify_last_orderdate = $(".jsc-LL").attr("data-last-order");

      //convert enrolled date and find expiry date
      var enrollDate = new Date(enroll[0]);
      var last_orderdate = new Date(shopify_last_orderdate);
      // var expireDate = new Date(enroll[0]);
      // expireDate.setFullYear(expireDate.getFullYear() + 1);
      // expireDate.setDate(expireDate.getDate() - 1);

      var newExpireDate = new Date(last_orderdate.getTime());
      newExpireDate.setDate(newExpireDate.getDate() + 365);
      
      var sinceFromattedDate =
        enrollDate.toLocaleString("en", { day: "numeric" }) +
        " " +
        enrollDate.toLocaleString("en", { month: "short" }) +
        " " +
        enrollDate.toLocaleString("en", { year: "numeric" });
    
      var newexpiredFormattedDate =
        newExpireDate.toLocaleString("en", { day: "numeric" }) +
        " " +
        newExpireDate.toLocaleString("en", { month: "short" }) +
        " " +
        newExpireDate.toLocaleString("en", { year: "numeric" });  
      // var expiredFormattedDate =
      //   expireDate.toLocaleString("en", { day: "numeric" }) +
      //   " " +
      //   expireDate.toLocaleString("en", { month: "short" }) +
      //   " " +
      //   expireDate.toLocaleString("en", { year: "numeric" });
      
      //set output of the element
      var point_text = point + ' Points'

      // member png 
      if (tier == 'Member') {
       var img_src = "https://cdn.shopify.com/s/files/1/0275/3318/0970/files/ZTbbRFwM.png?v=1680144774";
      }else if (tier == 'Silver'){
        var img_src = "https://cdn.shopify.com/s/files/1/0275/3318/0970/files/plEbcj08.png?v=1680146038";
      }else if (tier == 'Gold'){
        var img_src = "https://cdn.shopify.com/s/files/1/0275/3318/0970/files/tEz7as8A.png?v=1680146063";
      }else if (tier == 'Platinum'){
        var img_src = "https://cdn.shopify.com/s/files/1/0275/3318/0970/files/AMmH_kVo.png?v=1680146073";
      }
      // line 1 text 
      if (tier == 'Member') {
       var enrolled_output =  " You've been a <span style='color:#8C734C;font-weight: 700;'> " + tier + "</span> since <span style='font-weight: 700;color:#888'>" + sinceFromattedDate + "</span>";
      }else if ((tier == 'Silver') || (tier == 'Gold')){
        var enrolled_output =  " You're in <span style='color:#8C734C;font-weight: 700;'> " + tier + "</span> tier until <span style='font-weight: 700;color:#888'>" + newexpiredFormattedDate + "</span>";
      }else if (tier == 'Platinum'){
        var enrolled_output =  " You've been in <span style='color:#8C734C;font-weight: 700;'> " + tier + "</span> tier since <span style='font-weight: 700;color:#888'>" + sinceFromattedDate + "</span>";
      }

      // Line 2 text
      if ($(".openfaq").length > 0) {
        var reach_text = "Loyalty points are valid for 365 days from the date earned. <span class='openfaq' style='text-decoration:underline !important' onclick='openFaqAccount();'>Learn More</span>";
      }else{
      var reach_text = "Loyalty points are valid for 365 days from the date earned. <a style='text-decoration:underline !important' href='/pages/friendsofbynd'>Learn More</a>";
      }

      $(".left-ll-detail").append('<img src="'+img_src+'">');
      $("#enrolled").html(enrolled_output);
      $("#points").text(point_text);
      // if ((tier == 'Member') || (tier == 'Silver')){
        $("#__tier-reachtext").html(reach_text);
      // }
    }
  }, 2000);

$("#slideshow > div:gt(0)").hide();

  setInterval(function () {
    $("#slideshow > div:first")
      .fadeOut(0)
      .next()
      .fadeIn(0)
      .end()
      .appendTo("#slideshow");
  }, 3000);

  onloadSidebarAccount();
  //onloadCustomerProfile();
  updateklaviyoButtontext();
  bookThatAppStyling();
  removeGWP();
  addGWP();
  removeBundleProd();
  checkOrderLimitPrd();
  hideaddnotecart();
  $template = $('#js_template').val();

  if (location.href.includes('/challenge')) {
    oncloadChallenge();
  }

  if ($('.jsc-cnb-gallery').length > 0) {
    customNotebookCoverImg();
  }


  // Randomise article section
  var $randomCell = $('.js-random-cell').get().sort(function(){
  return Math.round(Math.random())-0.5; // random to get and show 3 randomise cell
  }).slice(0,3)
  $($randomCell).show();

  anchorDescription();

});

// Fallback if multi-column renders after ready, or ready was blocked
$(window).on('load', function() {
  try {
    initTextLinkClick();
  } catch (err) {}
});

//Country list redirect
onChangeCountry = (e) => {
  var selectedValue = $(e).val();

  // Redirect the page to the selected URL
  window.location.href = selectedValue;
}

appendProfileCTA = () => {
  var ele = $('.lion-rule-item--complete_profile').children().find('.lion-rule-item__actions');

  if (ele.children().length == 0) {
    ele.append('<a href="/account?data-segment=profile" class="lion-action-button lion-action-button--tile lion-complete_profile__button">My Profile</a>')
  }
}

showllEachSection = () => {
  $('.jsc-sidebarMenu-ll-each-section').removeClass('d-none');
  $('#_jsc-sidebar').addClass('jsc-sidebar-sticky');
  $('#_accountPageLayout').addClass('jsc-segment-sticky');
}

hidellEachSection = () => {
  $('.jsc-sidebarMenu-ll-each-section').addClass('d-none');
  $('#_jsc-sidebar').removeClass('jsc-sidebar-sticky');
  $('#_accountPageLayout').removeClass('jsc-segment-sticky');
}

loadLLSectionID = () => {
    var $earn = $('#jsc-lion').children().children('.data-lion-integrated-page').find('.lion-integrated-page').children('.lion-earn');
    var $tier = $('#jsc-lion').children().children('.data-lion-integrated-page').find('.lion-integrated-page').children('.lion-tiers-overview');
    var $reward = $('#jsc-lion').children().children('.data-lion-integrated-page').find('.lion-integrated-page').children('.lion-redeem');

    $earn.attr('id','_earn');
    $tier.attr('id','_tier');
    $reward.attr('id','_reward');
}

onclickSidebarLoyaltylion = (evt,segment) =>{
  var _this = $(evt);
  var newurl = window.location.href.split('?')[0];
  newurl = '/account?data-segment=loyaltylion#' + segment;
  window.history.pushState({ path: newurl }, '', newurl);
  $('html, body').animate({scrollTop: $('#'+segment).offset().top -250 });
}

submitprofile = () => {
  // var date = $(".DayPickerInput").find("input").val();
  var id = $(".jsc-LL").attr("data_id");
  var email = $('.jsc-LL').attr('data_email')
  $.ajax({
    url: "https://webhooks.mechanic.dev/28a9a75a-881e-4fbe-8e1b-dab82fe423d1",
    method: "POST",
    data: {
      id: id,
      email: email
    },
  })
    .done(function () {
      console.log("submit profle success");
    })
    .fail(function (e) {
      console.log(e);
    });
}

submitbirthday = () => {
  var date = $(".DayPickerInput").find("input").val();
  var id = $(".jsc-LL").attr("data_id");
  var email = $('.jsc-LL').attr('data_email');

  var arry = date.split("-");
  var new_date = arry[2] + "-" + arry[1] + "-" + arry[0];

    $.ajax({
      url: "https://webhooks.mechanic.dev/4bbe9949-a310-4e9e-bc15-94545ba32950",
      method: "POST",
      data: {
        id: id,
        date: new_date,
        email: email
      },
    })
      .done(function () {
        console.log("submit brithdy succes");
      })
      .fail(function (e) {
        console.log(e);
      });
}

removeProductDrawer = () =>{
  var $actionVal = 'plusMinus-';
  var $atcBtn = $('.ProductForm__AddToCart');
  var $dataVid = $atcBtn.attr('data-vid');
  var $targetQty = $('.'+$actionVal+$dataVid);
  var $checkQty = $('.'+$actionVal+$dataVid).attr('data-qty');
  var $checkInventory = $('.'+$actionVal+$dataVid).attr('data-inventory');

  if ($checkQty != null  && $checkInventory != null) {
    $atcBtn.prop('disabled',false);
    $atcBtn.attr('data-action','add-to-cart');
    $atcBtn.addClass('Button--primary');
    $atcBtn.removeClass('Button--secondary');
    $atcBtn.text('add to cart');

  }
}


// Scripts for custom notebook starts here
$(document).click(function(event) {
  // twin wire drodown
  var $dropdownTwinWire = $('.twin-wire-swatch-tab .stepselected');
  var $isClickInside = $dropdownTwinWire.has(event.target).length > 0 || $dropdownTwinWire.is(event.target);

  if (!$isClickInside) {
    $dropdownTwinWire.find('.dropdownwrapcnb').hide(); 
  }
  // addon drodown
  var $dropdownAddon = $('.addonoptwrap .stepselected');
  var $isClickInsideAddon = $dropdownAddon.has(event.target).length > 0 || $dropdownAddon.is(event.target);

  if (!$isClickInsideAddon) {
    $dropdownAddon.find('.dropdownwrapcnb').hide(); 
  }
});

customNotebookCoverImg = () =>{

  if($('.jsc-selector-dropdown').length > 0){
    var $selectedCover = $('.jsc-dropdown-selected-value').text();
    var $firstAltText = $selectedCover;
    $('.var_opt_color').text($selectedCover);
    var $coverImg = $('.cover_img_div');
    console.log("$selectedCover", $selectedCover);
    $coverImg.hide();

    for (var i = 0; i < $coverImg.length; i++) {
      var $thisAltText = $($coverImg[i]).attr('data-img-alt');
      if ($thisAltText == $firstAltText || $thisAltText == 'main_image') {
        $($coverImg[i]).show();
      }
    }
  
    $('.jsc-thumbnail').each(function(){
      var $thisAltText = $(this).attr('data-img-alt');
      if ($thisAltText == $firstAltText || $thisAltText == 'main_image') {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
    jscSelectSingleVisibleThumbnail(function(altText) {
      return altText.includes($firstAltText);
    });
  }else{
    var $selectedCover = $('.Notebook_ColorSwatch__Radio:checked').val();
    var $firstAltText = $selectedCover+'-1';
    var $coverImg = $('.cover_img_div');
    $('.var_opt_color').text($selectedCover);
    // hide all cover image
    $coverImg.hide();
  
    for (var i = 0; i < $coverImg.length; i++) {
      var $thisAltText = $($coverImg[i]).attr('data-img-alt');
      if ($thisAltText == $firstAltText || $thisAltText == 'main_image') {
        $($coverImg[i]).show();
      }
    }
  
    $('.jsc-thumbnail').each(function(){
      var $thisAltText = $(this).attr('data-img-alt');
      if ($thisAltText == $firstAltText || $thisAltText == 'main_image') {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
    jscSelectSingleVisibleThumbnail(function(altText) {
      return altText.includes($selectedCover + '-text');
    });
  }

  setTimeout(function() {
    updateProductGalleryCounter();
  }, 20);
}

customNotebookOnclickSwatch = (element) =>{
  setTimeout(function(){
    customNotebookCoverImg();
    customNotebookCustomDesc(element);
  },100);
}

swapFrontBackImg = (activeTab) =>{
  // This function is to swap Image for paper steps which is cover(https://share.getcloudapp.com/xQuL966e) and inside (https://share.getcloudapp.com/qGuNgJJJ)
  // Get selected options
  var $selectedCover = $('.Notebook_ColorSwatch__Radio:checked').val();
  var $selectedTwinWire = $('.twin-wire-radio:checked').val();
  var $selectedPaper = $('.paper-radio:checked').val();

  // Get images
  var $coverImg = $('.cover_img_div');
  var $twinWireImg = $('.twin-wire-img');
  var $paperImg = $('.paper-img');
  var $claspImg = $('.clasp-img');
  var $bandImg = $('.band-img');
  var $flapImg = $('.flap-img');

  if (activeTab) {
    // when swtich to paper tab then execute these

    var $secondAlt = '-2';
    var $coverImgAlt = $selectedCover + $secondAlt;
    var $twinWireImgAlt = $selectedTwinWire + $secondAlt;

    // Hide product image
    $coverImg.hide();
    $twinWireImg.hide();
    $paperImg.hide();
    $claspImg.hide();
    $bandImg.hide();

    // Hide text overlay
    $('#personalize-textoverlay-span').hide();

    for (var i = 0; i < $coverImg.length; i++) {
      var $thisAltText = $($coverImg[i]).attr('data-img-alt');
      if ($thisAltText == $coverImgAlt) {
        $($coverImg[i]).show();
      }
    }

    for (var i = 0; i < $twinWireImg.length; i++) {
      var $thisAltText = $($twinWireImg[i]).attr('alt');
      if ($thisAltText == $twinWireImgAlt) {
        $($twinWireImg[i]).show();
      }
    }

    for (var i = 0; i < $paperImg.length; i++) {
      var $thisAltText = $($paperImg[i]).attr('alt');
      if ($thisAltText == $selectedPaper) {
        $($paperImg[i]).show();
      }
    }

    // show selected Flap image only
    showFlapImgs();

  } else {
    // when it is not paper tab then execute these

    var $firstAlt = '-1';
    var $coverImgAlt = $selectedCover + $firstAlt;
    var $twinWireImgAlt = $selectedTwinWire + $firstAlt;

    // Hide product image
    $coverImg.hide();
    $twinWireImg.hide();
    $paperImg.hide();

    // Hide text overlay
    $('#personalize-textoverlay-span').show();

    for (var i = 0; i < $coverImg.length; i++) {
      var $thisAltText = $($coverImg[i]).attr('data-img-alt');
      if ($thisAltText == $coverImgAlt) {
        $($coverImg[i]).show();
      }
    }

    for (var i = 0; i < $twinWireImg.length; i++) {
      var $thisAltText = $($twinWireImg[i]).attr('alt');
      if ($thisAltText == $twinWireImgAlt) {
        $($twinWireImg[i]).show();
      }
    }

    // show selected clasp image only
    showClaspImgs();

    // show selected Band image only
    showBandImgs();

    // show selected Flap image only
    showFlapImgs();
  }

  showAddToCartBtn();
}

showAddToCartBtn = () =>{
  // Hide and show button between Next and Add To Cart
  var $nextBtn = $('#next_step');
  var $addToCartBtn = $('#fianl_step');
  if ($('.tab-container').children('.is-tab').hasClass('gift-tab')) {
    $nextBtn.hide();
    $addToCartBtn.show();
  } else {
    $nextBtn.show();
    $addToCartBtn.hide();
  }
}
showClaspImgs = () =>{
  var $selectedClaspColour = $('.clasp-color-radio:checked').val();
  var $selectedClaspString = $('.clasp-string-radio:checked').val();
  var $selectedClaspEyelet = $('.clasp-eyelet-radio:checked').val();
  var $selectedClasp = $('.add-ons-radio:checked').attr('data-addon');

  var $claspColorImg = $('.clasp-color-img');
  var $claspStringImg = $('.string-color-img');
  var $claspEyeletImg = $('.eyelet-color-img');

  if ($selectedClasp == '1') {
    loopAddonsImgToShow($claspColorImg,$selectedClaspColour);
    loopAddonsImgToShow($claspStringImg,$selectedClaspString);
    loopAddonsImgToShow($claspEyeletImg,$selectedClaspEyelet);
  } else {
    $claspColorImg.hide();
    $claspStringImg.hide();
    $claspEyeletImg.hide();
  }
}

showBandImgs = () =>{
  var $selectedBandColour = $('.band-color-radio:checked').val();
  var $selectedBandRivet = $('.band-rivert-color-radio:checked').val();
  var $selectedBand = $('.add-ons-radio:checked').attr('data-addon');

  var $bandColorImg = $('.band-color-img');
  //var $bandRivetImg = $('.band-rivet-img');

  if ($selectedBand == '3') {
    loopAddonsImgToShow($bandColorImg,$selectedBandColour);
    //loopAddonsImgToShow($bandRivetImg,$selectedBandRivet);
  } else {
    $bandColorImg.hide();
    //$bandRivetImg.hide();
  }
}

showFlapImgs = () =>{
  var $selectedFlapColour = $('.flap-color-radio:checked').val();
  var $selectedFlapRivet = $('.rivet-color-radio:checked').val();
  var $selectedFlap = $('.add-ons-radio:checked').attr('data-addon');

  var $flapColorImg = $('.flap-color-img');
  var $flapRivetImg = $('.flap-rivet-img');

  var $isPaperContainer = $('.tab-container').children('.is-tab').hasClass('paper-swatch-tab');
  // check which tab we are in and decided if to show 1st img or 2nd set img
  if ($isPaperContainer) {
    // if in paper tab show 2nd set img of flap add ons

    var $noPaperAlt1 = $selectedFlapColour + '-2';
    var $noPaperAlt2 = $selectedFlapRivet + '-2';
    if ($selectedFlap == '2') {
      /*
      loopAddonsImgToShow($flapColorImg,$noPaperAlt1);
      loopAddonsImgToShow($flapRivetImg,$noPaperAlt2);
      */
      $flapColorImg.hide();
      $flapRivetImg.hide();
    } else {
      $flapColorImg.hide();
      $flapRivetImg.hide();
    }
  } else {
    // if not in paper tab show 1st set img of flap add ons

    var $noPaperAlt1 = $selectedFlapColour + '-1';
    var $noPaperAlt2 = $selectedFlapRivet + '-1';
    if ($selectedFlap == '2') {
      loopAddonsImgToShow($flapColorImg,$noPaperAlt1);
      loopAddonsImgToShow($flapRivetImg,$noPaperAlt2);
    } else {
      $flapColorImg.hide();
      $flapRivetImg.hide();
    }
  }
}

loopAddonsImgToShow = (imgs, altText) =>{
  // first hide images
  imgs.hide();

  // show the selected images
  for (var i = 0; i < imgs.length; i++) {
    var $thisAltText = $(imgs[i]).attr('alt');
    if ($thisAltText == altText) {
      $(imgs[i]).show();
    }
  }
}

previousTab = (evt) =>{
  $('.next_addon_error').hide();
  var $this = $(evt);
  var $tabContainer = $('.tab-container');

  $('#next_step').prop('disabled', false);

  $tabContainer.children('.is-tab').hide().removeClass('is-tab').prev().show().addClass('is-tab');

  if ($tabContainer.children('.is-tab').prev().length == 0) {
    $this.prop('disabled', true).css('visibility', 'hidden');
  }
  swapFrontBackImg($tabContainer.children('.is-tab').hasClass('paper-swatch-tab'));
  if ($tabContainer.children('.is-tab').hasClass('add-ons-tab') == false) {
    $('#next_step').attr('onclick', 'nextTab(this); scrollToTop();');
    $('#next_step').removeClass('next_disabled');
  }
}
nextTab = (evt) =>{
  $('.next_addon_error').hide();
  var $this = $(evt);
  var $tabContainer = $('.tab-container');

  $('#previous_step').prop('disabled', false).css('visibility', 'visible');

  $tabContainer.children('.is-tab').hide().removeClass('is-tab').next().show().addClass('is-tab');


  if ($tabContainer.children('.is-tab').next().length == 0) {
    $this.prop('disabled', true);
  }
  swapFrontBackImg($tabContainer.children('.is-tab').hasClass('paper-swatch-tab'));

  if ($tabContainer.children('.is-tab').hasClass('add-ons-tab')) {
  checkAddons();
  }
}

selectSwatch = (evt,color) =>{
  var $this = $(evt).find('label');
  var $twinWireImg = $('.twin-wire-img');
  var $colorSwatch = $('.twin-wire-swatch');
  var $colorSwatchimg = $this.find('img').attr('src');
  var $selectedColor = color + '-1';

  // hide all twin wire img
  $twinWireImg.hide();

  // add border to the selected swatch
  $colorSwatch.css('border', 'none');
  $this.css('border', '1px solid #000');
  $(evt).parent().find('.dropdownlistcnb').removeClass('dropdownactive');
  $(evt).addClass('dropdownactive');
  $(evt).find('input').prop('checked', true);

  // add selected twin wire color text
  $('#twin-wire-color-span').html('<div><label class="twin-wire-swatch"><img src="'+ $colorSwatchimg +'" class="full-height" alt=""><span class="u-visually-hidden">Black</span></label>' + color + '</div>+');

  for (var i = 0; i < $twinWireImg.length; i++) {
    var $thisAltText = $($twinWireImg[i]).attr('alt');
    if ($thisAltText == $selectedColor) {
      $($twinWireImg[i]).show();
    }
  }
}

clickPaperBtn = (evt) =>{
  var $selectedSwatch = $(evt).parent().find('.cnb-popup-color').text();
  console.log('$selectedSwatch',$selectedSwatch);
  var $allPaperSwatch = $('.paper-swatch-tab .paper-swatch');

    $allPaperSwatch.each(function(){
      var $paperSwatch = $(this).attr('data-tooltip');
      if ($paperSwatch == $selectedSwatch) {
        console.log('$paperSwatch',$paperSwatch);
        $(this).click();
      }
    });
    // close popup
    $('jsc-cnb-popup').hide();
}

openPaperPopup = (evt, btnText, popuptype) =>{
  event.stopPropagation();

  if (popuptype == 'addon') {
    var $this = $(evt);
    var $paperColor = $this.parent('.category-label').attr('data-tooltip');
    var $paperDesc = $this.parent('.category-label').attr('data-description');
    var $paperImg = $this.parent('.category-label').attr('data-imgsrc').split(',');
    var $stepNo = $this.closest('.add-ons-tab').find('.stepcount').text();
  
    // Replace popup content
    $('jsc-cnb-popup').find('.jsc-cnb-popup-left').children().remove();
    $('jsc-cnb-popup').find('.cnb-popup-header .stepcount').text($stepNo);
    $('jsc-cnb-popup').find('.cnb-popup-header .steptitle').text('Add-on:');
    $('jsc-cnb-popup').find('.jsc-cnb-popup-left').append('<div class="flickitypopupaddon"></div>');
    $('jsc-cnb-popup').find('.jsc-cnb-popup-left').append('<div class="flickitypopupaddonthumbnail"></div>');
    for (var i = 0; i < $paperImg.length; i++) {
      $('jsc-cnb-popup').find('.flickitypopupaddon').append('<img class="paper-img-popup" src="'+$paperImg[i]+'">');
      $('jsc-cnb-popup').find('.flickitypopupaddonthumbnail').append('<img class="paper-img-popup-thumbnail" src="'+$paperImg[i]+'">');
    }
    setTimeout(function(){
      $('.flickitypopupaddon').flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        wrapAround: false,
        draggable: false,
        groupCells: true,
        imagesLoaded: true,
        prevNextButtons: false
      });

      // Flickity instance
      var flkty = $('.flickitypopupaddon').data('flickity');
      // elements
      var $cellButtonGroup = $('.flickitypopupaddonthumbnail');
      var $cellButtons = $cellButtonGroup.find('.paper-img-popup-thumbnail');

      // update selected cellButtons
      $('.flickitypopupaddon').on( 'select.flickity', function() {
        $cellButtons.filter('.is-selected')
          .removeClass('is-selected');
        $cellButtons.eq( flkty.selectedIndex )
          .addClass('is-selected');
      });

      // select cell on button click
      $cellButtonGroup.on( 'click', '.paper-img-popup-thumbnail', function() {
        var index = $(this).index();
        $('.flickitypopupaddon').flickity( 'select', index );
      });
      
      // previous
      $('.button--previous').on( 'click', function() {
        $('.flickitypopupaddon').flickity('previous');
      });
      // next
      $('.button--next').on( 'click', function() {
        $('.flickitypopupaddon').flickity('next');
      });

      $('.flickitypopupaddonthumbnail').flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        wrapAround: false,
        draggable: false,
        groupCells: true,
        imagesLoaded: true,
        prevNextButtons: false
      });

    },10);
    $('jsc-cnb-popup').find('.jsc-cnb-popup-right').find('.cnb-popup-color').text($paperColor);
    $('jsc-cnb-popup').find('.jsc-cnb-popup-right').find('.cnb-popup-description').html($paperDesc);
    $('jsc-cnb-popup').find('.jsc-cnb-popup-right').find('.cnb-popup-select-btn').hide();
    // open popup
    $('jsc-cnb-popup').show();
  }else{
  var $this = $(evt);
  var $paperColor = $this.parent('.paper-swatch').attr('data-tooltip');
  var $paperDesc = $this.parent('.paper-swatch').attr('data-description');
  var $paperImg = $this.parent('.paper-swatch').attr('data-imgsrc').split(',');
  var $stepNo = $this.closest('.paper-swatch-tab').find('.stepcount').text();
 
  // Replace popup content
  $('jsc-cnb-popup').find('.jsc-cnb-popup-left').children().remove();
  $('jsc-cnb-popup').find('.cnb-popup-header .stepcount').text($stepNo);
  $('jsc-cnb-popup').find('.cnb-popup-header .steptitle').text('Paper:');
  $('jsc-cnb-popup').find('.jsc-cnb-popup-left').append('<div class="flickitypopupaddon"></div>');
  $('jsc-cnb-popup').find('.jsc-cnb-popup-left').append('<div class="flickitypopupaddonthumbnail"></div>');
  for (var i = 0; i < $paperImg.length; i++) {
    $('jsc-cnb-popup').find('.flickitypopupaddon').append('<img class="paper-img-popup" src="'+$paperImg[i]+'">');
    $('jsc-cnb-popup').find('.flickitypopupaddonthumbnail').append('<img class="paper-img-popup-thumbnail" src="'+$paperImg[i]+'">');
  }
  setTimeout(function(){
    $('.flickitypopupaddon').flickity({
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: false,
      draggable: false,
      groupCells: true,
      imagesLoaded: true,
      prevNextButtons: false
    });

    // Flickity instance
    var flkty = $('.flickitypopupaddon').data('flickity');
    // elements
    var $cellButtonGroup = $('.flickitypopupaddonthumbnail');
    var $cellButtons = $cellButtonGroup.find('.paper-img-popup-thumbnail');

    // update selected cellButtons
    $('.flickitypopupaddon').on( 'select.flickity', function() {
      $cellButtons.filter('.is-selected')
        .removeClass('is-selected');
      $cellButtons.eq( flkty.selectedIndex )
        .addClass('is-selected');
    });

    // select cell on button click
    $cellButtonGroup.on( 'click', '.paper-img-popup-thumbnail', function() {
      var index = $(this).index();
      $('.flickitypopupaddon').flickity( 'select', index );
    });
    
    // previous
    $('.button--previous').on( 'click', function() {
      $('.flickitypopupaddon').flickity('previous');
    });
    // next
    $('.button--next').on( 'click', function() {
      $('.flickitypopupaddon').flickity('next');
    });

    $('.flickitypopupaddonthumbnail').flickity({
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: false,
      draggable: false,
      groupCells: true,
      imagesLoaded: true,
      prevNextButtons: false
    });

  },10);
  $('jsc-cnb-popup').find('.jsc-cnb-popup-right').find('.cnb-popup-color').text($paperColor);
  $('jsc-cnb-popup').find('.jsc-cnb-popup-right').find('.cnb-popup-description').html($paperDesc);
  if (btnText){
    $('jsc-cnb-popup').find('.jsc-cnb-popup-right').find('.cnb-popup-select-btn').text(btnText);
    $('jsc-cnb-popup').find('.jsc-cnb-popup-right').find('.cnb-popup-select-btn').show();
    $('jsc-cnb-popup').find('.jsc-cnb-popup-right').find('.cnb-popup-select-btn').attr('onclick', 'clickPaperBtn(this)');
  }
  // open popup
  $('jsc-cnb-popup').show();
  }

}

selectPaperSwatch = (evt,color) =>{
  var $this = $(evt);
  var $paperImg = $('.paper-img');
  var $colorSwatch = $('.paper-swatch');
  // var $selectedColor = color + '-1';

  // hide all paper img
  $paperImg.hide();

  // add border to the selected swatch
  $colorSwatch.css('border', 'none');
  $this.css('border', '1px solid #89714B');

  // add selected paper color text
  $('#paper-span').text(color);

  for (var i = 0; i < $paperImg.length; i++) {
    var $thisAltText = $($paperImg[i]).attr('alt');
    if ($thisAltText == color) {
      $($paperImg[i]).show();
    }
  }
}

onInputType = (evt) =>{
  var $this = $(evt);
  var $textVal = $this.val();
  var $textOverlay = $('#personalize-textoverlay-span');
  // var $fontFamily = $('#personalize-font-family-select').val(); // missing value
  // var $fontSize = $('#personalize-font-size-select').find(':selected').text();  // missing value
  var $fontFamily = $('.font-type-container').find('.jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-font-name');
  var $fontSize = $('.font-type-container').find('.jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-size');
  console.log($textVal,'in font:',$fontFamily,$fontSize);
  // Disable special character
  var regex = new RegExp("['.&a-zA-Z0-9]+$");
  if ($fontFamily == 'Copperplate' && $fontSize == '10mm') {
    var temp = $textVal.replace(/[^'.&a-zA-Z\s]/g, '').replaceAll('*', '').replaceAll('+', '').replaceAll("'", "").replace(/[0-9]/g, '');
  } else if ($fontFamily == 'Script Sentence' && $fontSize == '6mm'){
    var temp = $textVal.replace(/[^'.&a-zA-Z0-9\s]/g, '').replaceAll('*', '').replaceAll('+', '').replaceAll("'", "").replaceAll('.', '');
  } else {
    var temp = $textVal.replace(/[^'.&a-zA-Z0-9\s]/g, '').replaceAll('*', '').replaceAll('+', '');
  }

  var _maxPersonalize = parseInt($this.attr('maxlength'), 10);
  if (!isNaN(_maxPersonalize) && _maxPersonalize >= 1 && temp.length > _maxPersonalize) {
    temp = temp.slice(0, _maxPersonalize);
  }

  $this.val(temp);
  $textOverlay.text(temp);

  // Count character
  var $charCount = $('#charCount');
  var $limit = $this.attr('maxlength');
  var $textLength = temp.length;
  var $charLeft = 0;
  $charLeft = $limit - $textLength;
  $charCount.text($textLength + '/' + $limit);

}

onClickPosition = (evt) =>{
  var $this = $(evt);
  var $positionLabel = $('.position-label');
  var $textOverlay = $('.personalize-textoverlay-container');
  var $unique = $this.attr('data-unique');
  var $position = $this.attr('data-tooltip');
  var $sizeText = $('#personalize-font-size-select').find(':selected').text();
  var $fontFamily = $('#personalize-font-family-select').val();

  var $allpositionBtn = $('.text-tip-label');
  $this.addClass('position_active');

    $allpositionBtn.each(function(){
      var $_this = $(this);
      var $toolTip = $_this.attr('data-tooltip');
      if ($toolTip != $position ) {
        $_this.removeClass('position_active');
      }
    });

  // Position the text overlay
  var $top = $this.attr('data-top');
  var $left = $this.attr('data-left');
  var $transformTop = $this.attr('data-transform-top');
  var $transformLeft = $this.attr('data-transform-left');

  $textOverlay.attr('style', 'transform: translate(-'+$transformLeft+'%,-'+$transformTop+'%)');
  $textOverlay.css('top', $top+'%');
  $textOverlay.css('left', $left+'%');

  if ($unique != null && $unique != '' && $unique != undefined) {
    if ($unique.includes($sizeText) && $unique.includes($fontFamily)) {

      var $arryuniq = $unique.split(',');
      var $uniqtransLeft = $arryuniq[$arryuniq.length-1];
      $textOverlay.attr('style', 'transform: translate(-'+$uniqtransLeft+'%,-'+$transformTop+'%)');
      $textOverlay.css('top', $top+'%');
      $textOverlay.css('left', $left+'%');
    }
  }


}

onClickFoilColor = (evt) =>{
  var $this = $(evt);
  var $colorCode = $this.attr('data-color-code');
  var $colortype = $this.attr('data-tooltip');
  var $textOverlay = $('#personalize-textoverlay-span');
  var $foilLabel = $('.foil-label');
  var $texture_url = $this.attr('data-texture');
  var $backgroundTexture = "-webkit-linear-gradient(top, transparent, transparent), url('"+ $texture_url +"') center center no-repeat";
  $(".showFoil").html($colortype);

  // Change overlay text color
  $textOverlay.css('color',$colorCode);
  $textOverlay.css('opacity', ' ');
  $textOverlay.css('background',$backgroundTexture);

  // Unselect all border for foil label
  $foilLabel.css('border', '2px solid #ededed');

  // Add border to the selected foil label
  $this.css('border', '2px solid #000000');

  if ($colortype == 'Deboss' || $colortype == 'Blind Deboss') {
    var colorvar = $('.jsc-col-var input:checked').val();
    var hasdebosscol = false;

    $('.deboss-color-data').each(function(){
      var varcol = $(this).val();
      var coldeboss = $(this).attr('data-coldeboss');
      if (colorvar == varcol) {
        $textOverlay.css('background', coldeboss);
        hasdebosscol = true;
      }
    });

    if (hasdebosscol == false) {
      $textOverlay.css('background', '#666666');
    }
    $textOverlay.css('color', 'transparent');
    $textOverlay.css('opacity', '1');
    $textOverlay.show();
  }

}
checkAddons = () =>{
  var $nextBtn = $('#next_step');
  setTimeout(function(){
    var $addOnOption = $('.add-ons-radio:checked').val();

    if ($addOnOption == 'no-addons') {
      $nextBtn.prop('disabled', false);
      $nextBtn.attr('onclick', 'nextTab(this); scrollToTop();');
      $nextBtn.removeClass('next_disabled');
    }
    if ($addOnOption == 'Clasp') {
      if ( $('.clasp-color-radio:checked').length > 0 && $('.clasp-string-radio:checked').length > 0 && $('.clasp-eyelet-radio:checked').length > 0) {
        $nextBtn.prop('disabled', false);
        $nextBtn.attr('onclick', 'nextTab(this); scrollToTop();');
        $nextBtn.removeClass('next_disabled');
      } else {
        $nextBtn.attr('onclick', 'checkAddonsclick();');
        $nextBtn.addClass('next_disabled');
        //$nextBtn.prop('disabled', true);
      }
    }
    if ($addOnOption == 'Closing Flap') {
      if ( $('.flap-color-radio:checked').length > 0 && $('.rivet-color-radio:checked').length > 0) {
        $nextBtn.prop('disabled', false);
        $nextBtn.attr('onclick', 'nextTab(this); scrollToTop();');
        $nextBtn.removeClass('next_disabled');
      } else {
        $nextBtn.attr('onclick', 'checkAddonsclick();');
        $nextBtn.addClass('next_disabled');
        //$nextBtn.prop('disabled', true);
      }
    }
    if ($addOnOption == 'Elastic Band') {
      if ( $('.band-color-radio:checked').length > 0 && $('.band-rivert-color-radio:checked').length > 0) {
        $nextBtn.prop('disabled', false);
        $nextBtn.attr('onclick', 'nextTab(this); scrollToTop();');
        $nextBtn.removeClass('next_disabled');
      } else {
        $nextBtn.attr('onclick', 'checkAddonsclick();');
        $nextBtn.addClass('next_disabled');
        //$nextBtn.prop('disabled', true);
      }
    }
  },300);
}

checkAddonsclick = () =>{
  var $addOnOption = $('.add-ons-radio:checked').val();
    if ($addOnOption == 'Clasp') {
      if ( $('.clasp-color-radio:checked').length > 0 && $('.clasp-string-radio:checked').length > 0 && $('.clasp-eyelet-radio:checked').length > 0) {
      } else {
        $('.next_addon_error').text('* Please make sure to select all necessary color option for addon.');
        $('.next_addon_error').show();
        setTimeout(function(){
          $('.next_addon_error').hide();
        },2500);
      }
    }
    if ($addOnOption == 'Closing Flap') {
      if ( $('.flap-color-radio:checked').length > 0 && $('.rivet-color-radio:checked').length > 0) {
      } else {
        $('.next_addon_error').text('* Please make sure to select all necessary color option for addon.');
        $('.next_addon_error').show();
        setTimeout(function(){
          $('.next_addon_error').hide();
        },2500);
      }
    }
    if ($addOnOption == 'Elastic Band') {
      if ( $('.band-color-radio:checked').length > 0 && $('.band-rivert-color-radio:checked').length > 0) {
      } else {
        $('.next_addon_error').text('* Please make sure to select all necessary color option for addon.');
        $('.next_addon_error').show();
        setTimeout(function(){
          $('.next_addon_error').hide();
        },2500);
      }
    }
}

selectAddons = (evt) =>{
  var $this = $(evt);
  var $containerVal = $this.attr('data-container');
  var $addOnContainers = $('.addons-containers');
  var $addOnLabel = $('.category-label');
  var $claspImg = $('.clasp-img');
  var $bandImg = $('.band-img');
  var $flapImg = $('.flap-img');
  var $addonsName = $this.attr('data-tooltip');

  // Display selection text
  $('#addons-span').text($addonsName);

  // Hide all addons swatch container and gray out all border
  $addOnContainers.hide();
  $addOnLabel.css('border', '1px solid transparent');

  // Only show selected swatch for add ons and change label border to black
  $('.'+$containerVal).show();
  $this.css('border', '1px solid #89714B');

  // Hide add ons images
  $claspImg.hide();
  $bandImg.hide();
  $flapImg.hide();

  // Hide text position option
  if ($addonsName == 'Elastic Band') {
    var $textPos = $('.notebook-tab.personalize-tab .layout-container .jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-val');
    $('.jsc-hide-elastic').hide();
    if ($textPos == 'Top Right' || $textPos == 'Bottom Right') {
      $('.jsc-select-isElastic').click();
    }
  } else {
    $('.jsc-hide-elastic').show();
  }

  setTimeout(function(){
    showClaspImgs();
    showBandImgs();
    showFlapImgs();
  },300);
  checkAddons();
}
addonTitle = (val,ele) =>{
  ele.text(val);
}
selectClaspColor = (evt,selectVal) =>{
  var $this = $(evt).find('label');
  var $claspColorImg = $('.clasp-color-img');
  var $claspColorLabel = $('.clasp-color-label');
  var $selectedVal = $this.attr('data-tooltip');
  var $imgUrl = $this.attr('data-img-url');
  var $colorSwatchimg = $this.find('img').attr('src');

  // Border styling
  $claspColorLabel.css('border', 'none');
  $this.css('border', '1px solid #000');
  $(evt).parent().find('.dropdownlistcnb').removeClass('dropdownactive');
  $(evt).addClass('dropdownactive');
  $(evt).find('input').prop('checked', true);

  $(evt).parents('.stepselected').find('.selecteddropdown').html('<div><label for="black" class="twin-wire-swatch" data-tooltip="Black" style="background: black;"><img src="'+ $colorSwatchimg +'" class="full-height" alt=""><span class="u-visually-hidden">Black</span></label>' + selectVal + '</div>+');

  // hide all images
  $claspColorImg.hide();

  // loopAddonsImgToShow($claspColorImg,selectVal);
  appendImg($claspColorImg, $imgUrl, $selectedVal, true);
  addonTitle($selectedVal,$('#clasp-color-span'));
  checkAddons();
}
selectClaspString = (evt,selectVal) =>{
  var $this = $(evt).find('label');
  var $claspColorImg = $('.string-color-img');
  var $claspStringLabel = $('.clasp-string-label');
  var $selectedVal = $this.attr('data-tooltip');
  var $imgUrl = $this.attr('data-img-url');
  var $colorSwatchimg = $this.find('img').attr('src');

  // Border styling
  $claspStringLabel.css('border', 'none');
  $this.css('border', '1px solid #000');
  $(evt).parent().find('.dropdownlistcnb').removeClass('dropdownactive');
  $(evt).addClass('dropdownactive');
  $(evt).find('input').prop('checked', true);

  $(evt).parents('.stepselected').find('.selecteddropdown').html('<div><label for="black" class="twin-wire-swatch" data-tooltip="Black" style="background: black;"><img src="'+ $colorSwatchimg +'" class="full-height" alt=""><span class="u-visually-hidden">Black</span></label>' + selectVal + '</div>+');

  // hide all images
  $claspColorImg.hide();

  appendImg($claspColorImg, $imgUrl, $selectedVal, true);
  // loopAddonsImgToShow($claspColorImg,selectVal);
  addonTitle($selectedVal,$('#clasp-string-span'));
  checkAddons();
}
selectClaspEyelet = (evt,selectVal) =>{
  var $this = $(evt).find('label');
  var $claspColorImg = $('.eyelet-color-img');
  var $claspEyeletLabel = $('.clasp-eyelet-label');
  var $selectedVal = $this.attr('data-tooltip');
  var $imgUrl = $this.attr('data-img-url');
  var $colorSwatchimg = $this.find('img').attr('src');

  // Border styling
  $claspEyeletLabel.css('border', 'none');
  $this.css('border', '1px solid #000');
  $(evt).parent().find('.dropdownlistcnb').removeClass('dropdownactive');
  $(evt).addClass('dropdownactive');
  $(evt).find('input').prop('checked', true);

  $(evt).parents('.stepselected').find('.selecteddropdown').html('<div><label for="black" class="twin-wire-swatch" data-tooltip="Black" style="background: black;"><img src="'+ $colorSwatchimg +'" class="full-height" alt=""><span class="u-visually-hidden">Black</span></label>' + selectVal + '</div>+');

  // hide all images
  $claspColorImg.hide();

  appendImg($claspColorImg, $imgUrl, $selectedVal, true);
  // loopAddonsImgToShow($claspColorImg,selectVal);
  addonTitle($selectedVal,$('#clasp-eyelet-span'));
  checkAddons();
}

appendImg = (e, url, alt, isShow) =>{
  e.attr('src', url);
  e.attr('alt', alt);
  if (isShow) {
    e.show();
  }
}
selectBandColor = (evt,selectVal) =>{
  var $this = $(evt).find('label');
  var $bandColorImg = $('.band-color-img');
  var $bandColorLabel = $('.band-label');
  var $selectedVal = $this.attr('data-tooltip');
  var $imgUrl = $this.attr('data-img-url');
  var $colorSwatchimg = $this.find('img').attr('src');

  // Border styling
  $bandColorLabel.css('border', 'none');
  $this.css('border', '1px solid #000');
  $(evt).parent().find('.dropdownlistcnb').removeClass('dropdownactive');
  $(evt).addClass('dropdownactive');
  $(evt).find('input').prop('checked', true);

  $(evt).parents('.stepselected').find('.selecteddropdown').html('<div><label for="black" class="twin-wire-swatch" data-tooltip="Black" style="background: black;"><img src="'+ $colorSwatchimg +'" class="full-height" alt=""><span class="u-visually-hidden">Black</span></label>' + selectVal + '</div>+');

  // hide all images
  $bandColorImg.hide();

  appendImg($bandColorImg, $imgUrl, $selectedVal, true);
  // loopAddonsImgToShow($bandColorImg,selectVal);
  addonTitle($selectedVal,$('#band-color-span'));
  checkAddons();
}
selectBandRivet = (evt,selectVal) =>{
  var $this = $(evt).find('label');
  //var $bandRivetImg = $('.band-rivet-img');
  var $bandRivetLabel = $('.band-revert-label');
  var $selectedVal = $this.attr('data-tooltip');
  var $imgUrl = $this.attr('data-img-url');
  var $colorSwatchimg = $this.find('img').attr('src');

  // Border styling
  $bandRivetLabel.css('border', 'none');
  $this.css('border', '1px solid #000');
  $(evt).parent().find('.dropdownlistcnb').removeClass('dropdownactive');
  $(evt).addClass('dropdownactive');
  $(evt).find('input').prop('checked', true);

  $(evt).parents('.stepselected').find('.selecteddropdown').html('<div><label for="black" class="twin-wire-swatch" data-tooltip="Black" style="background: black;"><img src="'+ $colorSwatchimg +'" class="full-height" alt=""><span class="u-visually-hidden">Black</span></label>' + selectVal + '</div>+');

  // hide all images
  //$bandRivetImg.hide();

  //appendImg($bandRivetImg, $imgUrl, $selectedVal, true);
  //loopAddonsImgToShow($bandRivetImg,selectVal);
  addonTitle($selectedVal,$('#band-rivet-span'));
  checkAddons();
}

selectFlapColor = (evt,selectVal) =>{
  var $this = $(evt).find('label');
  var $flapColorImg = $('.flap-color-img');
  var $flapColorLabel = $('.flap-label');
  var $firstImg = selectVal + '-1';
  var $selectedVal = $this.attr('data-tooltip');
  var $imgUrl1 = $this.attr('data-img-url-1');
  var $imgUrl2 = $this.attr('data-img-url-2');
  var $imgEle1 = $('.jsc-flap-color-img-1');
  var $imgEle2 = $('.jsc-flap-color-img-2');
  var $colorSwatchimg = $this.find('img').attr('src');

  // Border styling
  $flapColorLabel.css('border', 'none');
  $this.css('border', '1px solid #000');
  $(evt).parent().find('.dropdownlistcnb').removeClass('dropdownactive');
  $(evt).addClass('dropdownactive');
  $(evt).find('input').prop('checked', true);

  $(evt).parents('.stepselected').find('.selecteddropdown').html('<div><label for="black" class="twin-wire-swatch" data-tooltip="Black" style="background: black;"><img src="'+ $colorSwatchimg +'" class="full-height" alt=""><span class="u-visually-hidden">Black</span></label>' + selectVal + '</div>+');

  // hide all images
  $flapColorImg.hide();
  $imgEle1.hide();
  $imgEle2.hide();

  appendImg($imgEle1, $imgUrl1, $selectedVal+'-1', true);
  appendImg($imgEle2, $imgUrl2, $selectedVal+'-2', false);
  // loopAddonsImgToShow($flapColorImg,$firstImg);
  addonTitle($selectedVal,$('#flap-color-span'));
  checkAddons();
}
selectFlapRivet = (evt,selectVal) =>{
  var $this = $(evt).find('label');
  var $flapRivetImg = $('.flap-rivet-img');
  var $flapRivetLabel = $('.rivet-label');
  var $firstImg = selectVal + '-1';
  var $selectedVal = $this.attr('data-tooltip');
  var $imgUrl1 = $this.attr('data-img-url-1');
  var $imgUrl2 = $this.attr('data-img-url-2');
  var $imgEle1 = $('.jsc-flap-rivet-img-1');
  var $imgEle2 = $('.jsc-flap-rivet-img-2');
  var $colorSwatchimg = $this.find('img').attr('src');

  // Border styling
  $flapRivetLabel.css('border', 'none');
  $this.css('border', '1px solid #000');
  $(evt).parent().find('.dropdownlistcnb').removeClass('dropdownactive');
  $(evt).addClass('dropdownactive');
  $(evt).find('input').prop('checked', true);

  $(evt).parents('.stepselected').find('.selecteddropdown').html('<div><label for="black" class="twin-wire-swatch" data-tooltip="Black" style="background: black;"><img src="'+ $colorSwatchimg +'" class="full-height" alt=""><span class="u-visually-hidden">Black</span></label>' + selectVal + '</div>+');

  // hide all images
  $flapRivetImg.hide();
  $imgEle1.hide();
  $imgEle2.hide();

  appendImg($imgEle1, $imgUrl1, $selectedVal+'-1', true);
  appendImg($imgEle2, $imgUrl2, $selectedVal+'-2', false);
  // loopAddonsImgToShow($flapRivetImg,$firstImg);
  addonTitle($selectedVal,$('#flap-rivet-span'));
  checkAddons();
}

// --- Custom notebook: edit personalisation from cart ---
var CNB_EDIT_STORAGE_KEY = 'bynd_cnb_edit_personalisation';

hasNotebookEditUrlFlag = () => {
  try {
    return new URLSearchParams(window.location.search).get('edit_personalisation') === '1';
  } catch (e) {
    return /[?&]edit_personalisation=1(?:&|$)/.test(String(window.location.search));
  }
};

readNotebookEditSession = () => {
  try {
    var raw = sessionStorage.getItem(CNB_EDIT_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
};

clearNotebookEditContext = () => {
  try {
    sessionStorage.removeItem(CNB_EDIT_STORAGE_KEY);
  } catch (e) {}
  $('body').removeClass('cnb-edit-personalisation-mode');
  $('#cnb-edit-line-key').remove();
  $('#cnb-edit-bind-id').remove();
  $('#cnb-edit-quantity').remove();
  $('#cnb-edit-type').remove();
  var $atc = $('#fianl_step.atc-notebook-btn, #fianl_step');
  if ($atc.length) {
    $atc.val('Add To Cart');
    $atc.attr('value', 'Add To Cart');
  }
  var $leatherAtc = $('#addCostPrice');
  if ($leatherAtc.length && !$leatherAtc.hasClass('sold_out_personalize')) {
    $leatherAtc.text('add to cart');
  }
  try {
    if (hasNotebookEditUrlFlag() && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.delete('edit_personalisation');
      url.searchParams.delete('edit_line');
      url.searchParams.delete('edit_type');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }
  } catch (e) {}
};

getPersonalisationEditTypeFromUrl = () => {
  try {
    return new URLSearchParams(window.location.search).get('edit_type') || '';
  } catch (e) {
    var m = String(window.location.search).match(/[?&]edit_type=([^&]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
};

isNotebookEditPage = () => {
  return $('.notebook-tab').length > 0 || $('#fianl_step.atc-notebook-btn').length > 0 || $('#fianl_step').length > 0;
};

isLeatherEditPage = () => {
  return $('#leather-text').length > 0 || $('#isPersonalisation').length > 0 || $('#addCostPrice').length > 0;
};

/** Edit mode when URL has edit_personalisation=1 and we have (or can load) payload. */
getActiveNotebookEditContext = () => {
  if (!hasNotebookEditUrlFlag()) return null;

  var ctx = readNotebookEditSession();
  if (!ctx || !ctx.properties) return null;

  var editType = ctx.editType || getPersonalisationEditTypeFromUrl() || '';
  if (editType === 'leather') {
    if (!isLeatherEditPage()) return null;
  } else if (editType === 'notebook') {
    if (!isNotebookEditPage()) return null;
  } else if (!isNotebookEditPage() && !isLeatherEditPage()) {
    return null;
  }

  var pathMatch = String(window.location.pathname).match(/\/products\/([^/?#]+)/);
  var currentHandle = (
    (pathMatch && pathMatch[1] ? decodeURIComponent(pathMatch[1]) : '')
    || ''
  ).toString();

  if (ctx.productHandle && currentHandle && ctx.productHandle !== currentHandle) {
    return null;
  }

  return ctx;
};

getNotebookEditLineKeyFromUrl = () => {
  try {
    return new URLSearchParams(window.location.search).get('edit_line') || '';
  } catch (e) {
    var m = String(window.location.search).match(/[?&]edit_line=([^&]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
};

/** True when cart edit context is leatherAddToCart (incl. complimentary Cost-$0P lines). */
isLeatherPersonalisationEditContext = (ctx) => {
  if (!ctx) return false;
  if (ctx.editType === 'leather') return true;
  if (ctx.editType === 'notebook') return false;
  var props = ctx.properties || {};
  if (props['Paper'] || props['Twin Wire']) return false;
  if (props['Main Product']) return true;
  if (props['Personalisation'] && (props['Font Type'] || props['Foil Colour'])) return true;
  return false;
};

detectPersonalisationEditTypeFromProps = (props) => {
  props = props || {};
  if (props['Paper'] || props['Twin Wire']) return 'notebook';
  if (props['Main Product']) return 'leather';
  if (props['Personalisation'] && (props['Font Type'] || props['Foil Colour']) && !props['Paper'] && !props['Twin Wire']) {
    return 'leather';
  }
  return 'notebook';
};

buildNotebookEditContextFromCartItem = (item, productHandle) => {
  if (!item) return null;
  var props = item.properties || {};
  return {
    lineKey: item.key,
    bindId: props.BindID || '',
    variantId: item.variant_id,
    quantity: item.quantity || 1,
    productHandle: productHandle || '',
    productId: item.product_id,
    editType: detectPersonalisationEditTypeFromProps(props),
    properties: props
  };
};

resolveNotebookEditContext = (done) => {
  var finish = typeof done === 'function' ? done : function() {};
  if (!hasNotebookEditUrlFlag()) {
    finish(null);
    return;
  }

  var editType = getPersonalisationEditTypeFromUrl();
  var pageOk = editType === 'leather' ? isLeatherEditPage()
    : editType === 'notebook' ? isNotebookEditPage()
    : (isNotebookEditPage() || isLeatherEditPage());
  if (!pageOk) {
    finish(null);
    return;
  }

  var cached = getActiveNotebookEditContext();
  if (cached) {
    finish(cached);
    return;
  }

  var lineKey = getNotebookEditLineKeyFromUrl();
  if (!lineKey) {
    finish(null);
    return;
  }

  fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET', credentials: 'same-origin' })
    .then(function(response) { return response.json(); })
    .then(function(data) {
      var item = (data.items || []).find(function(obj) { return obj.key === lineKey; });
      if (!item) {
        finish(null);
        return;
      }
      var pathMatch = String(window.location.pathname).match(/\/products\/([^/?#]+)/);
      var handle = pathMatch && pathMatch[1] ? decodeURIComponent(pathMatch[1]) : '';
      var ctx = buildNotebookEditContextFromCartItem(item, handle);
      ctx.editType = editType || detectPersonalisationEditTypeFromProps(item.properties || {});
      try {
        sessionStorage.setItem(CNB_EDIT_STORAGE_KEY, JSON.stringify(ctx));
      } catch (e) {}
      finish(ctx);
    })
    .catch(function() { finish(null); });
};

cnbPropLabel = (val) => {
  if (val === undefined || val === null) return '';
  var s = String(val);
  var idx = s.lastIndexOf('-');
  if (idx > 0) {
    var maybeSku = s.slice(idx + 1);
    if (maybeSku && !/\s/.test(maybeSku)) {
      return s.slice(0, idx);
    }
  }
  return s;
};

/** Exact / SKU-safe match — never let "Gold" match "Rose Gold". */
cnbValuesMatch = (candidate, propVal) => {
  if (candidate == null || propVal == null || propVal === '') return false;
  var c = String(candidate).trim();
  var raw = String(propVal).trim();
  if (!c || !raw) return false;
  var label = cnbPropLabel(raw);
  if (c === raw || c === label) return true;
  var cLower = c.toLowerCase();
  if (cLower === raw.toLowerCase() || cLower === label.toLowerCase()) return true;
  // Stored as "Label-SKU" — candidate must equal the full label, not a substring
  if (label && c === label) return true;
  if (raw.indexOf(c + '-') === 0 && cnbPropLabel(raw) === c) return true;
  return false;
};

cnbSkuMatchesProp = (sku, propVal) => {
  if (!sku || propVal == null || propVal === '') return false;
  var s = String(sku).trim();
  var raw = String(propVal).trim();
  if (!s || s.length < 2) return false;
  return raw === s || raw.endsWith('-' + s);
};

cnbFindRadioByProp = ($radios, propVal) => {
  if (!$radios || !$radios.length || propVal == null || propVal === '') return $();
  // Prefer exact value/tooltip matches first (avoids Gold winning over Rose Gold)
  var $exact = $radios.filter(function() {
    var v = String($(this).val() || '');
    var tip = String($(this).next('label').attr('data-tooltip') || $(this).siblings('label').attr('data-tooltip') || '');
    return cnbValuesMatch(v, propVal) || cnbValuesMatch(tip, propVal);
  });
  if ($exact.length) return $exact.first();
  var $bySku = $radios.filter(function() {
    return cnbSkuMatchesProp($(this).attr('data-sku'), propVal);
  });
  return $bySku.first();
};

cnbClickRadioByProp = ($radios, propVal) => {
  var $match = cnbFindRadioByProp($radios, propVal);
  if (!$match.length) return false;

  var id = $match.attr('id');
  var $label = id ? $('label[for="' + id + '"]') : $();
  if ($label.length) {
    $label.first().trigger('click');
  } else {
    $match.prop('checked', true).trigger('click');
  }
  return true;
};

cnbSelectDropdownOption = ($options, matcher) => {
  if (!$options || !$options.length) return false;
  var $match = $options.filter(function() {
    return matcher($(this));
  }).first();
  if (!$match.length) return false;
  $match.trigger('click');
  return true;
};

/** Match addon dropdown radios (band/flap rivet, etc.) and invoke their select* handler. */
cnbSelectAddonDropdownByProp = ($radios, propVal, selectFn) => {
  var $match = cnbFindRadioByProp($radios, propVal);
  if (!$match.length) return false;

  var $row = $match.closest('.dropdownlistcnb');
  if ($row.length && typeof selectFn === 'function') {
    selectFn($row[0], $match.val());
    return true;
  }
  if ($row.length) {
    $row.trigger('click');
    return true;
  }
  $match.prop('checked', true);
  return true;
};

showNotebookEditLoadingOverlay = () => {
  if ($('#cnb-edit-loading-overlay').length) {
    $('#cnb-edit-loading-overlay').addClass('is-visible');
    return;
  }
  var html = ''
    + '<div id="cnb-edit-loading-overlay" class="cnb-edit-loading-overlay is-visible" aria-live="polite" aria-busy="true">'
    +   '<div class="cnb-edit-loading-card">'
    +     '<div class="cnb-edit-loading-spinner" aria-hidden="true"></div>'
    +     '<p class="cnb-edit-loading-text">Loading your personalisation…</p>'
    +   '</div>'
    + '</div>';
  $('body').append(html);
};

hideNotebookEditLoadingOverlay = () => {
  var $overlay = $('#cnb-edit-loading-overlay');
  if (!$overlay.length) return;
  $overlay.removeClass('is-visible');
  setTimeout(function() {
    $overlay.remove();
  }, 250);
};

/** Keep all notebook steps visible (this PDP is stacked, not a one-step wizard). */
showAllNotebookEditSteps = () => {
  var $tabs = $('.tab-container').children('.notebook-tab');
  if ($tabs.length) {
    $tabs.show().addClass('is-tab');
  } else {
    $('.notebook-tab').show();
  }
  $('#previous_step').hide();
  $('#next_step').hide();
  var $atc = $('#fianl_step');
  $atc.show();
  if ($('body').hasClass('cnb-edit-personalisation-mode')) {
    $atc.val('Update');
    $atc.attr('value', 'Update');
  }
};

markNotebookEditModeUi = (ctx) => {
  $('body').addClass('cnb-edit-personalisation-mode');
  if ($('#cnb-edit-line-key').length === 0) {
    $('body').append('<input type="hidden" id="cnb-edit-line-key" value="">');
  }
  if ($('#cnb-edit-bind-id').length === 0) {
    $('body').append('<input type="hidden" id="cnb-edit-bind-id" value="">');
  }
  if ($('#cnb-edit-quantity').length === 0) {
    $('body').append('<input type="hidden" id="cnb-edit-quantity" value="1">');
  }
  if ($('#cnb-edit-type').length === 0) {
    $('body').append('<input type="hidden" id="cnb-edit-type" value="">');
  }
  $('#cnb-edit-line-key').val(ctx.lineKey || '');
  $('#cnb-edit-bind-id').val(ctx.bindId || '');
  $('#cnb-edit-quantity').val(ctx.quantity || 1);
  $('#cnb-edit-type').val(ctx.editType || '');
  var $atc = $('#fianl_step.atc-notebook-btn, #fianl_step');
  if ($atc.length) {
    $atc.val('Update');
    $atc.attr('value', 'Update');
    $atc.show();
  }
  var $leatherAtc = $('#addCostPrice');
  if ($leatherAtc.length && !$leatherAtc.hasClass('sold_out_personalize')) {
    $leatherAtc.text('Update');
  }
};

applyNotebookEditPrefill = (ctx) => {
  if (!ctx || !ctx.properties) return;
  var props = ctx.properties;

  // Mark edit UI first so ATC shows Update even if a later step fails
  markNotebookEditModeUi(ctx);

  try {
  // Cover / variant
  if (ctx.variantId) {
    var $cover = $('.ColorSwatch__Radio[data-id="' + ctx.variantId + '"], .Notebook_ColorSwatch__Radio[data-id="' + ctx.variantId + '"]');
    if ($cover.length) {
      var coverId = $cover.first().attr('id');
      if (coverId) {
        $('label[for="' + coverId + '"]').trigger('click');
      } else {
        $cover.first().prop('checked', true).trigger('change');
      }
      $('input.jsc-mainID-pdp').val(ctx.variantId);
    }
    var $dropdownVar = $('.cover-swatch-tab .dropdown-var[data-id="' + ctx.variantId + '"]');
    if ($dropdownVar.length) {
      $dropdownVar.trigger('click');
    }
  }

  // Twin wire
  if (props['Twin Wire']) {
    cnbClickRadioByProp($('.twin-wire-radio'), props['Twin Wire']);
    var $twChecked = $('.twin-wire-radio:checked');
    if ($twChecked.length) {
      var $twRow = $twChecked.closest('.dropdownlistcnb');
      if ($twRow.length) {
        $twRow.trigger('click');
      }
    }
  }

  // Paper — use selectPaperSwatch so border + #paper-span update
  if (props['Paper']) {
    var paperName = String(props['Paper']);
    var $paperSwatch = $('.paper-swatch').filter(function() {
      return String($(this).attr('data-tooltip')) === paperName
        || String($(this).prev('.paper-radio').val()) === paperName;
    }).first();
    if ($paperSwatch.length) {
      var $paperRadio = $paperSwatch.prev('.paper-radio');
      if ($paperRadio.length) $paperRadio.prop('checked', true);
      if (typeof selectPaperSwatch === 'function') {
        selectPaperSwatch($paperSwatch[0], paperName);
      } else {
        $paperSwatch.trigger('click');
      }
      // Scroll flickity to selected paper if present
      try {
        var $flick = $('.paperswatchflickity');
        if ($flick.length && $flick.data('flickity')) {
          var cellIndex = $flick.find('.paper-swatch').index($paperSwatch);
          if (cellIndex >= 0) $flick.flickity('select', cellIndex, false, true);
        }
      } catch (e) {}
    }
  }

  // Add-ons BEFORE personalisation clicks (font/position used to crash and skip this)
  var addonName = props['Add-on'];
  var $addonRadio = null;
  if (props['Clasp Colour'] || props['Strings'] || props['Eyelet']) {
    $addonRadio = $('.add-ons-radio[data-addon="1"]');
  } else if (props['Flap Colour'] || props['Snap Button Colour']) {
    $addonRadio = $('.add-ons-radio[data-addon="2"]');
  } else if (props['Band Colour']) {
    $addonRadio = $('.add-ons-radio[data-addon="3"]');
  } else if (addonName && addonName !== 'no-addons') {
    $addonRadio = $('.add-ons-radio').filter(function() {
      return String($(this).val()) === String(addonName)
        || String($(this).next('label').attr('data-tooltip') || '').toLowerCase() === String(addonName).toLowerCase();
    }).first();
  }

  if ($addonRadio && $addonRadio.length) {
    var addonId = $addonRadio.attr('id');
    var $addonLabel = addonId ? $('label[for="' + addonId + '"]') : $addonRadio.next('label.category-label');
    if ($addonLabel.length) {
      $addonLabel.first().trigger('click');
    } else {
      $addonRadio.prop('checked', true);
      if (typeof selectAddons === 'function') {
        selectAddons($addonRadio.next('label')[0] || $addonLabel[0]);
      }
    }

    setTimeout(function() {
      if (props['Clasp Colour']) {
        var $clasp = cnbFindRadioByProp($('.clasp-color-radio'), props['Clasp Colour']);
        if ($clasp.length) {
          var $row = $clasp.closest('.dropdownlistcnb');
          if ($row.length) $row.trigger('click');
          else cnbClickRadioByProp($('.clasp-color-radio'), props['Clasp Colour']);
        }
      }
      if (props['Strings']) {
        var $str = cnbFindRadioByProp($('.clasp-string-radio'), props['Strings']);
        if ($str.length) {
          var $srow = $str.closest('.dropdownlistcnb');
          if ($srow.length) $srow.trigger('click');
          else cnbClickRadioByProp($('.clasp-string-radio'), props['Strings']);
        }
      }
      if (props['Eyelet']) {
        cnbClickRadioByProp($('.clasp-eyelet-radio'), props['Eyelet']);
        var $eye = $('.clasp-eyelet-radio:checked').closest('.dropdownlistcnb');
        if ($eye.length) $eye.trigger('click');
      }
      if (props['Flap Colour']) {
        var $flap = cnbFindRadioByProp($('.flap-color-radio'), props['Flap Colour']);
        if ($flap.length) {
          var $frow = $flap.closest('.dropdownlistcnb');
          if ($frow.length) $frow.trigger('click');
        }
        // Flap snap/rivet — only .rivet-color-radio (not band)
        var flapRivet = props['Snap Button Colour'] || props['Rivet Colour'];
        if (flapRivet) {
          cnbSelectAddonDropdownByProp($('.rivet-color-radio'), flapRivet, typeof selectFlapRivet === 'function' ? selectFlapRivet : null);
        }
      }
      if (props['Band Colour']) {
        var $band = cnbFindRadioByProp($('.band-color-radio'), props['Band Colour']);
        if ($band.length) {
          var $brow = $band.closest('.dropdownlistcnb');
          if ($brow.length && typeof selectBandColor === 'function') {
            selectBandColor($brow[0], $band.val());
          } else if ($brow.length) {
            $brow.trigger('click');
          }
        }
        // Band rivet — only .band-rivert-color-radio (after band colour)
        var bandRivet = props['Rivet Colour'];
        if (bandRivet) {
          setTimeout(function() {
            cnbSelectAddonDropdownByProp(
              $('.band-rivert-color-radio'),
              bandRivet,
              typeof selectBandRivet === 'function' ? selectBandRivet : null
            );
          }, 150);
        }
      } else if (props['Rivet Colour'] && !props['Flap Colour'] && !props['Snap Button Colour']) {
        // Rivet only (band path without Band Colour key edge case)
        cnbSelectAddonDropdownByProp(
          $('.band-rivert-color-radio'),
          props['Rivet Colour'],
          typeof selectBandRivet === 'function' ? selectBandRivet : null
        );
      }
    }, 350);
  } else if ($('#category-no-addons').length && (!addonName || addonName === 'no-addons') && !props['Band Colour'] && !props['Clasp Colour'] && !props['Flap Colour']) {
    $('#category-no-addons').next('label').trigger('click');
  }

  // Personalisation text + font + position + foil
  if (props['Personalisation']) {
    $('#personalize-text-input').val(props['Personalisation']);
    if (typeof onInputType === 'function') {
      onInputType(document.getElementById('personalize-text-input'));
    } else {
      $('#personalize-textoverlay-span').text(props['Personalisation']);
    }
  }

  if (props['Font Type'] || props['Font Size']) {
    cnbSelectDropdownOption(
      $('.notebook-tab.personalize-tab .font-type-container .jsc-dropdown-options .jsc-option'),
      function($opt) {
        var fontOk = !props['Font Type'] || String($opt.attr('data-font-name')) === String(props['Font Type']);
        var sizeOk = !props['Font Size'] || String($opt.attr('data-size')) === String(props['Font Size']);
        return fontOk && sizeOk;
      }
    );
  }

  if (props['Font Position']) {
    cnbSelectDropdownOption(
      $('.notebook-tab.personalize-tab .layout-container .jsc-dropdown-options .jsc-option'),
      function($opt) {
        return String($opt.attr('data-val')) === String(props['Font Position']);
      }
    );
  }

  if (props['Stamp colour'] || props['Stamp colour code']) {
    var stamp = props['Stamp colour'];
    var $foilLabel = $('.foil-label').filter(function() {
      var tip = String($(this).attr('data-tooltip') || '');
      // Exact tooltip match only (Blind Deboss tip is "Deboss")
      if (cnbValuesMatch(tip, stamp)) return true;
      if (stamp === 'Blind Deboss' && tip === 'Deboss') return true;
      return false;
    }).first();
    if ($foilLabel.length) {
      $foilLabel.trigger('click');
    } else {
      var foilMatched = cnbClickRadioByProp($('.foil-radio'), stamp);
      if (!foilMatched && props['Stamp colour code']) {
        var code = String(props['Stamp colour code']).replace(/\s/g, '');
        var $foilByCode = $('.foil-radio').filter(function() {
          var fc = String($(this).attr('data-foil-code') || '').replace(/\s/g, '');
          return fc === code || fc.toLowerCase() === code.toLowerCase();
        }).first();
        if ($foilByCode.length) {
          var foilId = $foilByCode.attr('id');
          if (foilId) $('label[for="' + foilId + '"]').trigger('click');
        }
      }
    }
  }

  // Packaging — exact or label-SKU form only
  if (props['Packaging']) {
    var packVal = String(props['Packaging']);
    var $gift = $('.gift-radio').filter(function() {
      return cnbValuesMatch($(this).val(), packVal);
    }).first();
    if ($gift.length) {
      var gid = $gift.attr('id');
      if (gid) $('label[for="' + gid + '"]').trigger('click');
      else $gift.prop('checked', true).trigger('click');
    }
  }

  // Gift message / blank card
  if (props['Gift Message']) {
    var $msgCb = $('#pdpGiftCheckbox4');
    if ($msgCb.length && !$msgCb.prop('checked')) {
      $msgCb.prop('checked', true);
      if (typeof window.onPdpGiftCheckboxChange === 'function') {
        window.onPdpGiftCheckboxChange($msgCb[0]);
      }
    }
    $('.jsc-pdp-gift-message-wrapper .jsc-pdp-gift-message-input').val(props['Gift Message']);
  } else if (props['Blank Card']) {
    var $blankCb = $('#pdpGiftCheckbox3');
    if ($blankCb.length && !$blankCb.prop('checked')) {
      $blankCb.prop('checked', true);
      if (typeof window.onPdpGiftCheckboxChange === 'function') {
        window.onPdpGiftCheckboxChange($blankCb[0]);
      }
    }
  }

  if (props["Mother's Day Postcard"] === 'Yes') {
    var $mday = $('#pdpGiftCheckboxMdayPostcard');
    if ($mday.length) $mday.prop('checked', true);
  }

  showAllNotebookEditSteps();
  markNotebookEditModeUi(ctx);
  } catch (err) {
    console.error('applyNotebookEditPrefill error', err);
    showAllNotebookEditSteps();
    markNotebookEditModeUi(ctx);
  }
};

applyLeatherEditPrefill = (ctx) => {
  if (!ctx || !ctx.properties) return;
  var props = ctx.properties;

  markNotebookEditModeUi(ctx);

  try {
    if (typeof clickPersonalise === 'function') {
      clickPersonalise();
    } else {
      $('#isPersonalisation').show();
      $('#personaliseBtn').addClass('hideimportant');
    }

    // Variant / cover if color swatches exist
    if (ctx.variantId) {
      var $cover = $('.ColorSwatch__Radio[data-id="' + ctx.variantId + '"], input[type="radio"][data-id="' + ctx.variantId + '"]');
      if ($cover.length) {
        var coverId = $cover.first().attr('id');
        if (coverId) $('label[for="' + coverId + '"]').trigger('click');
        else $cover.first().prop('checked', true).trigger('change');
      }
      $('input.jsc-mainID-pdp').val(ctx.variantId);
    }

    if (props['Personalisation']) {
      $('#leather-text').val(props['Personalisation']);
      $('.personalisation-text').text(props['Personalisation']).show();
      var leatherEl = document.getElementById('leather-text');
      if (leatherEl) {
        $(leatherEl).trigger('input').trigger('change');
      }
    }

    if (props['Font Type'] || props['Font Size']) {
      var wantFont = props['Font Type'] ? String(props['Font Type']).trim() : '';
      var wantSize = props['Font Size'] ? String(props['Font Size']).trim() : '';
      cnbSelectDropdownOption(
        $('#isPersonalisation .font-type-container .jsc-dropdown-options .jsc-option, .font-type-container .jsc-dropdown-options .jsc-option'),
        function($opt) {
          var fontName = String($opt.attr('data-font-name') || '').trim();
          var size = String($opt.attr('data-size') || '').trim();
          var fontOk = !wantFont || fontName === wantFont;
          var sizeOk = !wantSize || size === wantSize || size.replace(/\s/g, '') === wantSize.replace(/\s/g, '');
          return fontOk && sizeOk;
        }
      );
    }

    if (props['Font Position']) {
      var pos = String(props['Font Position']).replace(/\s+/g, ' ').trim();
      var posNorm = pos.replace(/\s/g, '').toLowerCase().replace(/centre/g, 'center');
      cnbSelectDropdownOption(
        $('#isPersonalisation .layout-container .jsc-dropdown-options .jsc-option, .layout-container .jsc-dropdown-options .jsc-option'),
        function($opt) {
          var dataVal = String($opt.attr('data-val') || '').trim();
          var label = String($opt.text() || '').replace(/\s+/g, ' ').trim();
          var dataNorm = dataVal.replace(/\s/g, '').toLowerCase().replace(/centre/g, 'center');
          var labelNorm = label.replace(/\s/g, '').toLowerCase().replace(/centre/g, 'center');
          return dataVal === pos
            || label === pos
            || dataNorm === posNorm
            || labelNorm === posNorm;
        }
      );
    }

    if (props['Foil Colour'] || props['Stamp colour']) {
      var foil = String(props['Foil Colour'] || props['Stamp colour']).trim();
      var $foilOpt = $('#isPersonalisation .foil-option, .foil-option').filter(function() {
        return cnbValuesMatch($(this).attr('data-val'), foil) || cnbValuesMatch($(this).data('val'), foil);
      }).filter(':visible').first();
      if (!$foilOpt.length) {
        $foilOpt = $('#isPersonalisation .foil-option, .foil-option').filter(function() {
          return cnbValuesMatch($(this).attr('data-val'), foil) || cnbValuesMatch($(this).data('val'), foil);
        }).first();
      }
      if ($foilOpt.length) {
        if (typeof lFoil === 'function') lFoil($foilOpt[0]);
        else $foilOpt.trigger('click');
      }
    }

    if (props['Packaging']) {
      var packVal = String(props['Packaging']);
      var $gift = $('.gift-radio').filter(function() {
        return cnbValuesMatch($(this).val(), packVal);
      }).first();
      if ($gift.length) {
        var gid = $gift.attr('id');
        if (gid) $('label[for="' + gid + '"]').trigger('click');
        else $gift.prop('checked', true).trigger('click');
      }
    }

    if (props['Gift Message']) {
      var $msgCb = $('#pdpGiftCheckbox4');
      if ($msgCb.length && !$msgCb.prop('checked')) {
        $msgCb.prop('checked', true);
        if (typeof window.onPdpGiftCheckboxChange === 'function') {
          window.onPdpGiftCheckboxChange($msgCb[0]);
        }
      }
      $('.jsc-pdp-gift-message-wrapper .jsc-pdp-gift-message-input').val(props['Gift Message']);
    } else if (props['Blank Card']) {
      var $blankCb = $('#pdpGiftCheckbox3');
      if ($blankCb.length && !$blankCb.prop('checked')) {
        $blankCb.prop('checked', true);
        if (typeof window.onPdpGiftCheckboxChange === 'function') {
          window.onPdpGiftCheckboxChange($blankCb[0]);
        }
      }
    }

    if (props["Mother's Day Postcard"] === 'Yes') {
      var $mday = $('#pdpGiftCheckboxMdayPostcard');
      if ($mday.length) $mday.prop('checked', true);
    }

    markNotebookEditModeUi(ctx);
    try {
      $('html, body').animate({ scrollTop: ($('#isPersonalisation').offset() || { top: 0 }).top - 80 }, 300);
    } catch (e) {}
    // Variant swap runs on a short timeout and can reset ATC / personaliseBtn — reassert edit UI.
    setTimeout(function() { markNotebookEditModeUi(ctx); }, 50);
    setTimeout(function() {
      if (!$('#isPersonalisation').is(':visible') && typeof clickPersonalise === 'function') {
        clickPersonalise();
      }
      markNotebookEditModeUi(ctx);
    }, 120);
  } catch (err) {
    console.error('applyLeatherEditPrefill error', err);
    markNotebookEditModeUi(ctx);
  }
};

editCartPersonalisation = (el) => {
  var $el = $(el);
  var lineKey = $el.attr('data-line-key');
  var variantId = parseInt($el.attr('data-variant-id'), 10);
  var productUrl = $el.attr('data-product-url');
  var productHandle = $el.attr('data-product-handle');
  var quantity = parseInt($el.attr('data-quantity'), 10) || 1;
  var editType = $el.attr('data-edit-type') || 'notebook';

  if (!lineKey || !productUrl) return;

  fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
    .then(function(response) { return response.json(); })
    .then(function(data) {
      var item = (data.items || []).find(function(obj) { return obj.key === lineKey; });
      if (!item) return;

      var payload = {
        lineKey: item.key,
        bindId: (item.properties && item.properties.BindID) || '',
        variantId: item.variant_id || variantId,
        quantity: item.quantity || quantity,
        productHandle: productHandle || '',
        productId: item.product_id,
        editType: editType,
        properties: item.properties || {}
      };

      try {
        sessionStorage.setItem(CNB_EDIT_STORAGE_KEY, JSON.stringify(payload));
      } catch (e) {
        console.error('Could not store edit personalisation context', e);
      }

      var sep = productUrl.indexOf('?') >= 0 ? '&' : '?';
      var target = productUrl
        + sep
        + 'variant=' + encodeURIComponent(payload.variantId)
        + '&edit_personalisation=1'
        + '&edit_type=' + encodeURIComponent(editType)
        + '&edit_line=' + encodeURIComponent(payload.lineKey);
      window.location.href = target;
    })
    .catch(function(error) {
      console.error('Error:', error);
    });
};

// Back-compat alias
editNotebookPersonalisation = editCartPersonalisation;

removeNotebookEditCartLines = (ctx, done) => {
  var finish = typeof done === 'function' ? done : function() {};
  fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
    .then(function(response) { return response.json(); })
    .then(function(data) {
      var qtyMap = {};
      var bindId = ctx && ctx.bindId;
      (data.items || []).forEach(function(item) {
        if (bindId && item.properties && item.properties.BindID === bindId) {
          qtyMap[item.key] = 0;
        } else if (ctx && ctx.lineKey && item.key === ctx.lineKey) {
          qtyMap[item.key] = 0;
        }
      });

      if (Object.keys(qtyMap).length === 0) {
        finish();
        return;
      }

      CartJS.updateItemQuantitiesById(qtyMap, {
        success: function() { finish(); },
        error: function() { finish(); }
      });
    })
    .catch(function() { finish(); });
};
// --- end custom notebook edit personalisation ---

addNoteBook = (evt) =>{
  var $this = $(evt);
  var jsonObj = [];
  var $obj = {};
  var $bindId = '';
  // Step 1 — variant id for main notebook line item (must match Shopify variant or API returns 422)
  var $vid = parseInt($('.ColorSwatch__Radio:checked').attr('data-id'), 10);
  if (!Number.isFinite($vid) || $vid < 1) {
    $vid = parseInt($('.cover-swatch-tab .dropdown-var[aria-selected="true"]').attr('data-id'), 10);
  }
  // Dropdown swatch markup can miss data-id; master hidden / URL last-known variant
  if (!Number.isFinite($vid) || $vid < 1) {
    $vid = parseInt($('input.jsc-mainID-pdp').val(), 10);
  }
  if (!Number.isFinite($vid) || $vid < 1) {
    var _variantParam = String(window.location.search).match(/[?&]variant=(\d+)/);
    if (_variantParam) {
      $vid = parseInt(_variantParam[1], 10);
    }
  }
  var $variantSku = $('.product-select-option').find(':selected').attr('data-sku');
  var $variantTitle = $('.product-select-option').find(':selected').attr('data-variant-title');
  // Step 2
  var $twinWire = $('.twin-wire-radio:checked').val();
  var $twinWireSku = $('.twin-wire-radio:checked').attr('data-sku');
  // Step 3
  var $paper = $('.paper-radio:checked').val();
  var $paperSku = $('.paper-radio:checked').attr('data-sku');
  // Step 4
  var $nameInput = $('#personalize-text-input').val();
  var $fontFamily = $('.notebook-tab.personalize-tab .font-type-container .jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-font-name');
  var $fontSize = $('.notebook-tab.personalize-tab .font-type-container .jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-size');
  var $textPosition = $('.notebook-tab.personalize-tab .layout-container .jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-val');
  var $textColor = $('.foil-radio:checked').val();
  var $textColorCode = $('.foil-radio:checked').attr('data-foil-code');
  // Step 5
  var $addOn = $('.add-ons-radio:checked').val();
  var $addOnNum = $('.add-ons-radio:checked').attr('data-addon');
  var $addonselected = false;
  // Step 6
  var $giftWrap = $('.gift-radio:checked');
  var $giftWrap_temp = $('.gift-radio:checked').attr('data-gb');
  var $prod_gift_message = $('.jsc-pdp-gift-message-wrapper').find('.jsc-pdp-gift-message-input').val();
  var $prod_gift_blankcard = $('#pdpGiftCheckbox3').val();

  var __bindSeg = function (v) {
    return v === undefined || v === null ? '' : String(v);
  };

  $obj['Twin Wire'] = $('.twin-wire-radio').length > 0 ? ($twinWire || '') : '';
  $obj['Paper'] = $paper;
  //$obj['Personalisation'] = $nameInput;
  if ($nameInput){
    if ( $fontFamily == 'Copperplate' || $fontFamily == 'Script' || $fontFamily == 'Univers' ) {
    $obj['Personalisation'] = $nameInput.toUpperCase();
    }else {
    $obj['Personalisation'] = $nameInput;
    }

    $obj['Font Type'] = $fontFamily;
    $obj['Font Size'] = $fontSize;
    $obj['Font Position'] = $textPosition;
    $obj['Stamp colour'] = $textColor;
    $obj['Stamp colour code'] = $textColorCode;
  }
  $obj['Add-on'] = $addOn;

  $obj['Packaging'] = $giftWrap.val();
  if ($("#pdpGiftCheckbox3").prop("checked")) {
    $obj['Blank Card'] = $prod_gift_blankcard;
  } else if ($("#pdpGiftCheckbox4").prop("checked")) {
    $obj['Gift Message'] = $prod_gift_message;
  }
  if ($('#pdpGiftCheckboxMdayPostcard').length) {
    $obj["Mother's Day Postcard"] = $('#pdpGiftCheckboxMdayPostcard').is(':checked') ? 'Yes' : 'No';
  }

  $bindId = __bindSeg($twinWireSku) + __bindSeg($paperSku) + __bindSeg($nameInput) + __bindSeg($fontFamily) + __bindSeg($fontSize) + __bindSeg($textPosition) + __bindSeg($textColor) + __bindSeg($addOn);

  if ($addOnNum != '4') {
    if ($addOnNum == '1') {
      var $claspColor = $('.clasp-color-radio:checked').val();
      var $claspColorSku = $('.clasp-color-radio:checked').attr('data-sku');
      var $claspString = $('.clasp-string-radio:checked').val();
      var $claspStringSku = $('.clasp-string-radio:checked').attr('data-sku');
      var $claspeyelet = $('.clasp-eyelet-radio:checked').val();
      var $claspeyeletSku = $('.clasp-eyelet-radio:checked').attr('data-sku');

      if ($('.clasp-color-radio:checked').length > 0 && $('.clasp-string-radio:checked').length > 0 && $('.clasp-eyelet-radio:checked').length > 0) {
        $addonselected = true;
      }

      $obj['Clasp Colour'] = $claspColor +'-'+ $claspColorSku;
      $obj['Strings'] = $claspString +'-'+ $claspStringSku;
      $obj['Eyelet'] = $claspeyelet;

      $bindId += __bindSeg($claspColorSku) + __bindSeg($claspStringSku) + __bindSeg($claspeyeletSku);
    }
    if ($addOnNum == '2') {
      var $flapColor = $('.flap-color-radio:checked').val();
      var $flapColorSku = $('.flap-color-radio:checked').attr('data-sku');
      var $flaprivet = $('.rivet-color-radio:checked').val();
      var $flaprivetSku = $('.rivet-color-radio:checked').attr('data-sku');

      if ($('.flap-color-radio:checked').length > 0 && $('.rivet-color-radio:checked').length > 0) {
        $addonselected = true;
      }

      $obj['Flap Colour'] = $flapColor +'-'+ $flapColorSku;
      $obj['Snap Button Colour'] = $flaprivet;

      $bindId += __bindSeg($flapColorSku) + __bindSeg($flaprivetSku);
    }
    if ($addOnNum == '3') {
      var $bandColor = $('.band-color-radio:checked').val();
      var $bandColorSku = $('.band-color-radio:checked').attr('data-sku');
      var $bandrivet = $('.band-rivert-color-radio:checked').val();
      var $bandrivetSku = $('.band-rivert-color-radio:checked').attr('data-sku');

      if ($('.band-color-radio:checked').length > 0 && $('.band-rivert-color-radio:checked').length > 0) {
        $addonselected = true;
      }

      $obj['Band Colour'] = $bandColor +'-'+ $bandColorSku;
      $obj['Rivet Colour'] = $bandrivet;

      $bindId += __bindSeg($bandColorSku) + __bindSeg($bandrivetSku);
    }
  }else{
    $addonselected = true;
  }

  // $obj['Gift Wrap'] = $giftWrap.val();
  $bindId += __bindSeg($giftWrap.val());

  // Twin-wire + add-on dropdowns use .dropdownactive; Beyond The Canvas (notebook-2) omits twin wire and hides add-ons, so require dropdownactive only when twin-wire UI exists
  var stepDepsOk = ($('.dropdownactive').length > 0 || $('.twin-wire-radio').length === 0) && $('.paperswatchflickity input:checked').length > 0 && $addonselected;

  if (stepDepsOk) {
  if (!Number.isFinite($vid) || $vid < 1) {
    $('.next_addon_error').text('* Could not determine the selected cover variant. Please re-select your cover or refresh the page.');
    $('.next_addon_error').show();
    setTimeout(function(){
      $('.next_addon_error').hide();
    }, 3500);
    return;
  }
  // Add box product if needed
  var $handleizeBindId = $bindId.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  var $productBox = $('#box-wrap-'+$giftWrap_temp);
  if ($giftWrap.val() == $productBox.val()) {
    var $giftVid = parseInt($productBox.attr('data-vid'), 10);
    var $giftObj = {};

    $giftObj['Gift Wrap'] = $giftWrap.val();
    $giftObj['BindID'] = $handleizeBindId;
    $giftObj['Personalise'] = true;
    $obj['BindID'] = $handleizeBindId;
    if (Number.isFinite($giftVid) && $giftVid > 0) {
    var item = {};
    item ["id"] = $giftVid;
    item ["quantity"] = 1;
    item ["properties"] = $giftObj;
    jsonObj.push(item);
    }
  }

  if ($addOnNum != '4') {
    if ($addOnNum == '1') {
      var $claspColor = $('.clasp-color-radio:checked').val();
      var $claspColorSku = $('.clasp-color-radio:checked').attr('data-sku');
      var $claspString = $('.clasp-string-radio:checked').val();
      var $claspStringSku = $('.clasp-string-radio:checked').attr('data-sku');
      var $claspeyelet = $('.clasp-eyelet-radio:checked').val();
      var $claspeyeletSku = $('.clasp-eyelet-radio:checked').attr('data-sku');

      var $addonobj = {};
      $addonobj['_Addon'] = 'True';
      $addonobj['BindID'] = $handleizeBindId;
      var item = {};
      item ["id"] = parseInt($('.clasp-color-radio:checked').attr('data-varid'));
      item ["quantity"] = 1;
      item ["properties"] = $addonobj;
      //jsonObj.push(item);
      var item = {};
      item ["id"] = parseInt($('.clasp-string-radio:checked').attr('data-varid'));
      item ["quantity"] = 1;
      item ["properties"] = $addonobj;
      //jsonObj.push(item);
      var item = {};
      item ["id"] = parseInt($('.clasp-eyelet-radio:checked').attr('data-varid'));
      item ["quantity"] = 1;
      item ["properties"] = $addonobj;
      //jsonObj.push(item);
    }
    if ($addOnNum == '2') {
      var $flapColor = $('.flap-color-radio:checked').val();
      var $flapColorSku = $('.flap-color-radio:checked').attr('data-sku');
      var $flaprivet = $('.rivet-color-radio:checked').val();
      var $flaprivetSku = $('.rivet-color-radio:checked').attr('data-sku');

      var $addonobj = {};
      $addonobj['_Addon'] = 'True';
      $addonobj['BindID'] = $handleizeBindId;
      var item = {};
      item ["id"] = parseInt($('.flap-color-radio:checked').attr('data-varid'));
      item ["quantity"] = 1;
      item ["properties"] = $addonobj;
      //jsonObj.push(item);
      var item = {};
      item ["id"] = parseInt($('.rivet-color-radio:checked').attr('data-varid'));
      item ["quantity"] = 1;
      item ["properties"] = $addonobj;
      //jsonObj.push(item);
    }
    if ($addOnNum == '3') {
      var $bandColor = $('.band-color-radio:checked').val();
      var $bandColorSku = $('.band-color-radio:checked').attr('data-sku');
      var $bandrivet = $('.band-rivert-color-radio:checked').val();
      var $bandrivetSku = $('.band-rivert-color-radio:checked').attr('data-sku');

      var $addonobj = {};
      $addonobj['_Addon'] = 'True';
      $addonobj['BindID'] = $handleizeBindId;
      var item = {};
      item ["id"] = parseInt($('.band-color-radio:checked').attr('data-varid'));
      item ["quantity"] = 1;
      item ["properties"] = $addonobj;
      //jsonObj.push(item);
      var item = {};
      item ["id"] = parseInt($('.band-rivert-color-radio:checked').attr('data-varid'));
      item ["quantity"] = 1;
      item ["properties"] = $addonobj;
      //jsonObj.push(item);
    }
  }


  $('.dropdownactive').each(function(){
    if ($(this).attr('data-varid')) {
      var $addonobj = {};
      $addonobj['_Addon'] = 'True';
      $addonobj['BindID'] = $handleizeBindId;
      var item = {};
      item ["id"] = parseInt($(this).attr('data-varid'));
      item ["quantity"] = 1;
      item ["properties"] = $addonobj;
      //jsonObj.push(item);
    }
  });

  $('.paperswatchflickity input:checked').next().each(function(){
    if ($(this).attr('data-varid')) {
      var $addonobj = {};
      $addonobj['_Addon'] = 'True';
      $addonobj['BindID'] = $handleizeBindId;
      var item = {};
      item ["id"] = parseInt($(this).attr('data-varid'));
      item ["quantity"] = 1;
      item ["properties"] = $addonobj;
      //jsonObj.push(item);
    }
  });


  $obj['BindID'] = $handleizeBindId;


  var item = {};
  item ["id"] = $vid;
  var editCtx = getActiveNotebookEditContext();
  var editQty = 1;
  if (editCtx) {
    editQty = parseInt($('#cnb-edit-quantity').val(), 10) || parseInt(editCtx.quantity, 10) || 1;
  }
  item ["quantity"] = editQty;
  item ["properties"] = $obj;
  jsonObj.push(item);

  var pushNotebookItems = function() {
    CartJS.addItems(jsonObj,
      {
          // Define a success callback to display a success message.
          "success": function(data, textStatus, jqXHR) {
            if (editCtx) {
              clearNotebookEditContext();
            }
            $.ajax({
              url: '/cart.js',
              dataType: "json",
              cache: false,
              success: function() {}
            });
                  
          },
          // Define an error callback to display an error message.
          "error": function(jqXHR, textStatus, errorThrown) {}
      });
  };

  if (editCtx) {
    // Prefer session bindId; fall back to hidden field if URL/session still active
    var removeCtx = {
      bindId: editCtx.bindId || $('#cnb-edit-bind-id').val() || '',
      lineKey: editCtx.lineKey || $('#cnb-edit-line-key').val() || ''
    };
    shouldUpdateDrawer = false;
    removeNotebookEditCartLines(removeCtx, function() {
      shouldUpdateDrawer = true;
      pushNotebookItems();
    });
  } else {
    pushNotebookItems();
  }

  /*
  cartJSAddQuery($vid, 1,$obj);
  */
  }else{
    $('.next_addon_error').text('* Please make sure to select all necessary color option for addon.');
    $('.next_addon_error').show();
    setTimeout(function(){
      $('.next_addon_error').hide();
    },2500);
  }

  // $(document).on('cart.requestComplete', function(event, cart) {
  //   resetCustomNotebook();
  // });
}

resetCustomNotebook = () =>{
  // Reset Cover color
  $('.tab-container .ColorSwatch').first().click();

  // Reset twin Wire
  $('.twin-wire-swatch').first().click();
  $('.twin-wire-img').hide();

  // Reset Paper
  $('.paper-swatch').first().click();
  $('.paper-img').hide();

  // Reset personalisation
  $('#personalize-text-input').val('');
  $('#personalize-textoverlay-span').text('');
  $('#personalize-font-family-select').val('');
  $('#personalize-font-size-select').val('');
  $('.position-label').first().click();
  $('.foil-label').first().click();

  // Reset add ons
  $('.category-label').last().click();

  // Reset Clasp
  $('.clasp-color-radio').prop('checked', false);
  $('.clasp-color-label').css('border', '2px solid #dadada');
  $('.clasp-string-radio').prop('checked', false);
  $('.clasp-string-label').css('border', '2px solid #dadada');
  $('.clasp-eyelet-radio').prop('checked', false);
  $('.clasp-eyelet-label').css('border', '2px solid #dadada');
  $('#clasp-color-span').text('');
  $('#clasp-string-span').text('');
  $('#clasp-eyelet-span').text('');

  // Reset Closing flap
  $('.flap-color-radio').prop('checked', false);
  $('.flap-label').css('border', '2px solid #dadada');
  $('.rivet-color-radio').prop('checked', false);
  $('.rivet-label').css('border', '2px solid #dadada');
  $('#flap-color-span').text('');
  $('#flap-rivet-span').text('');

  // Reset Elastic band
  $('.band-color-radio').prop('checked', false);
  $('.band-label').css('border', '2px solid #dadada');
  $('.band-rivert-color-radio').prop('checked', false);
  $('.band-revert-label').css('border', '2px solid #dadada');
  $('#band-color-span').text('');
  $('#band-rivet-span').text('');

  // Reset Gift wrap
  $('.gift_label').first().click();

  // Reset tab
  $('.notebook-tab').hide();
  $('.notebook-tab').first().show();

  // Reset Tab
  $('#previous_step').css('visibility', 'hidden');
  $('#next_step').show();
  $('#next_step').prop('disabled', false);
  $('#fianl_step').hide();
  $('.gift-tab').removeClass('is-tab');
  $('.cover-swatch-tab').addClass('is-tab');
}

cnbCheckSoldout = (evt, isSoldout) =>{
  if (isSoldout) {
    setTimeout(function(){
      $('#next_step').prop('disabled', true);
      $('.btn.klaviyo-bis-trigger').show();
      $('#fianl_step').hide();
    },10);
  } else {
    setTimeout(function(){
      $('#next_step').prop('disabled', false);
      $('.btn.klaviyo-bis-trigger').hide();
      $('#fianl_step').show();
    },10);
  }
}
// Scripts for custom notebook ends here

checkInventory = () =>{
  setTimeout(function(){
    var $prodVar = $('.prod-var');
    var $prodVarInventory = parseInt($prodVar.find(':selected').attr('data-inventory'));
    var $notProdVarInventory = parseInt($('.not-prod-var').attr('data-inventory'));
    var $personaliseBtn = $('#personaliseBtn');

    if ($prodVarInventory > 0 || $notProdVarInventory > 0) {
      $personaliseBtn.removeClass('hideimportant').css('display','inline-block');
    } else {
      $personaliseBtn.addClass('hideimportant');
    }
  },100);
}

leatherAddToCart = (evt) => {
  var $this = $(evt);
  var $prod = {};
  var $prodCost_add = {};
  var $prodVid = parseInt($('.jsc-mainID-pdp').val());
  var $prodCost_vid = parseInt($this.attr('data-prodCostVid'));
  var $prodCost_price = parseInt($this.attr('data-prodCostPrice'));
  var $prodTitle = $this.attr('data-prodTitle');
  var $prodCost_title = $this.attr('data-prodCostTitle');
  var $prod_gift_message = $('.jsc-pdp-gift-message-wrapper').find('.jsc-pdp-gift-message-input').val();
  var $prod_gift_blankcard = $('.jsc-product-blankcard').val();
  var $prod_mday_postcard_el = $('#pdpGiftCheckboxMdayPostcard');

  var $pricegiftNum = parseInt($('.gift-radio:checked').next().attr('data-price-number'));

  if (!$prodVid) {
    $prodVid = parseInt($('.not-prod-var').val());
  }

  if ($pricegiftNum > 0  && $prodCost_price <= 0 && $pricegiftNum) {
    $prodCost_price = $pricegiftNum;
    $prodCost_vid = parseInt($('.gift-radio:checked').attr('data-vid'));
  }

  if (isNaN($prodCost_price)) {
    $prodCost_price = $pricegiftNum;
    $prodCost_vid = parseInt($('.gift-radio:checked').attr('data-vid'));
  }

  var leatherInputEl = document.getElementById('leather-text');
  var $inputTextRaw = $('#leather-text').val();
  var $inputText = jscClampLeatherTextToMaxlength($inputTextRaw, leatherInputEl);
  if (leatherInputEl && $inputTextRaw !== $inputText) {
    $('#leather-text').val($inputText);
    $('.personalisation-text').text($inputText);
  }
  var $fontType = $('.font-type-container').find('.jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-font-name');
  var $fontSize = $('.font-type-container').find('.jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-size');
  var $fontSizeMm = $('.font-type-container').find('.jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-size');
  var $layout = $.trim($('.layout-container').find('.jsc-dropdown-options .jsc-option[selected="selected"]').text() || '');
  var $foilColor = $('.foil-option.foil-selected').data('val');
  $fontType =  $.trim($fontType);

  // Gift Wrap options
  var $giftWrap = $('.gift-radio:checked');
  var $handleizeGiftOption = '';
  // Handleize Gift Wrap and text input
  if ($giftWrap.length > 0) {
    $handleizeGiftOption = $giftWrap.val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  }
  var $handleizeInputText = $inputText.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

  if ($inputText == '') {
    $('#input-text-error').show();
  }
  else if ($fontType == null) {
    $('#font-type-error').show();
  }
  else if ($fontSize == null) {
    $('#font-size-error').show();
  }
  else {
    $prodCost_add['Personalise'] = $prodTitle;
    // $prodCost_add['Font Type'] = $fontType;
    // $prodCost_add['Font Size'] = $fontSizeMm;
    // $prodCost_add['Foil Colour'] = $foilColor;
    // $prodCost_add['Font Position'] = $layout;
    // $prodCost_add['Personalisation'] = $inputText;

    // if ($fontType == 'Copperplate' || $fontType == 'Script' || $fontType == 'Univers' ) {
    // $prodCost_add['Personalisation'] = $inputText.toUpperCase();
    // }else {
    // $prodCost_add['Personalisation'] = $inputText;
    // }
    $prodCost_add['BindID'] = $prodVid+'-'+$prodCost_vid+'-'+$handleizeInputText+'-'+$fontType+'-'+$fontSize+'-'+$layout+'-'+$foilColor+'-'+$handleizeGiftOption;
    $prodCost_add['Packaging'] = $giftWrap.val();

    $prod['Main Product'] = $prodCost_title;
    $prod['Font Type'] = $fontType;
    $prod['Font Size'] = $fontSizeMm;
    $prod['Foil Colour'] = $foilColor;
    $prod['Font Position'] = $layout;
    //$prod['Personalisation'] = $inputText;

    if ($fontType == 'Copperplate' || $fontType == 'Script' || $fontType == 'Univers' ) {
    $prod['Personalisation'] = $inputText.toUpperCase();
    }else {
    $prod['Personalisation'] = $inputText;
    }

    if ($prodCost_price > 0){
    $prod['BindID'] = $prodVid+'-'+$prodCost_vid+'-'+$handleizeInputText+'-'+$fontType+'-'+$fontSize+'-'+$layout+'-'+$foilColor+'-'+$handleizeGiftOption;
    }else{
      $prod['BindID'] = $prodVid+'-'+$handleizeInputText+'-'+$fontType+'-'+$fontSize+'-'+$layout+'-'+$foilColor+'-'+$handleizeGiftOption;
    }
    $prod['Gift Message'] = $prod_gift_message;
    $prod['Blank Card'] = $prod_gift_blankcard;
    if ($prod_mday_postcard_el.length) {
      $prod["Mother's Day Postcard"] = $prod_mday_postcard_el.is(':checked') ? 'Yes' : 'No';
    }
    $prod['Packaging'] = $giftWrap.val();

    var editCtx = getActiveNotebookEditContext();
    var editQty = 1;
    if (isLeatherPersonalisationEditContext(editCtx)) {
      editQty = parseInt($('#cnb-edit-quantity').val(), 10) || parseInt(editCtx.quantity, 10) || 1;
    } else {
      editCtx = null;
    }

    var pushLeatherItems = function() {
      if ($prodCost_price > 0){
        cartJSAddQuery($prodVid, editQty, $prod);
        cartJSAddQuery($prodCost_vid, editQty, $prodCost_add);
      }else{
        cartJSAddQuery($prodVid, editQty, $prod);
      }
      if (editCtx) {
        clearNotebookEditContext();
      }
    };

    if (editCtx) {
      var removeCtx = {
        bindId: editCtx.bindId || $('#cnb-edit-bind-id').val() || '',
        lineKey: editCtx.lineKey || $('#cnb-edit-line-key').val() || ''
      };
      shouldUpdateDrawer = false;
      removeNotebookEditCartLines(removeCtx, function() {
        shouldUpdateDrawer = true;
        pushLeatherItems();
      });
    } else {
      pushLeatherItems();
    }
  }
}

//Function add to cart for new set product Personalise
setPersonaliseAddToCart = (evt) => {
  var $this = $(evt);
  var $prod = {};
  var $prodCost_add = {};
  var $prodVid = parseInt($('.prod-var').val());
  var $prodCost_vid = parseInt($this.attr('data-prodCostVid'));
  var $prodTitle = $this.attr('data-prodTitle');
  var $prodCost_title = $this.attr('data-prodCostTitle');
  var $all_optID = '';
  var canATC = true;

  if (!$prodVid) {
    $prodVid = parseInt($('.not-prod-var').val());
  }
  $('.jsc-input-text-error').hide();

  $('.tab-content').each(function(){
    var tabIDclick = $(this).attr('data-prodID');

    if ( $(this).find('.input-set-text').val() == null || $(this).find('.input-set-text').val() == '') {
      canATC = false;
      $(this).find('.jsc-input-text-error').show();

         $('.jsc-btnTab').each(function(){
           if ( $(this).attr('data-prodID') == tabIDclick) {
             $(this).click();
           }
         });

      return false;
    }

    if ( $(this).find('.input-set-text').val() != null && $(this).find('.input-set-text').val() != '') {
      var tabID = $(this).attr('data-prodID');
      var tabTitle = $(this).attr('data-optTitle');

      var $inputText = $('#leather-set-text-' + tabID).val();
      var $fontType = $('#fontType-' + tabID).val();
      var $fontSize = $('#fontSize-' + tabID).val();
      var $fontSizeMm = $('#fontSize-' + tabID).find(':selected').text();
      var $layout = $('.position-layout-label-'+ tabID +'.layout-selected').attr('value');
      var $foilColor = $('.foil-option-'+ tabID +'.foil-selected').data('val');
      var $handleizeInputText = $inputText.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

        $prodCost_add['Personalise'] = $prodTitle;
        $prodCost_add[tabTitle + ' - Font Type'] = $fontType;
        $prodCost_add[tabTitle + ' - Font Size'] = $fontSizeMm;
        $prodCost_add[tabTitle + ' - Foil Colour'] = $foilColor;
        $prodCost_add[tabTitle + ' - Font Position'] = $layout;

        if ($fontType == 'Copperplate' || $fontType == 'Script' || $fontType == 'Univers' ) {
        $prodCost_add[tabTitle + ' - Personalisation'] = $inputText.toUpperCase();
        }else {
        $prodCost_add[tabTitle + ' - Personalisation'] = $inputText;
        }

        $prod['Main Product'] = $prodCost_title;
        $prod[tabTitle + ' - Font Type'] = $fontType;
        $prod[tabTitle + ' - Font Size'] = $fontSizeMm;
        $prod[tabTitle + ' - Foil Colour'] = $foilColor;
        $prod[tabTitle + ' - Font Position'] = $layout;

        if ($fontType == 'Copperplate' || $fontType == 'Script' || $fontType == 'Univers' ) {
        $prod[tabTitle + ' - Personalisation'] = $inputText.toUpperCase();
        }else {
        $prod[tabTitle + ' - Personalisation'] = $inputText;
        }
        if ($all_optID == '') {
          $all_optID = $all_optID+tabID+'-'+$handleizeInputText+'-'+$fontType+'-'+$fontSize+'-'+$layout+'-'+$foilColor;
        }else {
          $all_optID = $all_optID+'-'+tabID+'-'+$handleizeInputText+'-'+$fontType+'-'+$fontSize+'-'+$layout+'-'+$foilColor;
        }

    }
  });

  // Gift Wrap options
  var $giftWrap = $('.gift-radio:checked');
  var $handleizeGiftOption = '';
  // Handleize Gift Wrap and text input
  if ($giftWrap.length > 0) {
    $handleizeGiftOption = $giftWrap.val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  }

  $prodCost_add['Packaging'] = $giftWrap.val();
  $prod['Packaging'] = $giftWrap.val();
  $prodCost_add['BindID'] = $prodVid+'-'+$prodCost_vid+'-'+$all_optID+$handleizeGiftOption;
  $prod['BindID'] = $prodVid+'-'+$prodCost_vid+'-'+$all_optID+$handleizeGiftOption;
  if (canATC == true) {
  cartJSDoubleAddQuery($prodVid, 1,$prod, $prodCost_vid, 1,$prodCost_add);
  }
  //cartJSAddQuery($prodCost_vid, 1,$prodCost_add);
}


jscGetLimitOneConfigForVariant = (vid) => {
  var vnum = parseInt(vid, 10);
  if (isNaN(vnum)) return null;
  var found = null;
  $('form[is="product-form"]').each(function () {
    var $cfg = $(this).find('.jsc-limit-one-config');
    if (!$cfg.length) return;
    var ids = $cfg.attr('data-limit-one-variant-ids');
    if (!ids) return;
    var s = ',' + String(ids) + ',';
    if (s.indexOf(',' + vnum + ',') >= 0) {
      found = $cfg;
      return false;
    }
  });
  return found;
};

jscLimitOneCanAddQty = (cart, productId, addQty) => {
  var existing = 0;
  if (!cart || !cart.items) return true;
  var pid = Number(productId);
  for (var i = 0; i < cart.items.length; i++) {
    if (Number(cart.items[i].product_id) === pid) existing += cart.items[i].quantity;
  }
  return existing + addQty <= 1;
};

cartJSAddQueryPerform = (vid, qty, prop) => {
  CartJS.addItem(vid, qty, prop,
  {
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          console.log('success',location.pathname);
        }
      });
    },
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
};

cartJSAddQuery = (vid, qty, prop) => {
  var vnum = parseInt(vid, 10);
  var qtyNum = parseInt(qty, 10);
  if (isNaN(qtyNum)) qtyNum = 1;
  var $cfg = jscGetLimitOneConfigForVariant(vnum);
  if ($cfg && $cfg.length) {
    var limitPid = parseInt($cfg.attr('data-limit-one-product'), 10);
    if (!isNaN(limitPid)) {
      $.getJSON('/cart.js', function (cart) {
        if (!jscLimitOneCanAddQty(cart, limitPid, qtyNum)) {
          $('.jsc-cart-limit-message').text('Only one of this product is allowed per cart.').show();
          return;
        }
        cartJSAddQueryPerform(vid, qty, prop);
      });
      return;
    }
  }
  cartJSAddQueryPerform(vid, qty, prop);
};

cartJSDoubleAddQueryPerform = (m_vid, m_qty, m_prop, vid, qty, prop) => {
  CartJS.addItem(m_vid, m_qty, m_prop,
  {
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          cartJSAddQuery(vid, qty, prop);
          $('.cart-item-count').text(cart.item_count);
        }
      });
    },
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
};

cartJSDoubleAddQuery = (m_vid, m_qty, m_prop, vid, qty, prop) => {
  var mnum = parseInt(m_vid, 10);
  var mq = parseInt(m_qty, 10);
  if (isNaN(mq)) mq = 1;
  var $cfg = jscGetLimitOneConfigForVariant(mnum);
  if ($cfg && $cfg.length) {
    var limitPid = parseInt($cfg.attr('data-limit-one-product'), 10);
    if (!isNaN(limitPid)) {
      $.getJSON('/cart.js', function (cart) {
        if (!jscLimitOneCanAddQty(cart, limitPid, mq)) {
          $('.jsc-cart-limit-message').text('Only one of this product is allowed per cart.').show();
          return;
        }
        cartJSDoubleAddQueryPerform(m_vid, m_qty, m_prop, vid, qty, prop);
      });
      return;
    }
  }
  cartJSDoubleAddQueryPerform(m_vid, m_qty, m_prop, vid, qty, prop);
};

plusQty = (evt) =>{
  var $this = $(evt);
  var $actionVal = 'plus-';
  plusMinusBindClick($this,$actionVal);
}

minusQty = (evt) =>{
  var $this = $(evt);
  var $actionVal = 'minus-';
  plusMinusBindClick($this,$actionVal);
}

plusMinusBindClick = (e,actionVal) =>{
  var $bindId = e.attr('data-bindId');
  setTimeout(function(){
    if ($('.'+actionVal+$bindId).length > 1) {
      var jsonObj = {};
      $('.'+actionVal+$bindId).each(function(){
        var key = $(this).attr('data-id');
        if (actionVal == 'plus-') {
          var itemQty = parseInt(e.attr('data-qty')) + 1;
        }else{
          var itemQty = parseInt(e.attr('data-qty')) - 1;
        }
        jsonObj[key] = itemQty;
        //CartJS.updateItemById(key, itemQty);
      });
      CartJS.updateItemQuantitiesById(jsonObj);
    }else{
    $('.'+actionVal+$bindId)[0].click();
    // console.log( $('.'+actionVal+$bindId),actionVal,$bindId);
    setTimeout(function(){
      $.when($.getJSON('/cart.js', function(cart) {
        $count = cart.item_count;
        })).then(function(){
          $('.cart-item-count').text($count);
        });
     },500);
    }
  },500);
}

clickPersonalise = (evt) => {
  // var $this = $(evt);
  $("#isPersonalisation").show();
  $(".personalisation-text").show();
  $(".motifpersonalizebtn").hide();
  $("#personaliseBtn").addClass('hideimportant');
  $(".ProductForm__AddToCart").hide();
  $(".before-price").hide();
  $(".personalise-price").show();
  $("#isPersonalisation").insertAfter("#personaliseBtn");
  $(".jsProductForm").addClass('isPersonalized');
  $(".Product__Info").addClass('isPersonalized');

  // move gift box container after remove personalisation Btn
  $(".gift-container").insertBefore(".jsc-pdp-gift-message-wrapper");

  // changeFontType($('#fontType'));
  var _priceAddpersonalize = $(".jsc-add-personalise").text();
  $("#atome-price").children().text(_priceAddpersonalize);
}

removePersonlise = (evt) => {
  // var $this = $(evt);
  $(".motifpersonalizebtn").show();
  $("#isPersonalisation").hide();
  $(".personalisation-text").hide();
  $(".before-price").show();
  $(".personalise-price").hide();
  $(".ProductForm__AddToCart").show();
  $(".jsProductForm").removeClass('isPersonalized');
  $(".Product__Info").removeClass('isPersonalized');

  // move gift box container before Add Personalisation btn
  $(".gift-container").insertBefore(".jsc-pdp-gift-message-wrapper");
  $("#personaliseBtn").removeClass('hideimportant').css('display','inline-block');
  var _priceAddpersonalize = $(".jsc-ori-price").text();
  $("#atome-price").children().text(_priceAddpersonalize);

  //extra function for set personlaise
  if ($('#setPersonalise').length > 0) {
    var oriImg = $('#ori-img').val();
    //swapTabimg(oriImg);
    $('.Alt_Product__Slideshow').show();
    $('.selectedNav').show();
    $('.jsc-set-img').hide();

  }

}

onInputGiftmessage = (evt) =>{
  var $this = $(evt);
  var $len = $this.val().length;
  var $maxLen = $this.attr("maxlength");
  $char = $maxLen - $len;
  $('.charNo').text($char + ' characters remaining');
  var temp = $this.val().replace(/[^'.&a-zA-Z0-9\s]/g, "").replaceAll("*", "").replaceAll("+", "");
  $this.val(temp);
  console.log(temp);
}
removeEmoji = (evt) =>{
  var $this = $(evt);
  var temp = $this.val().replace(/[^'.&a-zA-Z0-9\s]/g, "").replaceAll("*", "").replaceAll("+", "");
  $this.val(temp);
  console.log(temp);
}

onChangeShow = (evt) =>{
  var $this = $(evt);
  var $val = $this.val();
  var $topVal = $this.find(':selected').attr('data-top');
  var $leftVal = $this.find(':selected').attr('data-left');
  var $transformVal = $this.find(':selected').attr('data-transform');
  var sizetVal = $this.find(':selected').attr('data-size');
  var $overlayLogo = $('#overlay-logo');

  $overlayLogo.css('top', $topVal);
  $overlayLogo.css('left', $leftVal);
  $overlayLogo.css('transform', 'translate('+$transformVal+')');
  $overlayLogo.css('width', sizetVal);
  $('.corporate-img').hide();
  $('#'+$val).show();
}

uploadLogo = (evt) =>{
  var $this = $(evt);
  var $val = $this.val();
  var $label = $('#logo-upload-label');
  var $overlayLogo = $('#overlay-logo');

  if (evt.files && evt.files[0]) {
    var $reader = new FileReader();
    $reader.onload = function (e) {
      $overlayLogo.attr('src', e.target.result);
    };
    $reader.readAsDataURL(evt.files[0]);
    $label.text('Change Logo (PNG File)');
  } else {
    $overlayLogo.attr('src', '');
    $label.text('Add Logo (PNG File)');
  }

  if ($val != '') {

  } else {

  }
  console.log('val',evt.files);
}

reorderPreviewSection = () =>{
  var $shogunContainer = $('.appendPreviewSection');
  var $corpGiftContainer = $('.corporate-gift-conrtainer');

  $shogunContainer.append($corpGiftContainer);
  $corpGiftContainer.show();
}

scrollToTop = () =>{
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

checkoutValidate = (evt , b) =>{
  var $this = $(evt);
  var $gift = $('.jsc-gwp_add');
  var $selectedPackaging = $('.jsc-packaging-radio:checked');
  var $isPackage = false;
  var $errorText = $('#jsc-packaging-error');

  // check if packagin is selected
  if (!b){
    $isPackage = true;
  }else if(b) {
    $isPackage = true;
  }

  if ($isPackage) {
    $this.prop('disabled', 'true');
  }
  if ($gift.length > 0) {
    addGWP();

    $(document).on('cart.requestComplete', function(event, cart) {
      if ($isPackage) {
        $errorText.hide();
        $('#jsc-checkout-btn').click();
      } else {
        $errorText.show();
      }
    });
  } else {
    if ($isPackage) {
      $errorText.hide();
      $('#jsc-checkout-btn').click();
    } else {
      $errorText.show();
    }
  }
}

addGWP = () =>{
  var $obj = {};
  var $gift = $('.jsc-gwp_add');

  $obj['Campaign'] = 'Gift with Purchase';

  $gift.each(function(){
    console.log('add gift');
    var $_this = $(this);
    var $_vid = $_this.val();
    var qty = parseInt($_this.attr('data-qty'), 10);
    if (isNaN(qty) || qty < 1) {
      qty = 1;
    }

    cartJSAddQuery($_vid, qty, $obj);
  });
}

removeGWP = () =>{
  var $removeGift = $('.jsc-gwp_remove');
  $removeGift.each(function(){
    console.log('remove gift');
    var $_this = $(this);
    var $_vid = $_this.val();

    CartJS.updateItemById($_vid, 0);
  });
}

bookThatAppStyling = () =>{
  var $continer = $('#bta-calendar').parent();
  $continer.css('max-width', '1200px').css('margin', '60px auto');
  console.log('car',$continer);
}

addnotecart = () =>{
  $('.jsc-addnote').show();
  console.log($('.jsc-addnote'),'asdas');
}

hideaddnotecart = () => {
  $('.jsc-addnote').hide();
}

anchorDescription = () =>{
  $(".jsc-see-description").click(function(e) {
  	e.preventDefault();
    var $fullDesc = $('.jsc-collapible-desc');
  	var position = $fullDesc.offset().top - 240;

  	$("body, html").animate({
  		scrollTop: position
  	}/* speed */);
    $fullDesc.trigger('click');
});
}


updateklaviyoButtontext = () =>{
setTimeout(function(){
 var _productTag = $('.jsc-klaviyo-workshop').attr('data-tag');
 if (_productTag != undefined || _productTag != null ) {
 if (_productTag.includes('available upon request')) {
   console.log('changeklavityo');
   $('.klaviyo-bis-trigger').text( "Available Upon Request" );
   $('.klaviyo-bis-trigger').attr("href", "/pages/contact");
   $('.klaviyo-bis-trigger').addClass( "jsc-upt-klaviyo-bis-trigger" );
   $('.jsc-upt-klaviyo-bis-trigger').removeClass( "klaviyo-bis-trigger" );
 }
 }
}, 1000);
}

onloadSidebarAccount = () =>{

  if (location.href.includes('/account')) {
    var _href = location.href;
    var _sidebarmenu = $('.jsc-sidebarMenu');
    var _segmentContent = $('.jsc-segment');

    if (_href == 'https://byndartisan.com/account') {
      console.log('default');
    }else {

    _sidebarmenu.each(function(){
      var $_this = $(this);
      var _segmentData = $_this.attr('data-segment');
      if (_href.includes(_segmentData)) {
        $_this.addClass( "jsc-segment-active" );
      }else {
        $_this.removeClass( "jsc-segment-active" );
      }
    });

    _segmentContent.each(function(){
      var $_this = $(this);
      var _segmentData = $_this.attr('data-segment');
      if (_href.includes(_segmentData)) {
        $_this.show();
      }else {
        $_this.hide();
      }
    });
    }

  }

}

onclickSidebarAccount = (evt,segment) =>{
  var _this = $(evt);
  var _sidebarmenu = $('.jsc-sidebarMenu');
  var _segmentContent = $('.jsc-segment');

  var newurl = window.location.href.split('?')[0];
  newurl = newurl + '?data-segment=' + segment;
  window.history.pushState({ path: newurl }, '', newurl);
  console.log(newurl);

  _sidebarmenu.each(function(){
    var $_this = $(this);
    var _segmentData = $_this.attr('data-segment');
    if (_segmentData == segment) {
      $_this.addClass( "jsc-segment-active" );
    }else {
      $_this.removeClass( "jsc-segment-active" );
    }
  });

  _segmentContent.each(function(){
    var $_this = $(this);
    var _segmentData = $_this.attr('data-segment');
    if (_segmentData == segment) {
      $_this.show();
    }else {
      $_this.hide();
    }
  });
}

oncloadChallenge = () =>{
   var _formContent = $('form');
   _formContent.each(function(){
     var $_this = $(this);
     var _Dataaction = $_this.attr('action');
     if (_Dataaction.includes('byndartisan.com/account')) {
       $_this.append('<input type="hidden" name="return_to" value="/account">');
       console.log(_Dataaction);
     }
   });
}
// onloadCustomerProfile = () =>{
//   setTimeout(function(){
//     if ($('.cf-submit-form').length > 0) {
//       $('.cf-submit-form').attr('onclick', 'loyaltyLion()');
//     }
//   },2000);
//   console.log('test');
// }

loyaltyLion = () =>{
  //console.log('helloworld');
  var $return = {};
  $return['name'] = "signup_profile";
  $return['customer_id'] = $('#id').val();
  $return['customer_email'] = $('#email').val();

  var settings = {
     "url": "https://usemechanic.com/webhook/a442d7bf-b626-4d69-9111-1d74c9e6e672",
     "method": "POST",
     "timeout": 0,
     "headers": {
       "Content-Type": "application/json"
       //"Content-Type": "application/json","Authorization": "Bearer d07ad5364c2e35be8d9b26fbe85d1070"
     },
     "data" : JSON.stringify($return)
   };

   $.ajax(settings).done(function(r){
     console.log('success');
     alert('You have received 20 points for completing your profile!')
   }).fail(function(response) {
     console.log("error");
     console.log(response);
     // Happens when something goes wrong
     //
   });
}

initCustomRecommendation = () => {
  var $imgContainer = $('.jsc-custom-productList');

  if ($imgContainer.length > 0) {
    var $flickityConfig = $imgContainer.attr('data-flickity-config');
    var $obj = JSON.parse($flickityConfig);
    $imgContainer.flickity($obj);
  }
}

variantSlider = () => {
  clearTimeout(jscVariantSliderTimer);
  jscVariantSliderTimer = setTimeout(function () {
    if ($('.variant-slider').length) {
      if ($('.variant-slider').data('flickity')) {
        $('.variant-slider').flickity('destroy');
      }
      $('.variant-slider').flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        wrapAround: false,
        draggable: false,
        groupCells: true,
        initialIndex: '.is-initial-select',
        prevNextButtons: true
      });
    }
    if ($('.complementary-products__product-list').length) {
      if ($('.complementary-products__product-list').data('flickity')) {
        $('.complementary-products__product-list').flickity('destroy');
      }
      $('.complementary-products__product-list').flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        wrapAround: false,
        draggable: true,
        watchCSS: true,
        prevNextButtons: false
      });
    }
  }, 150);
}

initUpsellSlider = () =>{
  shogunflickity();
  $('.paperswatchflickity').flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    wrapAround: false,
    draggable: true,
    watchCSS: false,
    groupCells: true,
    imagesLoaded: true,
    prevNextButtons: true
  });
  var $maxHeight = 0;
  $('.paperswatchflickity .paper-swatch').each(function(){
    var $ConTentHeight = $(this).outerHeight();
    if ($maxHeight < $ConTentHeight) {
      $maxHeight = $ConTentHeight;
    }
  });
  $('.paperswatchflickity .paper-swatch').css("height", $maxHeight + "px");
  var $windowidth = $( window ).width();
  $( window ).resize(function() {
    var $windowidthresize = $( window ).width();
    if ($windowidthresize == $windowidth) {
      console.log('dont run');
    }else{
      $windowidth = $( window ).width();
      $('.paperswatchflickity .paper-swatch').removeAttr("style");
      setTimeout(function(){
        var $maxHeight = 0;
        $('.paperswatchflickity .paper-swatch').each(function(){
          var $ConTentHeight = $(this).outerHeight();
          if ($maxHeight < $ConTentHeight) {
            $maxHeight = $ConTentHeight;
          }
        });
        $('.paperswatchflickity .paper-swatch').css("height", $maxHeight + "px");
      },500);
    }
  });
  $('.complementary-products__product-list').flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    wrapAround: false,
    draggable: true,
    watchCSS: true,
    prevNextButtons: false
  });
  $('.variant-slider').flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    wrapAround: false,
    draggable: false,
    groupCells: true,
    initialIndex: '.is-initial-select',
    prevNextButtons: true
  });
  $('.jsc-feat-grid-list').flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    wrapAround: false,
    draggable: true,
    prevNextButtons: true
  });
  if ($(window).width() < 700) {
    $('.jsc-logo-list-slider').flickity({
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: true,
      draggable: true,
      groupCells: true,
      prevNextButtons: true
    });
  }else{
    $('.jsc-logo-list-slider').flickity({
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: false,
      draggable: true,
      groupCells: true,
      prevNextButtons: true
    });
  }
  $( window ).resize(function() {
    $('.jsc-logo-list-slider').flickity('destroy');
    if ($(window).width() < 700) {
      $('.jsc-logo-list-slider').flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        groupCells: true,
        prevNextButtons: true
      });
    }else{
      $('.jsc-logo-list-slider').flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        wrapAround: false,
        draggable: true,
        groupCells: true,
        prevNextButtons: true
      });
    }
  });
}


$(document).on('change', '.div-toggle', function() {
  var target = $(this).data('target');
  var show = $("option:selected", this).data('show');
  $(target).children().addClass('hide');
  $(show).removeClass('hide');
});
$(document).ready(function(){
  $('.div-toggle').trigger('change');
});


updateLowStockLabel = (variant) => {
  var variantAvailable = true;
  var qty = 0;

  if (variant) {
    variantAvailable = variant.available;
    qty = variant.inventory_quantity;
  } else {
    var selectedID = $('.jsc-mainID-pdp').val();
    $('.jsc-var-main-list').each(function(){
      if ($(this).val() == selectedID) {
        qty = parseInt($(this).attr('data-inventory'), 10);
        variantAvailable = $(this).attr('data-available') !== 'false';
      }
    });
  }

  // Per option row (e.g. Book Jacket vs Agenda): use that option's selected swatch
  // disabled state from variant-picker — not the combined URL variant availability.
  $('.jsc-product-stock-label').each(function(){
    var $label = $(this);
    var $option = $label.closest('.variant-picker__option');
    if (!$option.length) {
      return;
    }

    var $checked = $option.find('.variant-picker__option-values input:checked').first();
    if (!$checked.length) {
      $checked = $option.find('input.jsc-var-no-color, input[type="hidden"][name^="option"]').first();
    }

    var selectedAvailable = true;
    var selectedQty = 0;

    if ($checked.length) {
      var $swatchLabel = $checked.next('label');
      if (!$swatchLabel.length) {
        var checkedId = $checked.attr('id');
        $swatchLabel = $option.find('label[data-option-value]').filter(function() {
          return $(this).attr('for') === checkedId;
        }).first();
      }
      // Also support dropdown buttons as option values
      if (!$swatchLabel.length) {
        $swatchLabel = $option.find('[data-option-value][aria-selected="true"]').first();
      }

      // theme.js is-disabled is the source of truth for multi-option combinations
      if ($swatchLabel.length) {
        selectedAvailable = !$swatchLabel.hasClass('is-disabled');
      } else if ($checked.attr('data-available') !== undefined) {
        selectedAvailable = $checked.attr('data-available') !== 'false';
      }

      selectedQty = parseInt($checked.attr('data-inventory') || ($swatchLabel.attr('data-inventory') || ''), 10);
      if (isNaN(selectedQty)) {
        selectedQty = 0;
      }
    }

    if (!selectedAvailable) {
      $label.text('Sold Out').addClass('lowstockactive');
    } else if (selectedQty < 5 && selectedQty > 0) {
      $label.text('Low In Stock').addClass('lowstockactive');
    } else {
      $label.text('Low In Stock').removeClass('lowstockactive');
    }
  });

  // Title / non-option labels only (combined variant / ATC level).
  $('.lowstocklabel').not('.jsc-product-stock-label').each(function(){
    var $label = $(this);
    if (!variantAvailable) {
      $label.text('Sold Out').addClass('lowstockactive');
    } else if (qty < 5 && qty > 0) {
      $label.text('Low In Stock').addClass('lowstockactive');
    } else {
      $label.text('Low In Stock').removeClass('lowstockactive');
    }
  });
};

// Keep Klaviyo BIS in sync with the selected / first-available variant.
// Without ?variant= in the URL, Klaviyo uses the first variant (often sold out)
// even when the theme already selected an available colour.
syncKlaviyoBisVisibility = (variant) => {
  var available = true;

  if (variant && typeof variant.available !== 'undefined') {
    available = !!variant.available;
  } else {
    var selectedID = String($('.jsc-mainID-pdp').filter(':not(:disabled)').val() || $('form[is="product-form"] [name="id"]').filter(':not(:disabled)').first().val() || '');
    var matched = false;
    $('.jsc-var-main-list').each(function(){
      if (String($(this).val()) === selectedID) {
        available = $(this).attr('data-available') !== 'false';
        matched = true;
      }
    });
    if (!matched) {
      var $atc = $('#AddToCart, .ProductForm__AddToCart').first();
      if ($atc.length) {
        available = !$atc.is(':disabled');
      }
    }
  }

  var $bis = $('.btn.klaviyo-bis-trigger');
  if (!$bis.length) {
    return;
  }

  if (available) {
    $bis.hide();
  } else {
    $bis.show();
  }
};

// Re-sync after variant-picker finishes applying is-disabled (async product load + combination rules).
$(document).on('variant:change', function(evt) {
  var variant = evt && evt.originalEvent && evt.originalEvent.detail && evt.originalEvent.detail.variant;
  setTimeout(function() {
    updateLowStockLabel(variant);
    syncKlaviyoBisVisibility(variant);
  }, 20);
});

$(function() {
  setTimeout(function() {
    updateLowStockLabel();
    syncKlaviyoBisVisibility();
  }, 500);
  // Klaviyo injects the BIS trigger asynchronously after onsite.js loads.
  var bisTries = 0;
  var bisTimer = setInterval(function() {
    bisTries += 1;
    if ($('.btn.klaviyo-bis-trigger').length || bisTries > 20) {
      syncKlaviyoBisVisibility();
      clearInterval(bisTimer);
    }
  }, 250);
});

initfoil = (col) =>{
  
  //low stock hide/show - START
  setTimeout(function () {
    updateLowStockLabel();
  }, 50 );
  //low stock hide/show - END

  var color = $('.jsc-col-var input:checked').val();
  if (col) {
    color = col;
  }

  if ($('.foil-selected').attr('data-val') == 'Blind Deboss') {
    var $textPersonalise = $('.personalisation-text');
    var colorvar = col;
    var hasdebosscol = false;

    $('.deboss-color-data').each(function(){
      var varcol = $(this).val();
      var coldeboss = $(this).attr('data-coldeboss');
      if (colorvar == varcol) {
        $textPersonalise.css('background', coldeboss);
        hasdebosscol = true;
      }
    });

    if (hasdebosscol == false) {
      $textPersonalise.css('background', '#666666');
    }
  }

  var colorlist = $('.secondfoilList').val().split(',');
  var showfoil2 = false;
  for (var i = 0; i < colorlist.length; i++) {
    var colorcheck = colorlist[i];
    colorcheck = $.trim(colorcheck);
    if (colorcheck == color) {
      showfoil2 = true;
    }
  }
  if (showfoil2) {
    $('.jsc-foil2').show();
    $('.jsc-foil1').hide();
    if ($('.foil-selected').hasClass('jsc-foil1')) {
      var colorPrev = $('.foil-selected').attr('data-val');
      $('.jsc-foil2').each(function(){
        var colorCheck = $(this).attr('data-val');
        if (colorCheck == colorPrev ) {
          $(this).click();
        }
      });
    }
  }else{
    $('.jsc-foil2').hide();
    $('.jsc-foil1').show();
    if ($('.foil-selected').hasClass('jsc-foil2')) {
      var colorPrev = $('.foil-selected').attr('data-val');
      $('.jsc-foil1').each(function(){
        var colorCheck = $(this).attr('data-val');
        if (colorCheck == colorPrev ) {
          $(this).click();
        }
      });
    }
  }
}
swapfiler = (evt) =>{
  $(evt).parents('.h-stack').find('input').prop('checked',false);
}

//Start - Giftwrap
onloadgiftWrap = () =>{
  if ($('#selected-gift-wrap').length > 0) {
    $('.gift-container input').each(function(){
      $(this).prop('checked', true);
      $('#selected-gift-wrap').val($(this).val());
      var $priceNum = $(this).next().attr('data-price-number');
      if ($priceNum && $priceNum > 0) {
        var $bindId = $('.jsc-mainID-pdp').val() + $(this).val();
        var $handleizeBindId = $bindId.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        $('.append-bindid-gift-wrap').append('<input type="hidden" id="gift-wrap-id" name="properties[BindID]" class="gift-radio" value="'+ $handleizeBindId +'">')
        $('#AddToCart').addClass('add-gift-wrap');
      }
      return false;
    });
  }
}

addgiftwrapnormal = (elhasclass) =>{
  if (elhasclass == true) {
    var $giftVid = parseInt($('.gift-container input:checked').attr('data-vid'));
    var $giftObj = {};
    var $bindId = $('.jsc-mainID-pdp').val() + $('.gift-container input:checked').val();
    var $handleizeBindId = $bindId.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

    $giftObj['Gift Wrap'] = $('.gift-container input:checked').val();
    $giftObj['BindID'] = $handleizeBindId;
    $giftObj['Personalise'] = true;
    cartJSAddQuery($giftVid, 1,$giftObj);
  }
}
//End - Giftwrap

clearCart = (evt) =>{
  window.location.href = $(evt).attr('data-href'); 
}

closepopup = (evt) =>{
  $('.NewsletterPopup').attr('aria-hidden','true');
  localStorage.setItem('popupnewsletter', 'true');
}

closealcoholpopup = (evt) =>{
  $('#prompt-background').hide();
  localStorage.setItem('popupalcohol', 'true');
}

//Start - Shipping bar
shippingBarUpdate = () =>{
  setTimeout(function () {
    var $minSGD = parseInt($('.jsc-sgd-min-price .money').attr('doubly-currency-sgd'));
    var $minOTHER = parseInt($('.jsc-other-min-price .money').attr('doubly-currency-sgd'));
    var $cartTOTAL = parseInt($('.jsc-cart-total-price .money').attr('doubly-currency-sgd'));
    var $currentCurrency = $('.jsc-cart-total-price .money').attr('doubly-currency');
    var $cartAwaySGD = $('.jsc-cart-away-sgd-price .money').first().text();
    var $cartAwayOTHER = $('.jsc-cart-away-other-price .money').first().text();
    
    /*
    if ($currentCurrency != "SGD") {
      if ($cartTOTAL >= $minOTHER) {
        $('.cart_delivery').hide();
        $('.cart_freelocaldelivery').show();
        $('.jsc-current-bar').css('width' , '100%') 
        $('.js-free-shipping').show();
      }else{
        $('.jsc-localship-text').text('Just ' + $cartAwayOTHER + ' away from free international shipping!');
        var progress = 100 - [($minOTHER-$cartTOTAL)/$minOTHER * 100];
        $('.jsc-current-bar').css('width' , progress + '%') 
        $('.cart_delivery').show();
        $('.cart_freelocaldelivery').hide();
        $('.js-free-shipping').show();
      }
    }
    else{
    */
      if (isNaN($cartTOTAL)) {
        $cartTOTAL = parseInt($('.jsc-cart-total-price').attr('data-price'));
      }
      if (isNaN($minSGD)) {
        $minSGD = parseInt($('.jsc-sgd-min-price').attr('data-price'));
      }
      if ($cartTOTAL >= $minSGD) {
        if ($cartTOTAL >= $minOTHER) {
          $('.cart_delivery').hide();
          $('.cart_freelocaldelivery').show();
          $('.jsc-current-bar').css('width' , '100%'); 
          $('.js-free-shipping').show();
        }else{
          $('.jsc-localship-text').html('<strong>Your shipping to Singapore is on us!</strong><br> Spend <strong class="boldpriceship">' + $cartAwayOTHER + '</strong> more to enjoy free international shipping!');
          var progress = 100 - [($minOTHER-$cartTOTAL)/$minOTHER * 100];
          $('.jsc-current-bar').css('width' , progress + '%') 
          $('.cart_delivery').show();
          $('.cart_freelocaldelivery').hide();
          $('.js-free-shipping').show();
        }
      }else{
        $('.jsc-localship-text').html('You are <strong class="boldpriceship">' + $cartAwaySGD + '</strong> away from free SG shipping.<br> Spend <strong class="boldpriceship">' + $cartAwayOTHER + '</strong> more to enjoy free international shipping!');
        var progress = 100 - [($minSGD-$cartTOTAL)/$minSGD * 100];
        $('.jsc-current-bar').css('width' , progress + '%'); 
        $('.cart_delivery').show();
        $('.cart_freelocaldelivery').hide();
        $('.js-free-shipping').show();
      }
    /*
    }
    */
  }, 1000 );
}
//End - Shipping bar

//Start - filterpopup
openfilterpopup = (evt,title) =>{
  /*
  $('.facets-sidebar .accordion.group').removeAttr('open');
  $('.facets-sidebar .accordion__content').hide();
  */
  $('.facets-sidebar .accordion.group').each(function(){
    var $this = $(this);
    var _title = $this.attr('data-title');
    if (_title == title ) {
      console.log(_title);
      $(evt).find('.accordion__content').show();
      $(evt).find('.accordion.group').attr('open');
    }else{
      $this.removeAttr('open');
      $this.find('.accordion__content').hide();
    }
  });
  /*
  $(evt).find('.accordion__content ').show();
  $(evt).find('.accordion.group').attr('open');
  */
}
//End - filterpopup

//Start - Siderbar Mobile Menu
openlevel2Menu = (evt) =>{
  $(evt).toggleClass('openlevel2');
  $(evt).next().toggleClass('openlevel2active');
}
//End - Siderbar Mobile Menu

//start: add item from grid in cart drawer
jscAddFromGrid = (e,varId) => {
  cartJSAddQuery(varId, 1,{});
}
//end: add item from grid in cart drawer

openFaqAccount = () =>{
  $('.faq-popup-content').show();
}
closeFaqAccount = () =>{
  $('.faq-popup-content').hide();
}

onclickDebossChange = (color) =>{

}

// start: cp tag highlight slider
initTagSlider = () => {
  var $tagFilter = $('.tag-filters');
  if ($tagFilter.length > 0 && $(window).width() <= 820) {
    $tagFilter.flickity({
      cellAlign: 'center',
      contain: true,
      pageDots: false,
      wrapAround: false,
      draggable: true,
      prevNextButtons: false
    });
  }
}
// end: cp tag highlight slider
// start: update 
rerenderCP = (tagurl,colurl,reset) => {
  var currenturl = window.location.protocol + "//" + window.location.host + window.location.pathname;
  currenturl = currenturl.split(colurl);
  currenturl = currenturl[0];
  if (!reset) {
    var refresh = currenturl + colurl + '/' + tagurl;
  }else{
    var refresh = currenturl + colurl;
  }
  window.history.pushState({ path: refresh }, '', refresh);

  var headerID = $('.shopify-section--main-collection').attr('id').replace('shopify-section-','').replace(' ','');
  var headerIDpath = "?sections=" + $('.shopify-section--main-collection').attr('id').replace('shopify-section-','').replace(' ','');
  fetch(window.location.pathname + headerIDpath)
  .then(res => res.json())
  .then((restext) => {
    $('.shopify-section--main-collection').addClass('removeRerender');
    html = $.parseHTML( restext[headerID] );
    $( html ).insertBefore( ".removeRerender" );
    $('.removeRerender').remove();
  });

}
// end: cp tag highlight slider

// start: product level gift message
disabledemojigift  = (e) => {
  var $textVal = $(e).val();
  console.log($(e).val());
  var temp = $textVal.replace(/[^'.&a-zA-Z0-9!*()-+=<>:""@#$%^\s\-]/g, '');
  console.log(temp);
  $(e).val(temp);
}

updateCharacterCount = (e) => {
  var $textVal = $(e).val();
  var temp = $textVal.replace(/[^'.&a-zA-Z0-9!*()-+=<>:""@#$%^\s\-]/g, '');
  var giftMessage = temp;
  var characterCount = temp.length;
  var countText = $(e).parents('.jsc-pdp-gift-message-wrapper').find('.jsc-character-count');
  countText.text(characterCount);

  $(e).val(giftMessage);
  $('.jsc-product-gift-message').val(giftMessage);
}

showGiftMessageModal = (e) => {
  var key = $(e).parent().attr('data-line-key');
  var $modal = $('.jsc-gift-message-form-modal-wrapper');
  var $overlay = $($modal).siblings('.jsc-form-overlay');
  var $textInput = $($modal).find('.jsc-gift-message-form-input');

  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    var cartItems = data.items;
    var selectedLineItem = cartItems.find(function(obj) {
      return obj.key === key;
    });
    
    if(selectedLineItem.properties['Gift Message'] != "") {
      $textInput.text(selectedLineItem.properties['Gift Message']);
    }
    else {
      $textInput.text('');
    }
    $overlay.show();
    $modal.show();
    $modal.attr('data-line-key', key);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

updateGiftMessage = (e) => {
  var key = $(e).parents('.jsc-gift-message-form-modal-wrapper').attr('data-line-key');
  var $textInput = $(e).parents('.jsc-gift-message-form-modal-wrapper').find('.jsc-gift-message-form-input');

  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    var cartItems = data.items;
    var itemToUpdate = cartItems.find(function(obj) {
      return obj.key === key;
    });

    var itemProps = itemToUpdate.properties;
    var itemQty = itemToUpdate.quantity;
    if($textInput.val() != "") {
      itemProps['Gift Message'] = $textInput.val();
      if (itemProps['Blank Card'] === 'Yes') {
        itemProps['Blank Card'] = 'No';
      }
    }
    else {
      delete itemProps['Gift Message'];
    }
    CartJS.updateItemById(key, itemQty, itemProps);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

removeGiftMessage = (e) => {
  var key = $(e).parents('.jsc-gift-message-form-modal-wrapper').attr('data-line-key');
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    var cartItems = data.items;
    var itemToUpdate = cartItems.find(function(obj) {
      return obj.key === key;
    });

    var itemProps = itemToUpdate.properties;
    var itemQty = itemToUpdate.quantity;
    itemProps['Gift Message'] = "";
    CartJS.updateItemById(key, itemQty, itemProps);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

hideGiftMessageModal = (e) => {
  var $modal = $(e).parents('.jsc-gift-message-form-modal-wrapper');
  var $overlay = $($modal).siblings('.jsc-form-overlay');
  $modal.hide();
  $overlay.hide();
}
// end: product level gift message

toggleDisclaimerTooltip = (e) => {
  var $tooltip = $(e).siblings('.jsc-disclaimer-tooltip');
  $tooltip.toggleClass('active');
}

opencloseTwinwire = (evt) =>{ 
  $('.selecteddropdown').each(function(){
    if ( $(this).is(evt) ) {
    }else{
      $(this).siblings('.dropdownwrapcnb').hide();
    }
  });
  $(evt).siblings('.dropdownwrapcnb').toggle();
}

jscCustomHotspot = (e) => {

  $(e).parents('.shop-the-look__image-wrapper').find('.jscCustomHotspot').each(function(){
    if ( $(this).is($(e)) ) {
    }else{
      $(this).removeClass('jsc-hotspot-active-plus').addClass('jsc-hotspot-after-click');
    }
  });

  $(e).parents('.shop-the-look__image-wrapper').find('.jsc-hotspot-content.jsc-hotspot-active').each(function(){
    if ( $(this).is($(e).parents('carousel-navigation').find('.jsc-hotspot-content')) ) {
    }else{
      $(this).removeClass('jsc-hotspot-active');
    }
  });

  if ($(e).parents('carousel-navigation').find('.jsc-hotspot-content.jsc-hotspot-active').length > 0) {
    $(e).removeClass('jsc-hotspot-active-plus').addClass('jsc-hotspot-after-click');
    $(e).parents('carousel-navigation').find('.jsc-hotspot-content.jsc-hotspot-active').removeClass('jsc-hotspot-active');
  }
  else {
    $(e).addClass('jsc-hotspot-active-plus').removeClass('jsc-hotspot-after-click');
    $(e).parents('carousel-navigation').find('.jsc-hotspot-content').addClass('jsc-hotspot-active');
  }
  
}

jscCustomHotspotmob = (e) => {

  $(e).parents('.shop-the-look__image-wrapper').find('.jscCustomHotspot').each(function(){
    if ( $(this).is($(e)) ) {
    }else{
      $(this).removeClass('jsc-hotspot-active-plus').addClass('jsc-hotspot-after-click');
    }
  });

  $(e).parents('.shop-the-look__image-wrapper').find('.jsc-hotspot-content.jsc-hotspot-active').each(function(){
    if ( $(this).is($(e).parents('carousel-navigation').find('.jsc-hotspot-content')) ) {
    }else{
      $(this).removeClass('jsc-hotspot-active');
    }
  });

  if ($(e).parents('carousel-navigation').prev().find('.popover.popover-active').length > 0) {
    $(e).removeClass('jsc-hotspot-active-plus').addClass('jsc-hotspot-after-click');
    $(e).parents('carousel-navigation').prev().find('.popover.popover-active').removeClass('popover-active');
  }
  else {
    $(e).addClass('jsc-hotspot-active-plus').removeClass('jsc-hotspot-after-click');
    $(e).parents('shop-the-look-mobile-carousel.shop-the-look__carousel').addClass('shoploopindex');
    $(e).parents('carousel-navigation').prev().find('.popover').addClass('popover-active');
  }
  
}

jscCustomHotspotmobclose = (e) => {

  console.log();

  $(e).parents('.hot-spot-mob').find('.popover.popover-active').removeClass('popover-active');
  $(e).parents('.hot-spot-mob').next().find('.jsc-hotspot-active-plus').removeClass('jsc-hotspot-active-plus').addClass('jsc-hotspot-after-click');
  
}

togglegiftcartdrawer = (e) => {
  $(e).parents('.togglegiftoptwrap').find('.togglegiftopt').toggle();
}

togglepdpgift = (e) => {
  $(e).parents('.togglepdpgiftoptwrap').find('.togglepdpgiftopt').toggle();
}


removeitemcart = (varkey,bind,bindlist) =>{
  if (bind == 'true') {
    var jsonObj = {};
    var splitbindlist = bindlist.split(",");
    for (var i = 0; i < splitbindlist.length; i++) {
      jsonObj[splitbindlist[i]] = 0;
    }
    console.log(jsonObj);
    CartJS.updateItemQuantitiesById(jsonObj);
  }else{
    var jsonObj = {};
    jsonObj[varkey] = 0;
    CartJS.updateItemQuantitiesById(jsonObj);
  }
}

// Called from inline onchange on gifting checkboxes (render-product-gifting.liquid) so quick-buy clones keep behavior.
window.onPdpGiftCheckboxChange = function(el) {
  var $cb = $(el);
  var $giftRoot = $cb.closest('.jsc-pdp-gift-message-wrapper');
  var $toggleRoot = $cb.closest('.togglepdpgiftopt');
  var formId = el.getAttribute('form');
  var $form = formId && document.getElementById(formId) ? $(document.getElementById(formId)) : $cb.closest('form');
  var bindClass = $cb.attr('data-input-bind');

  if ($cb.is(':checked')) {
    if ($cb.hasClass('jsc-pdp-card-option')) {
      $toggleRoot.find('.jsc-pdp-card-option').not(el).prop('checked', false);
    }
    if (bindClass === 'jsc-product-cardwithmessage') {
      $giftRoot.find('.jsc-pdp-gift-message-section').show();
      $giftRoot.find('.jsc-pdp-gift-message-options-refresh').trigger('click');
      $giftRoot.find('.jsc-pdp-gift-message-options-wrapper-main').show();
    } else if (bindClass) {
      $form.find('.' + bindClass).val('Yes');
    }
  } else {
    if (bindClass === 'jsc-product-cardwithmessage') {
      $giftRoot.find('.jsc-pdp-gift-message-section').hide();
      $giftRoot.find('.jsc-pdp-gift-message-options-wrapper-main').hide();
    } else if (bindClass) {
      $form.find('.' + bindClass).val('No');
    }
  }
  if (!$giftRoot.find('input[data-input-bind="jsc-product-cardwithmessage"]').is(':checked')) {
    $giftRoot.find('.jsc-pdp-gift-message-section').hide();
    $giftRoot.find('.jsc-pdp-gift-message-options-wrapper-main').hide();
  }
};

// start: pdp page drawer
openPageDrawer = () => {
  var $pageDrawerOverlay = $('.jsc-pdp-page-overlay');
  var $pageDrawer = $('.jsc-pdp-page-drawer-wrapper');

  $pageDrawerOverlay.addClass('active');
  $pageDrawer.addClass('active');
}

closePageDrawer = () => {
  var $pageDrawerOverlay = $('.jsc-pdp-page-overlay');
  var $pageDrawer = $('.jsc-pdp-page-drawer-wrapper');

  $pageDrawerOverlay.removeClass('active');
  $pageDrawer.removeClass('active');
}

getPageContent = (e) => {
  var $el = $(e);
  var $pageDrawer = $('.jsc-pdp-page-drawer-wrapper');
  var href = $el.attr('data-page-handle') || $el.attr('href') || '';
  var pageHandle = String(href).replace(/#/g, '').replace(/^\/pages\//, '').split('?')[0].split('/')[0];

  if (!pageHandle) {
    return false;
  }

  if ($pageDrawer.length === 0) {
    return false;
  }

  $.ajax({
    url: `/pages/${pageHandle}`,
    cache: false,
    method: "GET",
    success: function(response) {
      var $parsed = $('<div>').append($.parseHTML(response));
      var $content = $parsed.find('main#main.anchor');

      if ($content.length === 0) {
        $content = $parsed.find('main#main');
      }

      if ($content.length === 0) {
        return;
      }

      $pageDrawer.html($content);
      $pageDrawer.prepend('<div onclick="closePageDrawer();" class="cartdrawerpopup"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M6.34425 7.398L1.27125 12.4713C1.13275 12.6096 0.958667 12.6804 0.749 12.6838C0.5395 12.6869 0.36225 12.6161 0.21725 12.4713C0.0724167 12.3263 0 12.1506 0 11.9443C0 11.7379 0.0724167 11.5623 0.21725 11.4173L5.2905 6.34425L0.21725 1.27125C0.0789167 1.13275 0.00808339 0.958667 0.00475006 0.749001C0.00158339 0.539501 0.0724167 0.36225 0.21725 0.21725C0.36225 0.0724167 0.537917 0 0.74425 0C0.950583 0 1.12625 0.0724167 1.27125 0.21725L6.34425 5.2905L11.4173 0.21725C11.5558 0.0789167 11.7298 0.00808339 11.9395 0.00475006C12.149 0.00158339 12.3263 0.0724167 12.4713 0.21725C12.6161 0.36225 12.6885 0.537917 12.6885 0.74425C12.6885 0.950584 12.6161 1.12625 12.4713 1.27125L7.398 6.34425L12.4713 11.4173C12.6096 11.5558 12.6804 11.7298 12.6838 11.9395C12.6869 12.149 12.6161 12.3263 12.4713 12.4713C12.3263 12.6161 12.1506 12.6885 11.9443 12.6885C11.7379 12.6885 11.5623 12.6161 11.4173 12.4713L6.34425 7.398Z" fill="#020202"/></svg></div>');
      openPageDrawer();
    },
    error: function() {}
  });

  return false;
}

// end: pdp page drawer
updateCharacterCountDeliveryNote = (e) => {
  var deliveryNoteMessage = $(e).val();
  var characterCount = $(e).val().length;
  var countText = $('.jsc-delivery-note-character-count');
  countText.text(characterCount);

  shouldUpdateDrawer = false;
  CartJS.setAttribute('DeliveryNote', deliveryNoteMessage);
}

OnloadCheckDeliveryNoteCheckbox = () => {
  var $checkbox = $('#defaultCheckbox2');
  if ($checkbox.length > 0) { 
    var isChecked = $checkbox[0].checked;
    if (isChecked) {
      $('.jsc-delivery-note-section').show();
    } else {
      $('.jsc-delivery-note-section').hide();
    }
  }
}

removepersonalitiontextcnb = () => {
  $('#personalize-text-input').val('');
  $('#personalize-textoverlay-span').text('');
}

togglePersonalitionTooltip = (e) => {
  var $tooltip = $(e).siblings('.personalition-popup-content');
  $('.personalition-popup-content').not($tooltip).removeClass('active');
  $tooltip.toggleClass('active');
}
closePersonalitionlearnmore = () => {
  $('.personalition-popup-content').removeClass('active');
}

customNotebookCustomDesc = (element) =>{
  if($('.jsc-selector-dropdown').length > 0){
    //Normal Product Description
    var variantDesc = $(element).find('.jsc-custom-variant-desc').html();
    console.log("variantDesc", variantDesc);
    var targetElement = $('[data-block-type="description"]');
    var childElement = targetElement.find('.accordion__content');
    
    if (variantDesc != '') {
      if (childElement.length) {
        childElement.html(variantDesc);
      }
    }
    //About The Artist Description
    var variantArtistDesc = $(element).find('.jsc-custom-variant-about-artist-desc').html();
    var targetElement = $('.jsc-about-artist-field');
    var childElement = targetElement.find('.accordion__content');
    if (variantArtistDesc != '') {
      if (childElement.length) {
        targetElement.show();
        childElement.html(variantArtistDesc);
      }
    }else{
      targetElement.hide();
    }
  }else{
    //Normal Product Description
    var variantDesc = $(element).find('.jsc-custom-variant-desc').html();
    var targetElement = $('[data-block-type="description"]');
    var childElement = targetElement.find('.accordion__content');
    
    if (variantDesc != '') {
      if (childElement.length) {
        childElement.html(variantDesc);
      }
    }
    //About The Artist Description
    var variantArtistDesc = $(element).find('.jsc-custom-variant-about-artist-desc').html();
    var targetElement = $('.jsc-about-artist-field');
    var childElement = targetElement.find('.accordion__content');
    if (variantArtistDesc != '') {
      if (childElement.length) {
        targetElement.show();
        childElement.html(variantArtistDesc);
      }
    }else{
      targetElement.hide();
    }
  }
}

openmagnifyrivet = () =>{
  $('.elasticBand .magnifywrap').click();
}

selectAddonscustomisedAtag = (evt) =>{
  var $this = $(evt);
  var $containerVal = $this.attr('data-container');
  var $addOnContainers = $('.addons-containers');
  var $addOnLabel = $('.category-label');
  var $addonImg = $('.customisedatag-addons');
  var $addonsName = $this.attr('data-tooltip');

  // Display selection text
  $('#addons-span').text($addonsName);

  // Hide all addons swatch container and gray out all border
  $addOnContainers.hide();
  $addOnLabel.css('border', '1px solid transparent');

  // Only show selected swatch for add ons and change label border to black
  $('.'+$containerVal).show();
  $this.css('border', '1px solid #89714B');

  // Hide add ons images
  $addonImg.hide();

  setTimeout(function(){
    $('.'+$containerVal).find('.dropdownlistcnb.dropdownactive').click();
  },1);
}

selectcustomiseAtagAddon = (evt,selectVal) =>{
  var $this = $(evt).find('label');
  var $addonImg = $('.customisedatag-addons');
  var $claspColorLabel = $('.clasp-color-label');
  var $selectedVal = $this.attr('data-tooltip');
  var $prodtitle = $this.attr('data-prod');
  var $imgUrl = $this.attr('data-img-url');
  var $colorSwatchimg = $this.find('img').attr('src');

  // Border styling
  $claspColorLabel.css('border', 'none');
  $this.css('border', '1px solid #000');
  $(evt).parent().find('.dropdownlistcnb').removeClass('dropdownactive');
  $(evt).addClass('dropdownactive');
  $(evt).find('input').prop('checked', true);

  $(evt).parents('.stepselected').find('.selecteddropdown').html('<div><label for="black" class="twin-wire-swatch" data-tooltip="Black" style="background: black;"><img src="'+ $colorSwatchimg +'" class="full-height" alt=""><span class="u-visually-hidden">Black</span></label>' + selectVal + '</div>+');

  // hide all images
  $addonImg.hide();

  var length = $('.side-variant .variant-picker__option-values input:checked').val();
  if ($prodtitle.includes('phone')) {
    var selectedalt = $selectedVal;
    $addonImg.css('z-index','0');
  }else{
    var selectedalt = $selectedVal + '-' + length;
    $addonImg.css('z-index','-1');
  }

  $(evt).parents('.stepselected').find('.addon-img').each(function(){
    if ($(this).attr('data-alt') == selectedalt) {
      $addonImg.attr('src', $(this).attr('data-url'));
      $addonImg.attr('alt', $(this).attr('data-alt'));
      $addonImg.show();
    }
  });

}

customiseAtagBuy = (evt) =>{
  $(evt).prop('disabled',true);
  $(evt).addClass('importantshow');
  var $obj = {};
  var $prodVid = parseInt($('.jsc-mainID-pdp').val());
  var jsonObj = [];

  // Check if the selected add-on has a disabled dropdownactive option
  var selectcoladdonparent = $('.add-ons-customiseAtag-category input:checked').next().attr('data-container');
  if (selectcoladdonparent && selectcoladdonparent !== 'none') {
    var $dropdownactive = $('.'+selectcoladdonparent).find('.dropdownlistcnb.dropdownactive');
    if ($dropdownactive.length > 0 && $dropdownactive.hasClass('disabled')) {
      $('.next_addon_error_customiseatag').show();
      setTimeout(function(){
        $('.next_addon_error_customiseatag').hide();
      }, 3000);
      $(evt).prop('disabled',false);
      $(evt).removeClass('importantshow');
      return
    }
  }

  // Step 3
  var $nameInput = $('#personalize-text-input').val();
  var $fontFamily = $('.notebook-tab.personalize-tab .font-type-container .jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-font-name');
  var $fontSize = $('.notebook-tab.personalize-tab .font-type-container .jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-size');
  var $textColor = $('.foil-radio:checked').val();
  var $textColorCode = $('.foil-radio:checked').attr('data-foil-code');
  // Step 4
  var $addOn = $('.add-ons-radio:checked').val();
  // Step 5
  var $giftWrap = $('.gift-radio:checked');
  var $prod_gift_message = $('.jsc-pdp-gift-message-wrapper').find('.jsc-pdp-gift-message-input').val();
  var $prod_gift_blankcard = $('#pdpGiftCheckbox3').val();

  if ($nameInput){
    if ( $fontFamily == 'Copperplate' || $fontFamily == 'Script' || $fontFamily == 'Univers' ) {
    $obj['Personalisation'] = $nameInput.toUpperCase();
    }else {
    $obj['Personalisation'] = $nameInput;
    }

    $obj['Font Type'] = $fontFamily;
    $obj['Font Size'] = $fontSize;
    $obj['Stamp colour'] = $textColor;
    $obj['Stamp colour code'] = $textColorCode;
  }
  $obj['Add-on'] = $addOn;
  $obj['Packaging'] = $giftWrap.val();
  if ($("#pdpGiftCheckbox3").prop("checked")) {
    $obj['Blank Card'] = $prod_gift_blankcard;
  } else if ($("#pdpGiftCheckbox4").prop("checked")) {
    $obj['Gift Message'] = $prod_gift_message;
  }
  if ($('#pdpGiftCheckboxMdayPostcard').length) {
    $obj["Mother's Day Postcard"] = $('#pdpGiftCheckboxMdayPostcard').is(':checked') ? 'Yes' : 'No';
  }

  var selectcoladdonparent = $('.add-ons-customiseAtag-category input:checked').next().attr('data-container');
  var addoncolor = $('.'+selectcoladdonparent).find('.dropdownlistcnb.dropdownactive input:checked').val();
  if (addoncolor){
    $obj['Add-on Color'] = addoncolor;
  }

  $bindId = $prodVid + $nameInput + $fontFamily + $fontSize + $textColor + $addOn;
  var $handleizeBindId = $bindId.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

  //$obj['BindID'] = $handleizeBindId;
  var item = {};
  item ["id"] = $prodVid;
  item ["quantity"] = 1;
  item ["properties"] = $obj;
  jsonObj.push(item);

  CartJS.addItems(jsonObj,
    {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        console.log('success');
        $(evt).prop('disabled',false);
        $(evt).removeClass('importantshow');
              
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
        $(evt).prop('disabled',false);
        $(evt).removeClass('importantshow');
      }
    });

}


addBundleProduct = (evt) =>{
  var $this = $(evt);
  var jsonObj = [];
  var $obj = {};
  var $bindId = '';
  //Main Bundle Product
  var $mainBundle_Vid = parseInt($('.variant-picker__option-values .sr-only[name="option1"]:checked').attr('bundle-var-id'));
  var $mainBundle_Title = $('.variant-picker__option-values .sr-only[name="option1"]:checked').attr('bundle-prd-title');
  var $mainBundle_Option = $('.variant-picker__option-values .sr-only[name="option1"]:checked').val();
  var $mainBundleName = $mainBundle_Title+' / '+$mainBundle_Option;
  console.log("main-bundle", $mainBundle_Vid, $mainBundle_Title, $mainBundle_Option, $mainBundleName);

  if ($('.variant-picker__option-values .sr-only[name="option-bundle-prodmain1"]:checked').length > 0) {
  $mainBundle_Vid = parseInt($('.variant-picker__option-values .sr-only[name="option-bundle-prodmain1"]:checked').attr('bundle-var-id'));
  $mainBundle_Title = $('.variant-picker__option-values .sr-only[name="option-bundle-prodmain1"]:checked').attr('bundle-prd-title');
  $mainBundle_Option = $('.variant-picker__option-values .sr-only[name="option-bundle-prodmain1"]:checked').val();
  $mainBundleName = $mainBundle_Title+' / '+$mainBundle_Option;
  console.log("main-bundle", $mainBundle_Vid, $mainBundle_Title, $mainBundle_Option, $mainBundleName);
  }

  //Child Bundle Product
  var $childBundle_Vid = parseInt($('.variant-picker__option-values .sr-only[name="option-bundle-prod1"]:checked').attr('bundle-var-id'));
  var $childBundle_Title = $('.variant-picker__option-values .sr-only[name="option-bundle-prod1"]:checked').attr('bundle-prd-title');
  var $childBundle_Option = $('.variant-picker__option-values .sr-only[name="option-bundle-prod1"]:checked').val();
  var $childBundleName = $childBundle_Title+' / '+$childBundle_Option;
  console.log("child-bundle", $childBundle_Vid, $childBundle_Title, $childBundle_Option, $childBundleName);

  //Add Personalisation card
  var $prod_gift_blankcard = 'No';
  if ($('#pdpGiftCheckbox3').is(':checked')) {
    $prod_gift_blankcard = $('#pdpGiftCheckbox3').val();
  }
  var $prod_gift_message = $('.jsc-pdp-gift-message-wrapper').find('.jsc-pdp-gift-message-input').val();
  //Packaging
  var $giftWrap = $('.gift-radio:checked');

  var now = new Date();
  var uniqueDate = now.toISOString().replace(/[-:.]/g, '').slice(0, 14);
  $bindId = $mainBundle_Vid +'-'+uniqueDate+'-'+$childBundle_Vid;
  console.log("prod_gift_blankcard", $prod_gift_blankcard);
  console.log("prod_gift_message", $prod_gift_message);
  console.log("$bindId", $bindId);
  var $handleizeBindId = $bindId.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

  if($mainBundle_Vid != ""){
    var $mainBundleObj = {};
  
    $mainBundleObj['BindID'] = $handleizeBindId;
    $mainBundleObj['BundleProduct'] = 'main';
    $mainBundleObj['BundleWith'] = $childBundleName;
    $mainBundleObj['Packaging'] = $giftWrap.val();
    if ($("#pdpGiftCheckbox3").prop("checked")) {
      console.log("HERE", $("#pdpGiftCheckbox3").prop("checked"));
      $mainBundleObj['Blank Card'] = $prod_gift_blankcard;
    } else if ($("#pdpGiftCheckbox4").prop("checked")) {
      $mainBundleObj['Gift Message'] = $prod_gift_message;
    }
    if ($('#pdpGiftCheckboxMdayPostcard').length) {
      $mainBundleObj["Mother's Day Postcard"] = $('#pdpGiftCheckboxMdayPostcard').is(':checked') ? 'Yes' : 'No';
    }
    var item = {};
    item ["id"] = $mainBundle_Vid;
    item ["quantity"] = 1;
    item ["properties"] = $mainBundleObj;
    jsonObj.push(item);
  }

  if($childBundle_Vid != ""){
    var $childBundleObj = {};
  
    $childBundleObj['BindID'] = $handleizeBindId;
    $childBundleObj['BundleProduct'] = 'child';
    $childBundleObj['BundleWith'] = $mainBundleName;
    if ($("#pdpGiftCheckbox3").prop("checked")) {
      $childBundleObj['Blank Card'] = $prod_gift_blankcard;
    } else if ($("#pdpGiftCheckbox4").prop("checked")) {
      $childBundleObj['Gift Message'] = $prod_gift_message;
    }
    if ($('#pdpGiftCheckboxMdayPostcard').length) {
      $childBundleObj["Mother's Day Postcard"] = $('#pdpGiftCheckboxMdayPostcard').is(':checked') ? 'Yes' : 'No';
    }
    var item = {};
    item ["id"] = $childBundle_Vid;
    item ["quantity"] = 1;
    item ["properties"] = $childBundleObj;
    jsonObj.push(item);
  }
  console.log("jsonObj", jsonObj);
  CartJS.addItems(jsonObj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            beforeSend: function() {
              console.log('before');
            },
            success: function(cart) {
              console.log('success',location.pathname);
            }
          });
                
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown, textStatus);
                // Log the status code and error message
        console.log("Error occurred!");

        // Log the text status of the error
        console.log("Text Status:", textStatus);

        // Log the error thrown (if any)
        console.log("Error Thrown:", errorThrown);

        // Log the detailed response text from the server (if available)
        console.log("Response Text:", jqXHR.responseText);
        
        // Log the status code
        console.log("Status Code:", jqXHR.status);
        }
    });
}

leatherBundleProductAddToCart = (evt) => {
  var $this = $(evt);
  var $prodCost_add = {};
  var jsonObj = [];

  var $mainBundle_Vid = parseInt($('.variant-picker__option-values .sr-only[name="option1"]:checked').attr('bundle-var-id'));
  var $mainBundle_Title = $('.variant-picker__option-values .sr-only[name="option1"]:checked').attr('bundle-prd-title');
  var $mainBundle_Option = $('.variant-picker__option-values .sr-only[name="option1"]:checked').val();
  var $mainBundleName = $mainBundle_Title+' / '+$mainBundle_Option;
  console.log("main-bundle", $mainBundle_Vid, $mainBundle_Title, $mainBundle_Option, $mainBundleName);

  if ($('.variant-picker__option-values .sr-only[name="option-bundle-prodmain1"]:checked').length > 0) {
  $mainBundle_Vid = parseInt($('.variant-picker__option-values .sr-only[name="option-bundle-prodmain1"]:checked').attr('bundle-var-id'));
  $mainBundle_Title = $('.variant-picker__option-values .sr-only[name="option-bundle-prodmain1"]:checked').attr('bundle-prd-title');
  $mainBundle_Option = $('.variant-picker__option-values .sr-only[name="option-bundle-prodmain1"]:checked').val();
  $mainBundleName = $mainBundle_Title+' / '+$mainBundle_Option;
  console.log("main-bundle", $mainBundle_Vid, $mainBundle_Title, $mainBundle_Option, $mainBundleName);
  }

  var $childBundle_Vid = parseInt($('.variant-picker__option-values .sr-only[name="option-bundle-prod1"]:checked').attr('bundle-var-id'));
  var $childBundle_Title = $('.variant-picker__option-values .sr-only[name="option-bundle-prod1"]:checked').attr('bundle-prd-title');
  var $childBundle_Option = $('.variant-picker__option-values .sr-only[name="option-bundle-prod1"]:checked').val();
  var $childBundleName = $childBundle_Title+' / '+$childBundle_Option;
  console.log("child-bundle", $childBundle_Vid, $childBundle_Title, $childBundle_Option, $childBundleName);

  //Add Personalisation card
  var $prod_gift_blankcard = 'No';
  if ($('#pdpGiftCheckbox3').is(':checked')) {
    $prod_gift_blankcard = $('#pdpGiftCheckbox3').val();
  }
  var $prod_gift_message = $('.jsc-pdp-gift-message-wrapper').find('.jsc-pdp-gift-message-input').val();
  var $prodCost_vid = parseInt($this.attr('data-prodCostVid'));
  var $prodCost_price = parseInt($this.attr('data-prodCostPrice'));
  var $prodTitle = $this.attr('data-prodTitle');
  var $prodCost_title = $this.attr('data-prodCostTitle');

  var leatherInputElBundle = document.getElementById('leather-text');
  var $inputTextRawBundle = $('#leather-text').val();
  var $inputText = jscClampLeatherTextToMaxlength($inputTextRawBundle, leatherInputElBundle);
  if (leatherInputElBundle && $inputTextRawBundle !== $inputText) {
    $('#leather-text').val($inputText);
    $('.personalisation-text').text($inputText);
  }
  var $fontType = $('.font-type-container').find('.jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-font-name');
  var $fontSize = $('.font-type-container').find('.jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-size');
  var $fontSizeMm = $('.font-type-container').find('.jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-size');
  var $layout = $('.layout-container').find('.jsc-dropdown-options .jsc-option[selected="selected"]').text();
  var $foilColor = $('.foil-option.foil-selected').data('val');
  $fontType =  $.trim($fontType);

  // Gift Wrap options
  var $giftWrap = $('.gift-radio:checked');

  if ($inputText == '') {
    $('#input-text-error').show();
  }
  else if ($fontType == null) {
    $('#font-type-error').show();
  }
  else if ($fontSize == null) {
    $('#font-size-error').show();
  }
  else {
    $prodCost_add['Personalise'] = $prodTitle;
    $prodCost_add['Font Type'] = $fontType;
    $prodCost_add['Font Size'] = $fontSizeMm;
    $prodCost_add['Foil Colour'] = $foilColor;
    $prodCost_add['Font Position'] = $layout;

    var now = new Date();
    var uniqueDate = now.toISOString().replace(/[-:.]/g, '').slice(0, 14);
    $bindId = $mainBundle_Vid +'-'+uniqueDate+'-'+$childBundle_Vid;
    console.log("prod_gift_blankcard", $prod_gift_blankcard);
    console.log("prod_gift_message", $prod_gift_message);
    console.log("$bindId", $bindId);
    var $handleizeBindId = $bindId.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

    if ($fontType == 'Copperplate' || $fontType == 'Script' || $fontType == 'Univers' ) {
    $prodCost_add['Personalisation'] = $inputText.toUpperCase();
    }else {
    $prodCost_add['Personalisation'] = $inputText;
    }
    $prodCost_add['BindID'] = $handleizeBindId;
    $prodCost_add['Packaging'] = $giftWrap.val();
  
    if($mainBundle_Vid != ""){
      var $mainBundleObj = {};
      $mainBundleObj['BindID'] = $handleizeBindId;
      $mainBundleObj['BundleProduct'] = 'main';
      $mainBundleObj['BundleWith'] = $childBundleName;
      $mainBundleObj['Font Type'] = $fontType;
      $mainBundleObj['Font Size'] = $fontSizeMm;
      $mainBundleObj['Foil Colour'] = $foilColor;
      $mainBundleObj['Font Position'] = $layout;
      if ($fontType == 'Copperplate' || $fontType == 'Script' || $fontType == 'Univers' ) {
      $mainBundleObj['Personalisation'] = $inputText.toUpperCase();
      }else {
      $mainBundleObj['Personalisation'] = $inputText;
      }
      $mainBundleObj['Packaging'] = $giftWrap.val();
      if ($("#pdpGiftCheckbox3").prop("checked")) {
        $mainBundleObj['Blank Card'] = $prod_gift_blankcard;
      } else if ($("#pdpGiftCheckbox4").prop("checked")) {
        $mainBundleObj['Gift Message'] = $prod_gift_message;
      }
      if ($('#pdpGiftCheckboxMdayPostcard').length) {
        $mainBundleObj["Mother's Day Postcard"] = $('#pdpGiftCheckboxMdayPostcard').is(':checked') ? 'Yes' : 'No';
      }
      if ($prodCost_price > 0){
        var item = {};
        item ["id"] = $prodCost_vid;
        item ["quantity"] = 1;
        item ["properties"] = $prodCost_add;
        jsonObj.push(item);

        var item = {};
        item ["id"] = $mainBundle_Vid;
        item ["quantity"] = 1;
        item ["properties"] = $mainBundleObj;
        jsonObj.push(item);
      }else{
        var item = {};
        item ["id"] = $mainBundle_Vid;
        item ["quantity"] = 1;
        item ["properties"] = $mainBundleObj;
        jsonObj.push(item);
      }
    }
  
    if($childBundle_Vid != ""){
      var $childBundleObj = {};
    
      $childBundleObj['BindID'] = $handleizeBindId;
      $childBundleObj['BundleProduct'] = 'child';
      $childBundleObj['BundleWith'] = $mainBundleName;
      var item = {};
      item ["id"] = $childBundle_Vid;
      item ["quantity"] = 1;
      item ["properties"] = $childBundleObj;
      jsonObj.push(item);
    }
    console.log("jsonObj", jsonObj);
    CartJS.addItems(jsonObj,
      {
          // Define a success callback to display a success message.
          "success": function(data, textStatus, jqXHR) {
              console.log('success');
                  
          },
          // Define an error callback to display an error message.
          "error": function(jqXHR, textStatus, errorThrown) {
          console.log("Error occur !", errorThrown, textStatus);
          }
      });
  }
}
bundleVariantSwap = (evt,optionValue) =>{
  $('variant-option-value[for="option-bundle-prod1"]').text(optionValue);
  console.log("evt", evt);
  if ($(evt).hasClass('is-disabled')) {
    $('#personaliseBtn').addClass('hideimportant');
    $('.jsc-atc').text('Sold out');
    $('.jsc-atc').addClass('sold_out_personalize');
    $('.jsc-atc').attr('onclick','');
    $('.ProductForm__AddToCart').attr('disabled', 'disabled');
    $('.ProductForm__AddToCart').text('Sold out');
  }else{
    $('#personaliseBtn').removeClass('hideimportant').css('display', 'inline-block');
    $('.jsc-atc').text('add to cart');
    $('.jsc-atc').removeClass('sold_out_personalize');
    $('.jsc-atc').attr('onclick','leatherBundleProductAddToCart(this)');
    if ($(evt).attr('bundleprd') !== undefined) {
      // If the attribute exists, check if its value is 'true' or 'false'
      var bundlePrdValue = $(evt).attr('bundleprd');
      if (bundlePrdValue == 'true') {
        $('.ProductForm__AddToCart').removeAttr('disabled');
        $('.ProductForm__AddToCart').text('add to cart');
      }
    }
  }
}
// If any BindID / BundleHandle component is unavailable, Liquid marks every line
// in that set with .jsc-bundle_remove. Remove the whole set in one CartJS call
// so line keys do not shift between sequential updates.
removeBundleProd = () =>{
  var $removeBDProd = $('.jsc-bundle_remove');
  if (!$removeBDProd.length || typeof CartJS === 'undefined') return;

  var qtyMap = {};
  $removeBDProd.each(function(){
    var key = String($(this).val() || '').trim();
    if (key) qtyMap[key] = 0;
  });

  if (!Object.keys(qtyMap).length) return;

  console.log('remove bundle prod (unavailable set)', qtyMap);
  if (typeof CartJS.updateItemQuantitiesById === 'function') {
    CartJS.updateItemQuantitiesById(qtyMap);
  } else {
    Object.keys(qtyMap).forEach(function(key) {
      CartJS.updateItemById(key, 0);
    });
  }
}

shogunflickity = () =>{
  setTimeout(function(){
    $('.jsc-shogun-flickity .shg-category-grid').append('<div class="splide"><div class="splide__track"></div></div>');
    $('.jsc-shogun-flickity .splide__track').append($('.jsc-shogun-flickity .shg-category-row'));
    $('.jsc-shogun-flickity .shg-category-row').addClass('splide__list');
    $('.jsc-shogun-flickity .shg-category-col').addClass('splide__slide');
    $('.jsc-shogun-flickity .shg-category-row').append($('.jsc-shogun-flickity .shg-category-col').clone());
    var splides = $('.splide');
    if (splides.length) {
      for (var i = 0; i < splides.length; i++) {
        new Splide(splides[i], { // Pass splides[i] instead of $('.splide')
          type: 'loop',
          drag: 'free',
          focus: 'center',
          pagination: false,
          toggle: false,
          arrows: false,
          perPage: 6,
          autoScroll: {
            speed: 1,
            pauseOnHover: false,
          },
        }).mount( window.splide.Extensions );
      }
    }
    setTimeout(function(){
    var $maxHeight = 0;
    $('.jsc-shogun-flickity .splide__slide .shogun-image').each(function(){
      var $ConTentHeight = $(this).outerHeight();
      if ($maxHeight == 0) {
        $maxHeight = $ConTentHeight;
      }
      if ($maxHeight > $ConTentHeight) {
        $maxHeight = $ConTentHeight;
      }
    });
    $('.jsc-shogun-flickity .splide__slide .shogun-image').css("height", $maxHeight + "px");
    var $maxHeightgrid = 0;
    $('.jsc-shogun-flickity .splide__slide').each(function(){
      var $ConTentHeight = $(this).outerHeight();
      if ($maxHeightgrid == 0) {
        $maxHeightgrid = $ConTentHeight;
      }
      if ($maxHeightgrid < $ConTentHeight) {
        $maxHeightgrid = $ConTentHeight;
      }
    });
    $('.jsc-shogun-flickity .splide__slide').css("height", $maxHeightgrid + "px");
    },500);
    $( window ).resize(function() {
      $('.jsc-shogun-flickity .splide__slide .shogun-image').removeAttr("style");
      $('.jsc-shogun-flickity .splide__slide').removeAttr("style");
      setTimeout(function(){
        var $maxHeight = 0;
        $('.jsc-shogun-flickity .splide__slide .shogun-image').each(function(){
          var $ConTentHeight = $(this).outerHeight();
          if ($maxHeight == 0) {
            $maxHeight = $ConTentHeight;
          }
          if ($maxHeight < $ConTentHeight) {
            $maxHeight = $ConTentHeight;
          }
        });
        $('.jsc-shogun-flickity .splide__slide .shogun-image').css("height", $maxHeight + "px");
        var $maxHeightgrid = 0;
        $('.jsc-shogun-flickity .splide__slide').each(function(){
          var $ConTentHeight = $(this).outerHeight();
          if ($maxHeightgrid == 0) {
            $maxHeightgrid = $ConTentHeight;
          }
          if ($maxHeightgrid < $ConTentHeight) {
            $maxHeightgrid = $ConTentHeight;
          }
        });
        $('.jsc-shogun-flickity .flickity-cell').css("height", $maxHeightgrid + "px");
      },500);
    });
  },500);
}

checkOrderLimitPrd = () =>{
  var $updateLimitProd = $('.jsc-limit-prd-update');
  $updateLimitProd.each(function(){
    var $_this = $(this);
    var $_pid = $_this.val();
    CartJS.updateItemById($_pid, 1);
  });
}

//Start - motif functions
swapcolormotif = (evt) =>{
  $(evt).parents('.foil-container').find('.foil-option').removeClass('foil-selected-motif');
  $(evt).addClass('foil-selected-motif');
  $(evt).parents('.foil-container').find('.showFoil').text($(evt).attr('data-val'))
  var colorselected = $(evt).attr('data-val').replace(/ /g, '');
  var motifselected = $('.active-design').attr('data-design').replace(/ /g, '-');
  var combinedcolmotif = motifselected + '-' + colorselected;
  combinedcolmotif = combinedcolmotif.toLowerCase();
  $('.imgmotiflist').each(function(){
    var altimg = $(this).attr('data-alt').toLowerCase();
    if (combinedcolmotif == altimg) {
      $('.motif-img-wrap img').attr('src', $(this).val())
    }
  });
}
updateoverlay = () =>{
  var colorselected = $('.foil-selected-motif').attr('data-val').replace(/ /g, '');
  var motifselected = $('.active-design').attr('data-design').replace(/ /g, '-');
  var combinedcolmotif = motifselected + '-' + colorselected;
  combinedcolmotif = combinedcolmotif.toLowerCase();
  $('.imgmotiflist').each(function(){
    var altimg = $(this).attr('data-alt').toLowerCase();
    if (combinedcolmotif == altimg) {
      $('.motif-img-wrap img').attr('src', $(this).val())
    }
  });
}
toggleOptionDropdownmotif = (e) => {
  var $selector = $(e).parents('.jsc-custom-selector');
  $selector.toggleClass('active');
}
changeSelectedOptionmotif = (e) => {
  var $otherOptions = $(e).siblings('.jsc-option');
  var $selector = $(e).parents('.jsc-custom-selector');

  // update selector
  $(e).attr('selected', 'selected');
  $(e).addClass('active-design');
  $otherOptions.removeAttr('selected');
  $otherOptions.removeClass('active-design');
  updateSelectorTextmotif();
  $selector.removeClass('active');  

  updateoverlay();
}
updateSelectorTextmotif = () => {
  var $selectors = $('.jsc-custom-selector');
  $selectors.each(function() {
    var selectedOptText = $(this).find('.jsc-dropdown-options .jsc-option[selected="selected"]').text();
    var $selectorText = $(this).find('.jsc-selected-text-motif');
    $selectorText.text(selectedOptText);
  })
}
clickPersonalisemotif = (evt) => {
  $(".motifpersonalizebtn").hide();
  $("#personaliseBtn").addClass('hideimportant');
  $(".ProductForm__AddToCart").hide();
  $(".motifpersonalize-wrap").show();
  $(".motif-img-wrap").show();
}
removePersonlisemotif = (evt) => {
  $(".motifpersonalizebtn").show();
  $("#personaliseBtn").removeClass('hideimportant').css('display', 'inline-block');
  $(".ProductForm__AddToCart").show();
  $(".motifpersonalize-wrap").hide();
  $(".motif-img-wrap").hide();
}
motifAddToCart = (evt) => {
  var $this = $(evt);
  var $prod = {};
  var $prodCost_add = {};
  var $prodVid = parseInt($('.jsc-mainID-pdp').val());
  var $prodCost_vid = parseInt($this.attr('data-prodCostVid'));
  var $prodCost_price = parseInt($this.attr('data-prodCostPrice'));
  var $prodTitle = $this.attr('data-prodTitle');
  var $prodCost_title = $this.attr('data-prodCostTitle');
  var $prod_gift_message = $('.jsc-pdp-gift-message-wrapper').find('.jsc-pdp-gift-message-input').val();
  var $prod_gift_blankcard = $('.jsc-product-blankcard').val();

  var $pricegiftNum = parseInt($('.gift-radio:checked').next().attr('data-price-number'));

  if (!$prodVid) {
    $prodVid = parseInt($('.not-prod-var').val());
  }

  if ($pricegiftNum > 0  && $prodCost_price <= 0 && $pricegiftNum) {
    $prodCost_price = $pricegiftNum;
    $prodCost_vid = parseInt($this.attr('data-prodcostvid'));
  }

  var $motifdesign = $('.active-design').attr('data-design');
  var $motifcolor = $('.foil-selected-motif').attr('data-val');

  $prodCost_add['Personalise Motif'] = $prodTitle;
  $prodCost_add['BindID'] = $prodVid+'-'+$prodCost_vid+'-'+$motifdesign+'-'+$motifcolor;

  $prod['Main Product'] = $prodCost_title;
  $prod['Motif Design'] = $motifdesign;
  $prod['Motif Color'] = $motifcolor;
  $prod['BindID'] = $prodVid+'-'+$prodCost_vid+'-'+$motifdesign+'-'+$motifcolor;
  $prod['Gift Message'] = $prod_gift_message;
  $prod['Blank Card'] = $prod_gift_blankcard;
  if ($('#pdpGiftCheckboxMdayPostcard').length) {
    $prod["Mother's Day Postcard"] = $('#pdpGiftCheckboxMdayPostcard').is(':checked') ? 'Yes' : 'No';
  }

  cartJSAddQuery($prodCost_vid, 1,$prodCost_add);
  cartJSAddQuery($prodVid, 1,$prod);
}

toggleLabelTooltip = (evt) => {
  var $this = $(evt);
  var $tooltip = $this.next('.pdp-label-tooltip');
  $tooltip.toggle();
}

opencloseGiftMessageOptions = (evt) => {
  var $this = $(evt);
  $this.siblings('.jsc-pdp-gift-message-options-list').toggle();
}

selectGiftMessageOptions = (evt) => {
  var $this = $(evt);
  console.log($this.parents('.jsc-pdp-gift-message-options-list'));
  $this.parents('.jsc-pdp-gift-message-options-list').find('div').removeClass('active');
  $this.addClass('active');
  $this.parents('.jsc-pdp-gift-message-options-container').find('.jsc-pdp-gift-message-options-select').text($this.text());
  $this.parents('.jsc-pdp-gift-message-options-list').hide();
  $this.parents('.jsc-pdp-gift-message-options-container').find('.jsc-pdp-gift-message-options-refresh').click();
}

// Gift message data organized by category
const giftMessageData = {
  'Birthday': [
    'Wishing you endless joy and laughter on your birthday. Celebrate big and smile even bigger!',
    'Happy Birthday! May this year bring you new adventures, great memories, and true happiness.',
    'Wishing you a day filled with joy and a year full of happiness. Happy Birthday!',
    'May your year ahead be filled with success, health, and happiness. Happy Birthday!',
    'Birthdays come and go, but amazing people like you make every year unforgettable. Enjoy!',
    'Cheers to you on your big day! May happiness find you and stay with you all year long.',
    'May your birthday be filled with fun, laughter, and all the love your heart can hold.',
    'Sending you smiles, hugs, and a ton of love on your special day. Happy birthday!',
    'Wishing you a birthday that\'s as amazing as you are. Enjoy every moment!',
    'Happy Birthday! May your dreams take flight and your heart feel full today and always.'
  ],
  'Wedding': [
    'Congratulations! Wishing you a lifetime of love, laughter, and a journey full of beautiful memories.',
    'May your marriage be filled with trust, happiness, and unconditional love. Best wishes always!',
    'Here\'s to love, laughter, and happily ever after. Congratulations on your wedding day!',
    'A perfect match, a perfect day! Wishing you both a future filled with joy and love.',
    'May today be the beginning of a long, beautiful chapter in your love story. Congrats!',
    'So happy for you both. May your life together be more amazing than you ever imagined!',
    'Love wins! Congratulations on tying the knot. Wishing you all the happiness in the world.',
    'You two are a beautiful reminder that true love still exists. Wishing you joy forever!',
    'From this day forward, may love be your guide and laughter your constant companion.',
    'May your hearts stay forever connected through life\'s every turn. Congratulations!'
  ],
  'Anniversaries': [
    'To my love, every year with you is a precious gift. Here\'s to many more together. Happy Anniversary!',
    'You are my forever and always. Thank you for being my partner, my best friend, and my everything.',
    'With all my heart, I celebrate the beautiful life we have built. I love you more each day.',
    'Happy Anniversary, my love. You make every moment brighter just by being you.',
    'You\'re my greatest blessing and joy. Thank you for filling my life with love and laughter.',
    'Every day with you feels like a dream come true. Happy Anniversary!',
    'Through every chapter, you are my constant. Here\'s to us and the love we share.',
    'Every moment with you is a treasure. Thank you for being my forever partner and my greatest love.',
    'My love for you grows deeper with each passing year. Happy Anniversary, my love!',
    'You complete me in every way. Here\'s to celebrating us today and always. I love you.'
  ],
  'Graduations': [
    'Congratulations, graduate! Your hard work has paid off—here\'s to the next big adventure!',
    'The tassel was worth the hassle—celebrate big today, your future just got brighter!',
    'So proud of all you\'ve achieved—cheers to the journey ahead and all you\'ll accomplish!',
    'Your success is well earned—wishing you endless opportunities and happiness ahead!',
    'Dream big, work hard, and keep going. Congrats on this amazing milestone!',
    'Graduation is not the end—it\'s just the beginning. Go chase your dreams with confidence!',
    'Hats off to you, grad! This is only the start of the great things you\'ll do.',
    'A bright future awaits—congratulations on all the hard work and determination!',
    'You did it! Time to celebrate everything you\'ve accomplished and all that\'s coming next!',
    'May this graduation open doors to new dreams, new goals, and endless possibilities!'
  ],
  'Farewell': [
    'Wishing you all the best on your next adventure. You\'ll be missed!',
    'Thank you for your hard work and friendship. Good luck in your new journey!',
    'It\'s been a pleasure working with you. Wishing you success and happiness ahead.',
    'Cheers to new beginnings and exciting challenges ahead! Keep shining!',
    'Here\'s to embracing change and all the wonderful opportunities that come with it. Wishing you the best!',
    'Farewell, and may your journey be filled with exciting new horizons.',
    'Your dedication and positivity have made a lasting impact. Wishing you all the best in your future endeavours!',
    'Here\'s to new opportunities, new adventures, and new successes. Farewell and all the best!'
  ],
  'Appreciate Message': [
    'We truly appreciate your support and the opportunity to be part of your journey.',
    'It\'s a privilege to be part of your journey, and we look forward to many more moments together.',
    'Thank you for your kindness and confidence in us. Your support inspires us to keep delivering our very best, and we are grateful to have you with us.',
    'We are grateful for the opportunity to work with you and thankful for the trust you\'ve placed in us.',
    'Thank you for your trust and support. We look forward to continuing this partnership and growing together.',
    'We deeply value the relationship we have built and are excited for what the future holds together.',
    'Thank you for your trust. We\'re truly grateful for the opportunity to serve you.',
    'Thank you for your trust and dedication. We truly appreciate everything you do and are grateful to have you on our team.',
    'Your hard work and commitment mean so much to us. Thank you for being a valued part of our journey.',
    'We appreciate your passion and effort every day. Thank you for your continued dedication and trust.',
    'Thank you for your unwavering trust and contribution. Together, we\'re building something great.',
    'Your trust and teamwork make all the difference. Thank you for being an essential part of our success.'
  ],
  'Housewarming': [
    'Congratulations on your new home! Wishing you lots of happiness, love, and wonderful memories in your new space.',
    'May your new house become a warm and welcoming home filled with joy and laughter.',
    'Wishing you all the best as you settle into your beautiful new home. Here\'s to new beginnings and happy memories!',
    'Congratulations on your new place! May it be filled with love, comfort, and countless joyful moments.',
    'A new home is the start of a new chapter. Wishing you happiness, peace, and endless blessings in your new space.',
    'Here\'s to a fresh start and many happy moments in your new home. Congratulations!',
    'May your new home bring you years of happiness, laughter, and cherished memories. Congratulations!',
    'Wishing you warmth, comfort, and joy in your new home. Congratulations on this wonderful milestone!',
    'Congratulations on your new home! May it be a place where dreams are nurtured and happiness grows.',
    'Best wishes as you turn your new house into a loving home. Cheers to new adventures and memories ahead!'
  ],
  'Teacher\'s Day': [
    'Thank you for being a great teacher. Happy Teacher\'s Day!',
    'Thank you for your dedication and for believing in every student\'s potential.',
    'Happy Teacher\'s Day! Thank you for inspiring and guiding me with patience and passion. Your support has made a lasting difference in my life.',
    'Happy Teacher\'s Day! I\'m grateful for your dedication and belief in me.',
    'Wishing you a wonderful day filled with appreciation for all that you do. Happy Teacher\'s Day!',
    'I am grateful for your mentorship and the confidence you have helped me build. Thank you.',
    'Your advice and encouragement have been invaluable. Thank you for being a wonderful mentor.',
    'Thank you for believing in me and guiding me every step of the way.'
  ],
  'Christmas': [
    'Wishing you a joyful festive season filled with peace, love, and happiness.',
    'May your holidays be merry and bright, and your new year full of promise.',
    'Warmest wishes for a wonderful Christmas and a happy, healthy new year.',
    'Sending you festive cheer and all the best for the year ahead.',
    'May this season bring you joy, laughter, and cherished moments with loved ones.',
    'Wishing you peace, love, and joy this holiday season and beyond.',
    'Hope your Christmas is filled with warmth and your new year with success.',
    'Sending heartfelt wishes for a magical and memorable festive season. Merry Christmas!',
    'May your holidays sparkle with happiness and your new year shine with opportunity.',
    'Wishing you a season full of blessings, joy, and treasured moments.'
  ]
};

// Function to get a random message from a category
function getRandomGiftMessage(category) {
  const messages = giftMessageData[category];
  if (messages && messages.length > 0) {
    const randomIndex = Math.floor(Math.random() * messages.length);
    return messages[randomIndex];
  }
  return '';
}

// Function to append message to gift input
function appendGiftMessage(message) {
  const $giftInput = $('.jsc-pdp-gift-message-input');
  if ($giftInput.length > 0) {
    const currentValue = $giftInput.val();
    const newValue = currentValue ? currentValue + ' ' + message : message;
    $giftInput.val(newValue);
    
    // Trigger character count update if the function exists
    if (typeof updateCharacterCount === 'function') {
      updateCharacterCount($giftInput[0]);
    }
  }
}

refreshGiftMessageOptions = (evt) => {
  var $this = $(evt);
  const selectedCategory = $this.parents('.jsc-pdp-gift-message-options-container').find('.jsc-pdp-gift-message-options-select').text().trim();
  
  if (selectedCategory && giftMessageData[selectedCategory]) {
    const randomMessage = getRandomGiftMessage(selectedCategory);
    if (randomMessage) {
      // Clear current value and set new message
      const $giftInput = $('.jsc-pdp-gift-message-input');
      if ($giftInput.length > 0) {
        $giftInput.val(randomMessage);
        
        // Trigger character count update if the function exists
        if (typeof updateCharacterCount === 'function') {
          updateCharacterCount($giftInput[0]);
        }
      }
    }
  }else{
    const $giftInput = $('.jsc-pdp-gift-message-input');
    if ($giftInput.length > 0) {
      $giftInput.val('');
    }
  }
}

// start: Image with text slider
initImageWithTextSlider = () => {
  $('.jsc-image-with-text-slider-wrapper .jsc-image-with-text-slider').flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    wrapAround: true,
    draggable: true,
    prevNextButtons: false
  });
}

increasePageDotProgress = ($dotProgress, duration, $slider) => {
  var barWidth = 0;
  var increment = 100 / (duration / 10);

  clearInterval(intervalID);
  intervalID = setInterval(() => {
    if(barWidth >= 100) {
      clearInterval(intervalID);
      $slider.flickity('next');
    }
    else {
      barWidth += increment;
      $dotProgress.css('width', barWidth + '%');
    }
  }, 10);
}

updateSliderNavProgress = (dotIndex) => {
  var $slider = $('.jsc-image-with-text-slider-wrapper .jsc-image-with-text-slider');
  var isDesktopAuto = $slider.attr('data-desktop-auto');
  var isMobileAuto = $slider.attr('data-mobile-auto');
  var duration = parseInt($slider.attr('data-duration')) * 1000;
  var $pageNumber = $('.jsc-slider-nav-button-wrapper').find('.jsc-current-page-number');
  var $pageDots = $('.jsc-image-with-text-slider-wrapper').find('.jsc-slider-page-dot');
  var $pageDotsProgress = $($pageDots).find('.jsc-page-dot-progress');
  var $currentDot = $pageDots.filter('[data-index="' + dotIndex + '"]');
  var $currentProgress = $($currentDot).find('.jsc-page-dot-progress');

  $pageDotsProgress.css('width', '0');
  $pageNumber.text(dotIndex + 1);
  if($(window).width() > 1024) { // desktop view
    if(isDesktopAuto === "true") { // desktop view auto play
      increasePageDotProgress($currentProgress, duration, $slider);
    }
    else { // desktop view without auto play
      $currentProgress.css('width', '100%');
    }
  }
  else { // mobile view
    if(isMobileAuto === "true") { // mobile view auto play
      increasePageDotProgress($currentProgress, duration, $slider);
    }
    else { // mobile view without auto play
      $currentProgress.css('width', '100%');
    }
  }
}

onloadUpdateSliderNav = () => {
  var $slider = $('.jsc-image-with-text-slider-wrapper .jsc-image-with-text-slider');
  if (!$slider.length) return;
  var flkty = $($slider).data('flickity');
  if (!flkty) return;
  var startIndex = flkty.selectedIndex;
  updateSliderNavProgress(startIndex);
}

onchangeUpdateSliderNav = () => {
  var $slider = $('.jsc-image-with-text-slider-wrapper .jsc-image-with-text-slider');
  $slider.on('change.flickity', function(event,index) {
    clearInterval(intervalID);
    updateSliderNavProgress(index);
  });
}

goToPrevSlide = () => {
  var $slider = $('.jsc-image-with-text-slider-wrapper .jsc-image-with-text-slider');
  $slider.flickity('previous');
}

goToNextSlide = () => {
  var $slider = $('.jsc-image-with-text-slider-wrapper .jsc-image-with-text-slider');
  $slider.flickity('next');
}
// end: Image with text slider

// Boot personalisation edit-from-cart restore (notebook + leather).
initNotebookEditPersonalisationOnLoad = () => {
  if (!hasNotebookEditUrlFlag()) return;

  window.__cnbEditPrefillActive = true;
  showNotebookEditLoadingOverlay();

  var attempts = 0;
  var maxAttempts = 12;
  var editType = getPersonalisationEditTypeFromUrl() || (isLeatherEditPage() && !isNotebookEditPage() ? 'leather' : 'notebook');

  var finishOverlay = function() {
    if (editType !== 'leather') {
      showAllNotebookEditSteps();
    }
    hideNotebookEditLoadingOverlay();
  };

  var run = function() {
    attempts += 1;

    var pageReady = editType === 'leather'
      ? ($('#leather-text').length > 0 || $('#isPersonalisation').length > 0)
      : ($('.notebook-tab').length > 0 || $('#fianl_step').length > 0);

    if (!pageReady) {
      if (attempts < maxAttempts) {
        setTimeout(run, 200);
      } else {
        finishOverlay();
      }
      return;
    }

    resolveNotebookEditContext(function(ctx) {
      if (!ctx) {
        if (attempts < maxAttempts) {
          setTimeout(run, 250);
        } else {
          finishOverlay();
        }
        return;
      }

      var type = ctx.editType || editType || 'notebook';
      if (type === 'leather') {
        applyLeatherEditPrefill(ctx);
        setTimeout(function() {
          applyLeatherEditPrefill(ctx);
          markNotebookEditModeUi(ctx);
          hideNotebookEditLoadingOverlay();
        }, 450);
      } else {
        applyNotebookEditPrefill(ctx);
        setTimeout(function() {
          applyNotebookEditPrefill(ctx);
          showAllNotebookEditSteps();
          markNotebookEditModeUi(ctx);
          hideNotebookEditLoadingOverlay();
        }, 500);
      }
    });
  };

  setTimeout(run, 100);
};

$(function() {
  // Show overlay immediately on edit landings (before restore finishes)
  if (/[?&]edit_personalisation=1(?:&|$)/.test(String(window.location.search))) {
    if (typeof showNotebookEditLoadingOverlay === 'function') {
      showNotebookEditLoadingOverlay();
    }
  }
  initNotebookEditPersonalisationOnLoad();
});